<template>
    <div :style="cssProps">

        <div v-if="$session.get('doors_last_sync') == null" style="height: 2000px;">
            <div v-if="navigatorOnline">
                <h1 class="text-center" style="padding-top: 15%">
                <span v-if="isSyncing">
                    <span class="fa fa-spin fa-circle-notch"></span> Please wait, contacting the server...
                </span>
                    <span v-else>
                    Hello...<br>
                    <span class="a-primary c-pointer" @click="initialSetUp">
                        Click here to get started.
                    </span>
                </span>
                </h1>
                <div style="bottom: 0; position: fixed; width: 100%">
                    <p style="text-align: center; ">Please note this app does not work in private browsing mode. | version {{ this.appVersionNumber }}</p>
                </div>
            </div>
            <div v-else>
                <h1>You need to be online to set up the app. Once the app has been set up and you have logged in, the app can be used offline.</h1>
            </div>
        </div>

        <div v-else>

            <div v-if="!isLoggedIn">

                <div class="container-fluid h-100 overflow-y">
                    <div class="row flex-row h-100">
                        <div class="col-12 my-auto">
                            <div class="password-form mx-auto">
                                <div class="logo-centered">
                                    <img v-bind:src="'/img/' + workspace.workspace_logo" v-bind:alt="workspace.workspace_name" class="logo-big">
                                </div>
                                <div v-if="navigatorOnline">
                                    <h3>Sign in</h3>
                                    <form class="form-horizontal" @submit.prevent="login">
                                        <div class="form-body">
                                            <div v-if="loginFailed" class="alert alert-danger mb-5">
                                                Your email address or password was incorrect. Please check your details and try again.
                                            </div>
                                            <div v-if="loginErrorOccurred" class="alert alert-danger mb-5">
                                                There was an issue contacting the server. Please try again or contact an administrator.
                                            </div>
                                            <div style="display:none;">
                                                <div class="col-lg-6 col-md-12"><input type="hidden" name="_method"
                                                                                       value="POST"/></div>
                                            </div>
                                            <div class="group material-input">
                                                <input
                                                        type="text"
                                                        required="required"
                                                        name="email_address"
                                                        id="email_address"
                                                        v-model="user_email_address"
                                                >
                                                <span class="highlight"></span>
                                                <span class="bar"></span>
                                                <label for="email_address">Email</label>
                                            </div>
                                            <div class="group material-input">
                                                <input
                                                        type="password"
                                                        required="required"
                                                        name="user_password"
                                                        id="user_password"
                                                        v-model="user_user_password"
                                                >
                                                <span class="highlight"></span>
                                                <span class="bar"></span>
                                                <label for="user_password">Password</label>
                                            </div>


                                            <div class="sign-btn text-center">
                                                <button type="submit" class="btn btn-primary btn-square btn-lg w-100" :disabled="submitting">
                                                    <span v-if="submitting">Please wait... <i class="fa fa-circle-notch fa-spin"></i></span>
                                                    <span v-else>Sign in</span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div v-else>
                                    <h3>You are currently offline, so you can not log in.<br><br>Please reconnect to the internet, then log in.<br><br>Once you are logged in, this app can be used offline.</h3>
                                </div>
                                <div class="back">
                                    <!--<a href="/users/forgot-password">Forgot Password?</a>-->
                                    <a @click="clearDatabase">Clear local storage</a> <i class="far fa-question-circle" @click="toggleClearDbInfo"></i>
                                    <div class="clear-db-info" v-bind:class="{ expanded: isClearDbInfoExpanded }">
                                        <p>This feature allows to remove all data from local storage. It's recommended to use it if this device was already used by another user in order to prevent creating report duplicates. You might want to use it to get rid of old data as well. <strong>Note: Any data not synced to the server will be lost.</strong></p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <div v-else-if="!this.hasDoneFullSync" style="height: 200px;">
                <div v-if="navigatorOnline">
                    <div class="logo-centered" style="padding-top: 15%">
                        <img v-bind:src="'/img/' + workspace.workspace_logo" v-bind:alt="workspace.workspace_name" class="">
                    </div>

                    <div v-if="isSyncing">
                        <h1 class="text-center">Please wait, contacting the server...  <span class="fa fa-spin fa-circle-notch"></span> </h1>

                        <div style="width: 400px; margin: 0 auto;">
                            <div v-if="initDb === false">
                                <p>Checking for local storage</p>
                            </div>
                            <div v-else>
                                <p class="c-positive">Local storage device has been found</p>

                                <div v-if="initApi === false">
                                    <p>Communicating with {{ this.cmsUrl }}</p>
                                </div>
                                <div v-else>
                                    <p class="c-positive">Successfully communicated with {{ this.cmsUrl }}</p>
                                </div>
                                <div v-if="initApiError !== null">
                                    <p>Problem communicating with {{ this.cmsUrl }}</p>
                                    <p>Stage: {{ initApiErrorStage }}</p>
                                    <pre>{{ initApiError }}</pre>
                                </div>

                            </div>
                            <div v-if="initDbError !== null">
                                <p>There was a problem with the local storage</p>
                                <pre>{{ initDbError }}</pre>
                            </div>

                        </div>

                        <div style="bottom: 0; position: fixed; width: 100%">
                            <p style="text-align: center; ">Please note this app does not work in private browsing mode. | version {{ this.appVersionNumber }}</p>
                        </div>
                    </div>
                    <div v-else>
                        <h1 class="text-center">
                            <span>
                                The app needs to sync with the server.<br>
                                <span class="a-primary c-pointer" @click="syncWithServer">
                                    Click here to get started.
                                </span>
                            </span>
                        </h1>

                        <div style="bottom: 0; position: fixed; width: 100%">
                            <p style="text-align: center; ">Please note this app does not work in private browsing mode. | version {{ this.appVersionNumber }}</p>
                        </div>
                    </div>

                </div>
                <div v-else>
                    <h1>You need to be online to set up the app. Once the app has been set up and you have logged in, the app can be used offline.</h1>
                </div>
            </div>

            <div v-else>

                <div class="page" id="app">
                    <app-header :workspace="workspace" ref="appHeader"></app-header>

                    {{ getMenuState }}

                    <div class="page-content d-flex align-items-stretch">

                        <div class="compact-sidebar">

                            <nav class="side-navbar box-scroll sidebar-scroll" v-bind:class="isMenuActive ? '': 'shrinked'">

                                <ul class="list-unstyled">
                                    <li><router-link to="/">Dashboard</router-link></li>
                                    <li v-if="workspace.has_access_to_fire_door_audit && isModuleEnabled('FDR')">
                                        <router-link to="/">Door Inspections</router-link>
                                    </li>
                                    <li v-if="workspace.has_access_to_risk_audit && isModuleEnabled('FRA')">
                                        <router-link to="/risk-audits">Risk Audits</router-link>
                                    </li>
                                    <li v-if="workspace.has_access_to_extinguisher_report && isModuleEnabled('FER')">
                                        <router-link to="/extinguisher-reports">Extinguisher Reports</router-link>
                                    </li>
                                    <li v-if="workspace.has_access_to_fire_stopping_report && isModuleEnabled('FSR')">
                                        <router-link to="/fire-stopping-reports">Fire Stopping Reports</router-link>
                                    </li>
                                    <li v-if="workspace.has_access_to_bae_system_report && isModuleEnabled('BSR')">
                                        <router-link to="/bae-systems-reports">BAE Systems Reports</router-link>
                                    </li>
                                    <li v-if="workspace.has_access_to_door_installation_report && isModuleEnabled('FDIR')">
                                        <router-link to="/door-installation-reports">Door Installation Reports</router-link>
                                    </li>
                                    <li v-if="workspace.has_access_to_door_maintenance_report && isModuleEnabled('FDMR')">
                                        <router-link to="/door-maintenance-reports">Door Maintenance Reports</router-link>
                                    </li>
                                    <li><span class="c-pointer" @click="logout">Log out</span></li>
                                </ul>

                            </nav>

                        </div>

                        <div class="content-inner compact" v-bind:class="isMenuActive ? '': 'active'">
                            <div class="container-fluid">
                                <div class="row pt-0 mt-0 mb-0 pb-0">
                                    <div class="col-lg-4 offset-lg-2 col-md-6">
                                        <div class="widget mb-3">
                                            <div class="widget-header" @click="syncsOpen = !syncsOpen">
                                                <h5 class="a-primary c-pointer"><strong>
                                                    <span v-bind:class="'fa mr-2 ' + (syncsOpen ? 'fa-chevron-up' : 'fa-chevron-down')"></span>
                                                    Sync Actions</strong>
                                                </h5>
                                            </div>
                                            <div class="widget-body" v-if="syncsOpen">
                                                <table class="table table-condensed">
                                                    <tbody>
                                                        <tr v-if="workspace.has_access_to_fire_door_audit && isModuleEnabled('FDR')">
                                                            <td>
                                                                <small><strong>
                                                            <span v-if="navigatorOnline && !doorReportsSyncStarted">
                                                                <span class="a-primary c-pointer" @click="syncDoorApps">
                                                                    Sync Fire Doors
                                                                </span>
                                                            </span>
                                                            <span v-else-if="navigatorOnline && doorReportsSyncStarted" class="c-negative">
                                                            Syncing Fire Doors
                                                            </span>
                                                            <span v-else class="c-negative">
                                                            Fire Doors
                                                            </span>
                                                                </strong></small>
                                                            </td>
                                                            <td>
                                                                <small>
                                                                    <span v-if="$session.get('doors_last_sync') == null">
                                                                        Last sync unknown or never done. Refresh the app or sync.
                                                                    </span>
                                                                    <span v-else>
                                                                        Last synced {{ $session.get('doors_last_sync') | formatDateTime }}.
                                                                    </span>
                                                                </small>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="workspace.has_access_to_risk_audit && isModuleEnabled('FRA')">
                                                            <td>
                                                                <small><strong>
                                                            <span v-if="navigatorOnline && !riskAuditsSyncStarted">
                                                                <span class="a-primary c-pointer" @click="syncRiskAudits">
                                                                    Sync Risk Audits
                                                                </span>
                                                            </span>
                                                            <span v-else-if="navigatorOnline && riskAuditsSyncStarted" class="c-negative">
                                                            Syncing Risk Audits
                                                            </span>
                                                            <span v-else class="c-negative">
                                                            Risk Audits
                                                            </span>
                                                                </strong></small>
                                                            </td>
                                                            <td>
                                                                <small>
                                                                    <span v-if="$session.get('risk_audits_last_sync') == null">
                                                                        Last sync unknown or never done. Refresh the app or sync.
                                                                    </span>
                                                                    <span v-else>
                                                                        Last synced {{ $session.get('risk_audits_last_sync') | formatDateTime }}.
                                                                    </span>
                                                                </small>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="workspace.has_access_to_extinguisher_report && isModuleEnabled('FER')">
                                                            <td>
                                                                <small><strong>
                                                            <span v-if="navigatorOnline && !extinguisherReportsSyncStarted">
                                                                <span class="a-primary c-pointer" @click="syncExtinguisherReports">
                                                                    Sync Extinguisher Reports
                                                                </span>
                                                            </span>
                                                            <span v-else-if="navigatorOnline && extinguisherReportsSyncStarted" class="c-negative">
                                                            Syncing Extinguisher Reports
                                                            </span>
                                                            <span v-else class="c-negative">
                                                            Extinguisher Reports
                                                            </span>
                                                                </strong></small>
                                                            </td>
                                                            <td>
                                                                <small>
                                                                    <span v-if="$session.get('extinguisher_reports_last_sync') == null">
                                                                        Last sync unknown or never done. Refresh the app or sync.
                                                                    </span>
                                                                    <span v-else>
                                                                        Last synced {{ $session.get('extinguisher_reports_last_sync') | formatDateTime }}.
                                                                    </span>
                                                                </small>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="workspace.has_access_to_fire_stopping_report && isModuleEnabled('FSR')">
                                                            <td>
                                                                <small><strong>
                                                            <span v-if="navigatorOnline && !fireStoppingReportsSyncStarted">
                                                                <span class="a-primary c-pointer" @click="syncFireStoppingReports">
                                                                    Sync Fire Stopping Reports
                                                                </span>
                                                            </span>
                                                            <span v-else-if="navigatorOnline && fireStoppingReportsSyncStarted" class="c-negative">
                                                            Syncing Fire Stopping Reports
                                                            </span>
                                                            <span v-else class="c-negative">
                                                            Fire Stopping Reports
                                                            </span>
                                                                </strong></small>
                                                            </td>
                                                            <td>
                                                                <small>
                                                                    <span v-if="$session.get('fire_stopping_reports_last_sync') == null">
                                                                        Last sync unknown or never done. Refresh the app or sync.
                                                                    </span>
                                                                    <span v-else>
                                                                        Last synced {{ $session.get('fire_stopping_reports_last_sync') | formatDateTime }}.
                                                                    </span>
                                                                </small>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="workspace.has_access_to_bae_system_report && isModuleEnabled('BSR')">
                                                            <td>
                                                                <small><strong>
                                                            <span v-if="navigatorOnline && !baeSystemsReportsSyncStarted">
                                                                <span class="a-primary c-pointer" @click="syncBaeSystemsReports">
                                                                    Sync BAE Systems Reports
                                                                </span>
                                                            </span>
                                                            <span v-else-if="navigatorOnline && baeSystemsReportsSyncStarted" class="c-negative">
                                                            Syncing BAE Systems Reports
                                                            </span>
                                                            <span v-else class="c-negative">
                                                            BAE Systems Reports
                                                            </span>
                                                                </strong></small>
                                                            </td>
                                                            <td>
                                                                <small>
                                                                    <span v-if="$session.get('bae_systems_reports_last_sync') == null">
                                                                        Last sync unknown or never done. Refresh the app or sync.
                                                                    </span>
                                                                    <span v-else>
                                                                        Last synced {{ $session.get('bae_systems_reports_last_sync') | formatDateTime }}.
                                                                    </span>
                                                                </small>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="workspace.has_access_to_door_installation_report && isModuleEnabled('FDIR')">
                                                            <td>
                                                                <small><strong>
                                                                    <span v-if="navigatorOnline && !fdirSyncStarted">
                                                                        <span class="a-primary c-pointer" @click="syncFdiReports">
                                                                            Sync Door Installation Reports
                                                                        </span>
                                                                    </span>
                                                                    <span v-else-if="navigatorOnline && fdirSyncStarted" class="c-negative">
                                                                    Syncing Door Installation Reports
                                                                    </span>
                                                                    <span v-else class="c-negative">
                                                                    Door Installation Reports
                                                                    </span>
                                                                </strong></small>
                                                            </td>
                                                            <td>
                                                                <small>
                                                                    <span v-if="$session.get('fdir_last_sync') == null">
                                                                        Last sync unknown or never done. Refresh the app or sync.
                                                                    </span>
                                                                    <span v-else>
                                                                        Last synced {{ $session.get('fdir_last_sync') | formatDateTime }}.
                                                                    </span>
                                                                </small>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="workspace.has_access_to_door_maintenance_report && isModuleEnabled('FDMR')">
                                                            <td>
                                                                <small><strong>
                                                            <span v-if="navigatorOnline && !fdmrSyncStarted">
                                                                <span class="a-primary c-pointer" @click="syncFdmReports">
                                                                    Sync Door Maintenance Reports
                                                                </span>
                                                            </span>
                                                            <span v-else-if="navigatorOnline && fdmrSyncStarted" class="c-negative">
                                                            Syncing Door Maintenance Reports
                                                            </span>
                                                            <span v-else class="c-negative">
                                                            Door Maintenance Reports
                                                            </span>
                                                                </strong></small>
                                                            </td>
                                                            <td>
                                                                <small>
                                                                    <span v-if="$session.get('fdmr_last_sync') == null">
                                                                        Last sync unknown or never done. Refresh the app or sync.
                                                                    </span>
                                                                    <span v-else>
                                                                        Last synced {{ $session.get('fdmr_last_sync') | formatDateTime }}.
                                                                    </span>
                                                                </small>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-lg-4 col-md-6">
                                        <div class="widget mb-3">
                                            <div class="widget-header">
                                                <div v-if="!riskAuditsSyncStarted && !doorReportsSyncStarted && !extinguisherReportsSyncStarted && !fireStoppingReportsSyncStarted && !baeSystemsReportsSyncStarted">
                                                    <h5 class="a-primary c-pointer" @click="reloadPage">
                                                        <strong>
                                                            <span class="fas fa-sync mr-2"></span>
                                                            Reload App <small class="ml-5 pl-5">v{{ appVersionNumber }}</small>
                                                        </strong>
                                                    </h5>
                                                </div>
                                                <div v-else>
                                                    <h5 class="c-negative">
                                                        <strong>
                                                            <span class="fas fa-sync mr-2"></span>
                                                            Syncing data..
                                                        </strong>
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-8 offset-lg-2 col-md-12">

                                        <div v-if="navigatorOnline">
                                        </div>
                                        <div v-else class="alert alert-info">
                                            <img class="img-fluid" src="/img/offline.png"
                                                 style="width: 20px; margin-right: 10px;">
                                            You are currently offline. Some functionality is limited. Your reports will
                                            be synced
                                            when an online connection is detected.
                                        </div>

                                        {{ initApiError }}
                                        <div v-if="isSyncingInBg === true && bgAlert === true">
                                            <div class="alert alert-danger" v-if="initApiError !== null">
                                                There was an API error at this stage: {{ initApiErrorStage }}
                                                The error is:
                                                <pre>{{ initApiError }}</pre>
                                            </div>
                                            <div class="alert alert-info" v-else>
                                                <div v-if="isSyncComplete === false">
                                                    <strong>Note:</strong> An automatic sync for fire doors only is taking place. This should only take a second...<br>
                                                    Progress {{ syncProgress }}%
                                                </div>
                                                <div v-else>
                                                    Automatic sync has been completed.
                                                    <span class="fa fa-times c-pointer close-cross" v-on:click="hideAlert"></span>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="doorReportsSyncErrors.length > 0 && showDoorReportsSyncErrors">
                                            <div class="alert alert-danger">
                                                <span class="fa fa-times c-pointer close-cross" v-on:click="hideDoorReportsSyncErrors"></span>
                                                <p>Saving some door reports / doors failed, see details below:</p>
                                                <ul>
                                                    <li v-for="(msg, index) in doorReportsSyncErrors" :key="`dc-sync-error-${index}`">{{ msg }}</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div v-if="doorReportsConflicts.length > 0" class="widget has-shadow">
                                            <div class="widget-header bordered d-flex align-items-center section-header">
                                                <h2>Door Reports Sync Conflicts</h2>
                                            </div>
                                            <div class="widget-body">
                                                <p class="mb-5">
                                                    We've detected version conflicts between local and remote (stored in the database) versions for at least one report. Please decide whether you want to overwrite remote version, save local version as new report or reject local version. <br>
                                                    <strong>NOTE: </strong> Overwriting applies to reports marked in the database as complete as well. It means you can lose some data.
                                                </p>
                                                <div class="form-group row d-flex align-items-center" v-for="doorReportIndex in doorReportsConflicts" :key="`door-report-conflict-${doorReportIndex}`">
                                                    <label class="col-lg-8 form-control-label d-flex">Report #{{ offlineDoorChecks[doorReportIndex].site_door_check_id }} (ID: {{ offlineDoorChecks[doorReportIndex].document_id }}), local: {{ offlineDoorChecks[doorReportIndex].report_version != null ? offlineDoorChecks[doorReportIndex].report_version : 'no version' }}, remote: {{ offlineDoorChecks[doorReportIndex].remote_report_version }}</label>
                                                    <div class="col-lg-4">
                                                        <select class="form-control" v-model="offlineDoorChecks[doorReportIndex].update_flag" :disabled="submittedDoorReportsConflictForm">
                                                            <option value="OVERWRITE">Overwrite</option>
                                                            <option value="SAVE_AS_NEW">Save as new</option>
                                                            <option value="REJECT">Reject local version</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row mt-5">
                                                    <div class="col-sm-12">
                                                        <div class="form-group">
                                                            <a href="#" @click="continueDoorReportsSyncProcess" class="btn btn-primary btn-square btn-lg w-100" :disabled="submittedDoorReportsConflictForm">
                                                                <span v-if="submittedDoorReportsConflictForm">Syncing... <i class="fa fa-circle-notch fa-spin"></i></span>
                                                                <span v-else>Confirm</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="riskAuditsSyncErrors.length > 0 && showRiskAuditsSyncErrors">
                                            <div class="alert alert-danger">
                                                <span class="fa fa-times c-pointer close-cross" v-on:click="hideRiskAuditSyncErrors"></span>
                                                <p>Saving some risk audit reports failed, see details below:</p>
                                                <ul>
                                                    <li v-for="(msg, index) in riskAuditsSyncErrors" :key="`ra-sync-error-${index}`">{{ msg }}</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div v-if="riskAuditConflicts.length > 0" class="widget has-shadow">
                                            <div class="widget-header bordered d-flex align-items-center section-header">
                                                <h2>Risk Audits Sync Conflicts</h2>
                                            </div>
                                            <div class="widget-body">
                                                <p class="mb-5">
                                                    We've detected version conflicts between local and remote (stored in the database) versions for at least one report. Please decide whether you want to overwrite remote version, save local version as new report or reject local version. <br>
                                                    <strong>NOTE: </strong> Overwriting applies to reports marked in the database as complete as well. It means you can lose some data.
                                                </p>
                                                <div class="form-group row d-flex align-items-center" v-for="riskAuditIndex in riskAuditConflicts" :key="`risk-audit-conflict-${riskAuditIndex}`">
                                                    <label class="col-lg-8 form-control-label d-flex">Report #{{ offlineRiskAudits[riskAuditIndex].site_risk_audit_id }} (ref: {{ offlineRiskAudits[riskAuditIndex].ra_cover.reference_number }}), local: {{ offlineRiskAudits[riskAuditIndex].report_version != null ? offlineRiskAudits[riskAuditIndex].report_version : 'no version' }}, remote: {{ offlineRiskAudits[riskAuditIndex].remote_report_version }}</label>
                                                    <div class="col-lg-4">
                                                        <select class="form-control" v-model="offlineRiskAudits[riskAuditIndex].update_flag" :disabled="submittedRiskAuditConflictForm">
                                                            <option value="OVERWRITE">Overwrite</option>
                                                            <option value="SAVE_AS_NEW">Save as new</option>
                                                            <option value="REJECT">Reject local version</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row mt-5">
                                                    <div class="col-sm-12">
                                                        <div class="form-group">
                                                            <a href="#" @click="continueRiskAuditsSyncProcess" class="btn btn-primary btn-square btn-lg w-100" :disabled="submittedRiskAuditConflictForm">
                                                                <span v-if="submittedRiskAuditConflictForm">Syncing... <i class="fa fa-circle-notch fa-spin"></i></span>
                                                                <span v-else>Confirm</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="extinguisherReportsErrors.length > 0 && showExtinguisherReportsSyncErrors">
                                            <div class="alert alert-danger">
                                                <span class="fa fa-times c-pointer close-cross" v-on:click="hideExtinguisherReportsSyncErrors"></span>
                                                <p>Saving some extinguisher reports / extinguishers failed, see details below:</p>
                                                <ul>
                                                    <li v-for="(msg, index) in extinguisherReportsErrors" :key="`er-sync-error-${index}`">{{ msg }}</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div v-if="extinguisherReportsConflicts.length > 0" class="widget has-shadow">
                                            <div class="widget-header bordered d-flex align-items-center section-header">
                                                <h2>Extinguisher Reports Sync Conflicts</h2>
                                            </div>
                                            <div class="widget-body">
                                                <p class="mb-5">
                                                    We've detected version conflicts between local and remote (stored in the database) versions for at least one report. Please decide whether you want to overwrite remote version, save local version as new report or reject local version. <br>
                                                    <strong>NOTE: </strong> Overwriting applies to reports marked in the database as complete as well. It means you can lose some data.
                                                </p>
                                                <div class="form-group row d-flex align-items-center" v-for="extinguisherReportIndex in extinguisherReportsConflicts" :key="`extinguisher-report-conflict-${extinguisherReportIndex}`">
                                                    <label class="col-lg-8 form-control-label d-flex">Report #{{ offlineExtinguisherReports[extinguisherReportIndex].site_extinguisher_report_id }} (ID: {{ offlineExtinguisherReports[extinguisherReportIndex].job_number }}), local: {{ offlineExtinguisherReports[extinguisherReportIndex].report_version != null ? offlineExtinguisherReports[extinguisherReportIndex].report_version : 'no version' }}, remote: {{ offlineExtinguisherReports[extinguisherReportIndex].remote_report_version }}</label>
                                                    <div class="col-lg-4">
                                                        <select class="form-control" v-model="offlineExtinguisherReports[extinguisherReportIndex].update_flag" :disabled="submittedExtinguisherReportsConflictForm">
                                                            <option value="OVERWRITE">Overwrite</option>
                                                            <option value="SAVE_AS_NEW">Save as new</option>
                                                            <option value="REJECT">Reject local version</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row mt-5">
                                                    <div class="col-sm-12">
                                                        <div class="form-group">
                                                            <a href="#" @click="continueExtinguisherReportsSyncProcess" class="btn btn-primary btn-square btn-lg w-100" :disabled="submittedExtinguisherReportsConflictForm">
                                                                <span v-if="submittedExtinguisherReportsConflictForm">Syncing... <i class="fa fa-circle-notch fa-spin"></i></span>
                                                                <span v-else>Confirm</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="fireStoppingReportsErrors.length > 0 && showFireStoppingReportsSyncErrors">
                                            <div class="alert alert-danger">
                                                <span class="fa fa-times c-pointer close-cross" v-on:click="hideFireStoppingReportsSyncErrors"></span>
                                                <p>Saving some fire stopping reports / items failed, see details below:</p>
                                                <ul>
                                                    <li v-for="(msg, index) in fireStoppingReportsErrors" :key="`fsr-sync-error-${index}`">{{ msg }}</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div v-if="fireStoppingReportsConflicts.length > 0" class="widget has-shadow">
                                            <div class="widget-header bordered d-flex align-items-center section-header">
                                                <h2>Fire Stopping Reports Sync Conflicts</h2>
                                            </div>
                                            <div class="widget-body">
                                                <p class="mb-5">
                                                    We've detected version conflicts between local and remote (stored in the database) versions for at least one report. Please decide whether you want to overwrite remote version, save local version as new report or reject local version. <br>
                                                    <strong>NOTE: </strong> Overwriting applies to reports marked in the database as complete as well. It means you can lose some data.
                                                </p>
                                                <div class="form-group row d-flex align-items-center" v-for="fireStoppingReportIndex in fireStoppingReportsConflicts" :key="`fire-stopping-report-conflict-${fireStoppingReportIndex}`">
                                                    <label class="col-lg-8 form-control-label d-flex">Report #{{ offlineFireStoppingReports[fireStoppingReportIndex].site_fire_stopping_report_id }} (ID: {{ offlineFireStoppingReports[fireStoppingReportIndex].job_number }}), local: {{ offlineFireStoppingReports[fireStoppingReportIndex].report_version != null ? offlineFireStoppingReports[fireStoppingReportIndex].report_version : 'no version' }}, remote: {{ offlineFireStoppingReports[fireStoppingReportIndex].remote_report_version }}</label>
                                                    <div class="col-lg-4">
                                                        <select class="form-control" v-model="offlineFireStoppingReports[fireStoppingReportIndex].update_flag" :disabled="submittedFireStoppingReportsConflictForm">
                                                            <option value="OVERWRITE">Overwrite</option>
                                                            <option value="SAVE_AS_NEW">Save as new</option>
                                                            <option value="REJECT">Reject local version</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row mt-5">
                                                    <div class="col-sm-12">
                                                        <div class="form-group">
                                                            <a href="#" @click="continueFireStoppingReportsSyncProcess" class="btn btn-primary btn-square btn-lg w-100" :disabled="submittedFireStoppingReportsConflictForm">
                                                                <span v-if="submittedFireStoppingReportsConflictForm">Syncing... <i class="fa fa-circle-notch fa-spin"></i></span>
                                                                <span v-else>Confirm</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="baeSystemsReportsErrors.length > 0 && showBaeSystemsReportsSyncErrors">
                                            <div class="alert alert-danger">
                                                <span class="fa fa-times c-pointer close-cross" v-on:click="showBaeSystemsReportsSyncErrors = false"></span>
                                                <p>Saving some BAE Systems reports failed, see details below:</p>
                                                <ul>
                                                    <li v-for="(msg, index) in baeSystemsReportsErrors" :key="`bsr-sync-error-${index}`">{{ msg }}</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div v-if="baeSystemsReportsConflicts.length > 0" class="widget has-shadow">
                                            <div class="widget-header bordered d-flex align-items-center section-header">
                                                <h2>BAE Systems Reports Sync Conflicts</h2>
                                            </div>
                                            <div class="widget-body">
                                                <p class="mb-5">
                                                    We've detected version conflicts between local and remote (stored in the database) versions for at least one report. Please decide whether you want to overwrite remote version, save local version as new report or reject local version. <br>
                                                    <strong>NOTE: </strong> Overwriting applies to reports marked in the database as complete as well. It means you can lose some data.
                                                </p>
                                                <div class="form-group row d-flex align-items-center" v-for="baeSystemsReportIndex in baeSystemsReportsConflicts" :key="`bae-systems-report-conflict-${baeSystemsReportIndex}`">
                                                    <label class="col-lg-8 form-control-label d-flex">Report #{{ offlineBaeSystemsReports[baeSystemsReportIndex].site_bae_systems_report_id }} (ID: {{ offlineBaeSystemsReports[baeSystemsReportIndex].door_identifier }}), local: {{ offlineBaeSystemsReports[baeSystemsReportIndex].report_version != null ? offlineBaeSystemsReports[baeSystemsReportIndex].report_version : 'no version' }}, remote: {{ offlineBaeSystemsReports[baeSystemsReportIndex].remote_report_version }}</label>
                                                    <div class="col-lg-4">
                                                        <select class="form-control" v-model="offlineBaeSystemsReports[baeSystemsReportIndex].update_flag" :disabled="submittedBaeSystemsReportsConflictForm">
                                                            <option value="OVERWRITE">Overwrite</option>
                                                            <option value="SAVE_AS_NEW">Save as new</option>
                                                            <option value="REJECT">Reject local version</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row mt-5">
                                                    <div class="col-sm-12">
                                                        <div class="form-group">
                                                            <a href="#" @click="continueBaeSystemsReportsSyncProcess" class="btn btn-primary btn-square btn-lg w-100" :disabled="submittedBaeSystemsReportsConflictForm">
                                                                <span v-if="submittedBaeSystemsReportsConflictForm">Syncing... <i class="fa fa-circle-notch fa-spin"></i></span>
                                                                <span v-else>Confirm</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="fdirSyncErrors.length > 0 && showFdirSyncErrors">
                                            <div class="alert alert-danger">
                                                <span class="fa fa-times c-pointer close-cross" v-on:click="showFdirSyncErrors = false"></span>
                                                <p>Saving some Door Installation reports failed, see details below:</p>
                                                <ul>
                                                    <li v-for="(msg, index) in fdirSyncErrors" :key="`fdir-sync-error-${index}`">{{ msg }}</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div v-if="fdirConflicts.length > 0" class="widget has-shadow">
                                            <div class="widget-header bordered d-flex align-items-center section-header">
                                                <h2>Door Installation Reports Sync Conflicts</h2>
                                            </div>
                                            <div class="widget-body">
                                                <p class="mb-5">
                                                    We've detected version conflicts between local and remote (stored in the database) versions for at least one report. Please decide whether you want to overwrite remote version, save local version as new report or reject local version. <br>
                                                    <strong>NOTE: </strong> Overwriting applies to reports marked in the database as complete as well. It means you can lose some data.
                                                </p>
                                                <div class="form-group row d-flex align-items-center" v-for="fdiReportIndex in fdirConflicts" :key="`fdi-report-conflict-${fdiReportIndex}`">
                                                    <label class="col-lg-8 form-control-label d-flex">Report #{{ offlineFdiReports[fdiReportIndex].site_door_installation_report_id }} (ID: {{ offlineFdiReports[fdiReportIndex].door_identifier }}), local: {{ offlineFdiReports[fdiReportIndex].report_version != null ? offlineFdiReports[fdiReportIndex].report_version : 'no version' }}, remote: {{ offlineFdiReports[fdiReportIndex].remote_report_version }}</label>
                                                    <div class="col-lg-4">
                                                        <select class="form-control" v-model="offlineFdiReports[fdiReportIndex].update_flag" :disabled="submittedFdirConflictForm">
                                                            <option value="OVERWRITE">Overwrite</option>
                                                            <option value="SAVE_AS_NEW">Save as new</option>
                                                            <option value="REJECT">Reject local version</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row mt-5">
                                                    <div class="col-sm-12">
                                                        <div class="form-group">
                                                            <a href="#" @click="continueFdiReportsSyncProcess" class="btn btn-primary btn-square btn-lg w-100" :disabled="submittedFdirConflictForm">
                                                                <span v-if="submittedFdirConflictForm">Syncing... <i class="fa fa-circle-notch fa-spin"></i></span>
                                                                <span v-else>Confirm</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="fdmrSyncErrors.length > 0 && showFdirSyncErrors">
                                            <div class="alert alert-danger">
                                                <span class="fa fa-times c-pointer close-cross" v-on:click="showFdirSyncErrors = false"></span>
                                                <p>Saving some Door Maintenance reports failed, see details below:</p>
                                                <ul>
                                                    <li v-for="(msg, index) in fdmrSyncErrors" :key="`fdmr-sync-error-${index}`">{{ msg }}</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div v-if="fdmrConflicts.length > 0" class="widget has-shadow">
                                            <div class="widget-header bordered d-flex align-items-center section-header">
                                                <h2>Door Maintenance Reports Sync Conflicts</h2>
                                            </div>
                                            <div class="widget-body">
                                                <p class="mb-5">
                                                    We've detected version conflicts between local and remote (stored in the database) versions for at least one report. Please decide whether you want to overwrite remote version, save local version as new report or reject local version. <br>
                                                    <strong>NOTE: </strong> Overwriting applies to reports marked in the database as complete as well. It means you can lose some data.
                                                </p>
                                                <div class="form-group row d-flex align-items-center" v-for="fdmReportIndex in fdmrConflicts" :key="`fdi-report-conflict-${fdmReportIndex}`">
                                                    <label class="col-lg-8 form-control-label d-flex">Report #{{ offlineFdmReports[fdmReportIndex].site_door_maintenance_report_id }} (ID: {{ offlineFdmReports[fdmReportIndex].door_identifier }}), local: {{ offlineFdmReports[fdmReportIndex].report_version != null ? offlineFdmReports[fdmReportIndex].report_version : 'no version' }}, remote: {{ offlineFdmReports[fdmReportIndex].remote_report_version }}</label>
                                                    <div class="col-lg-4">
                                                        <select class="form-control" v-model="offlineFdmReports[fdmReportIndex].update_flag" :disabled="submittedFdirConflictForm">
                                                            <option value="OVERWRITE">Overwrite</option>
                                                            <option value="SAVE_AS_NEW">Save as new</option>
                                                            <option value="REJECT">Reject local version</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row mt-5">
                                                    <div class="col-sm-12">
                                                        <div class="form-group">
                                                            <a href="#" @click="continueFdmReportsSyncProcess" class="btn btn-primary btn-square btn-lg w-100" :disabled="submittedFdirConflictForm">
                                                                <span v-if="submittedFdirConflictForm">Syncing... <i class="fa fa-circle-notch fa-spin"></i></span>
                                                                <span v-else>Confirm</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="isSyncing === true">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="widget has-shadow">
                                                        <div class="widget-header bordered d-flex align-items-center section-header">
                                                            <h2>Syncing...</h2>
                                                        </div>
                                                        <div class="widget-body">
                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <div class="alert alert-info"
                                                                         v-if="isSyncComplete === false">
                                                                        Please do not reload or exit this page.
                                                                    </div>
                                                                    <div class="alert alert-danger"
                                                                         v-else-if="syncError === true">
                                                                        There was an error. Please try again or contact
                                                                        an administrator.
                                                                        <pre>{{ syncErrorDetails }}</pre>
                                                                    </div>
                                                                    <div class="alert alert-success" v-else>
                                                                        <strong>Success!</strong> The application has
                                                                        successfully synced with the server. Please wait
                                                                        a moment...
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <div class="progress progress-lg mb-3">
                                                                        <div class="progress-bar bg-primary"
                                                                             v-if="!syncError"
                                                                             role="progressbar"
                                                                             v-bind:style="'width: ' + syncProgress + '%'"
                                                                             v-bind:aria-valuenow="syncProgress"
                                                                             aria-valuemin="0"
                                                                             aria-valuemax="100"
                                                                        >
                                                                        </div>
                                                                        <div class="progress-bar bg-danger" v-else
                                                                             role="progressbar"
                                                                             v-bind:style="'width: ' + syncProgress + '%'"
                                                                             v-bind:aria-valuenow="syncProgress"
                                                                             aria-valuemin="0"
                                                                             aria-valuemax="100"
                                                                        >
                                                                            Error
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <div v-if="isWorkspaceDetailsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Workspace
                                                                            details received by server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-check"></span> Problem
                                                                            getting workspace details from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting workspace details from server...</p>
                                                                    </div>

                                                                    <div v-if="isDoorMaterialsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door
                                                                            materials received by server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting door materials from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting door materials from server...</p>
                                                                    </div>

                                                                    <div v-if="isFrameMaterialsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Frame
                                                                            materials received by server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting frame materials from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting frame materials from server...</p>
                                                                    </div>

                                                                    <div v-if="isLocationsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Locations
                                                                            received from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting locations from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting locations from server...</p>
                                                                    </div>

                                                                    <div v-if="iSubstrateTypesLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Substrate types
                                                                            received from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting substrate types from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting substrate types from server...</p>
                                                                    </div>

                                                                    <div v-if="isDoorSetsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door sets
                                                                            received by server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting door sets from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting door sets from server...</p>
                                                                    </div>

                                                                    <div v-if="isDoorTypesLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door types
                                                                            received by server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting door types from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting door types from server...</p>
                                                                    </div>

                                                                    <div v-if="isReportConfigLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Report
                                                                            configuration received from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting report configuration from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting report configuration from server...
                                                                        </p>
                                                                    </div>

                                                                    <div v-if="canAccessBMTradaOptions()">
                                                                        <div v-if="isAdditionalDoorFieldsOptionsLoaded">
                                                                            <p class="c-positive"><span
                                                                                    class="fa fa-check"></span> Additional fields options
                                                                                    received from server</p>
                                                                        </div>
                                                                        <div v-else-if="syncError">
                                                                            <p class="c-negative"><span
                                                                                    class="fa fa-times"></span> Problem
                                                                                getting additional fields options from server</p>
                                                                        </div>
                                                                        <div v-else>
                                                                            <p><span
                                                                                    class="fa fa-spin fa-circle-notch"></span>
                                                                                Getting additional fields options from server...
                                                                            </p>
                                                                        </div>
                                                                    </div>

                                                                    <div v-if="isDoorFaultsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door faults
                                                                            received by server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting door faults from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting door faults from server...</p>
                                                                    </div>

                                                                    <div v-if="isDoorChecksLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door checks
                                                                            received by server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting door checks from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting door checks from server...</p>
                                                                    </div>

                                                                    <div v-if="canAccessSitePlansForFD()">
                                                                        <div v-if="isDoorCheckSitePlansLoaded">
                                                                            <p class="c-positive"><span
                                                                                    class="fa fa-check"></span> Site plans
                                                                                received from server</p>
                                                                        </div>
                                                                        <div v-else-if="syncError">
                                                                            <p class="c-negative"><span
                                                                                    class="fa fa-times"></span> Problem
                                                                                getting site plans from server</p>
                                                                        </div>
                                                                        <div v-else>
                                                                            <p><span
                                                                                    class="fa fa-spin fa-circle-notch"></span>
                                                                                Getting site plans from server...</p>
                                                                        </div>
                                                                    </div>

                                                                    <div v-if="isDoorCheckDoorsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door check
                                                                            doors received by server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting door check doors from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting door check doors from server...</p>
                                                                    </div>

                                                                    <div v-if="isOfflineDoorChecksPosted">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Offline door
                                                                            checks saved to server.</p>
                                                                    </div>
                                                                    <div v-else-if="isOfflineDoorChecksZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No door
                                                                            checks to send to server.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            saving door checks to server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Saving offline door checks to server...</p>
                                                                    </div>

                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isWorkspaceDetailsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Workspace
                                                                            details synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing workspace details with application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing workspace details with
                                                                            application...</p>
                                                                    </div>

                                                                    <div v-if="isDoorMaterialsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door
                                                                            materials synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isDoorMaterialsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No door
                                                                            materials to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing door materials with application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing door materials with application...
                                                                        </p>
                                                                    </div>

                                                                    <div v-if="isFrameMaterialsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Frame
                                                                            materials synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isFrameMaterialsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No frame
                                                                            materials to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing frame materials with application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing frame materials with application...
                                                                        </p>
                                                                    </div>

                                                                    <div v-if="isLocationsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Locations
                                                                            synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isLocationsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No locations
                                                                            to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing locations with application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing locations with application...</p>
                                                                    </div>

                                                                    <div v-if="iSubstrateTypesAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Substrate types
                                                                            synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isSubstrateTypesZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No substrate types
                                                                            to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing substrate types with application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing substrate types with application...</p>
                                                                    </div>

                                                                    <div v-if="isDoorSetsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door sets
                                                                            synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isDoorSetsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No door sets
                                                                            to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing door sets with application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing door sets with application...</p>
                                                                    </div>

                                                                    <div v-if="isDoorTypesAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door types
                                                                            synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isDoorTypesZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No door
                                                                            types to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing door types with application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing door types with application...</p>
                                                                    </div>

                                                                    <div v-if="isReportConfigAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Report
                                                                            configuration synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing report configuration with
                                                                            application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing report configuration with
                                                                            application...</p>
                                                                    </div>

                                                                    <div v-if="canAccessBMTradaOptions()">
                                                                        <div v-if="isDeclaredResistanceLevelsAdded && isLevelOptionsAdded && isCpiScheduleItemsAdded">
                                                                            <p class="c-positive"><span
                                                                                    class="fa fa-check"></span> Additional fields options
                                                                                     synced with application</p>
                                                                        </div>
                                                                        <div v-else-if="syncError">
                                                                            <p class="c-negative"><span
                                                                                    class="fa fa-times"></span> Problem
                                                                                syncing additional fields options with
                                                                                application</p>
                                                                        </div>
                                                                        <div v-else>
                                                                            <p><span
                                                                                    class="fa fa-spin fa-circle-notch"></span>
                                                                                Syncing additional fields options with
                                                                                application...</p>
                                                                        </div>    
                                                                    </div>

                                                                    <div v-if="isDoorFaultsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door faults
                                                                            synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isDoorFaultsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No door
                                                                            faults to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing door faults with application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing door faults with application...</p>
                                                                    </div>

                                                                    <div v-if="isDoorChecksAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door checks
                                                                            synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isDoorChecksZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No door
                                                                            checks to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing door checks with application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing door checks with application...</p>
                                                                    </div>

                                                                    <div v-if="canAccessSitePlansForFD()">
                                                                        <div v-if="isDoorCheckSitePlansAdded">
                                                                            <p class="c-positive"><span
                                                                                    class="fa fa-check"></span> Site plans
                                                                                synced with application</p>
                                                                        </div>
                                                                        <div v-else-if="isDoorCheckSitePlansZeroLength">
                                                                            <p class="c-neutral"><span
                                                                                    class="fa fa-check"></span> No site plans to be added.</p>
                                                                        </div>
                                                                        <div v-else-if="syncError">
                                                                            <p class="c-negative"><span
                                                                                    class="fa fa-times"></span> Problem
                                                                                syncing site plans with application</p>
                                                                        </div>
                                                                        <div v-else>
                                                                            <p><span
                                                                                    class="fa fa-spin fa-circle-notch"></span>
                                                                                Syncing site plans with application...</p>
                                                                        </div>
                                                                        
                                                                        <div v-if="isOfflineDoorCheckSitePlansPosted">
                                                                            <p class="c-positive"><span
                                                                                    class="fa fa-check"></span> Offline site plans saved to server.</p>
                                                                        </div>
                                                                        <div v-else-if="isDoorCheckSitePlansZeroLength">
                                                                            <p class="c-neutral"><span
                                                                                    class="fa fa-check"></span> No offline
                                                                             site plans to send to server.</p>
                                                                        </div>
                                                                        <div v-else-if="syncError">
                                                                            <p class="c-negative"><span
                                                                                    class="fa fa-times"></span> Problem
                                                                                saving offline site plans to server
                                                                            </p>
                                                                        </div>
                                                                        <div v-else>
                                                                            <p><span
                                                                                    class="fa fa-spin fa-circle-notch"></span>
                                                                                Saving offline site plans to server...
                                                                            </p>
                                                                        </div>     
                                                                    </div>

                                                                    <div v-if="isDoorCheckDoorsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door check
                                                                            doors synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isDoorCheckDoorsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No doors to
                                                                            be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing door check doors with application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing door check doors with application...
                                                                        </p>
                                                                    </div>

                                                                    <div v-if="isOfflineDoorCheckDoorsPosted">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Offline door
                                                                            check doors saved to server.</p>
                                                                    </div>
                                                                    <div v-else-if="isOfflineDoorChecksDoorZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No offline
                                                                            door check doors to send to server.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            saving offline door check doors to server
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Saving offline door check doors to server...
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else-if="isRasSyncing">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="widget has-shadow">
                                                        <div class="widget-header bordered d-flex align-items-center section-header">
                                                            <h2>Syncing risk audits...</h2>
                                                        </div>
                                                        <div class="widget-body">
                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <div class="alert alert-info"
                                                                         v-if="isRasSyncComplete === false">
                                                                        Please do not reload or exit this page.
                                                                    </div>
                                                                    <div class="alert alert-danger"
                                                                         v-else-if="syncError === true">
                                                                        There was an error. Please try again or contact
                                                                        an administrator.
                                                                        <pre>{{ syncErrorDetails }}</pre>
                                                                    </div>
                                                                    <div class="alert alert-success" v-else>
                                                                        <strong>Success!</strong> The application has
                                                                        successfully synced with the server. Please wait
                                                                        a moment...
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <div class="progress progress-lg mb-3">
                                                                        <div class="progress-bar bg-primary"
                                                                             v-if="!syncError"
                                                                             role="progressbar"
                                                                             v-bind:style="'width: ' + syncRasProgress + '%'"
                                                                             v-bind:aria-valuenow="syncRasProgress"
                                                                             aria-valuemin="0"
                                                                             aria-valuemax="100"
                                                                        >
                                                                        </div>
                                                                        <div class="progress-bar bg-danger" v-else
                                                                             role="progressbar"
                                                                             v-bind:style="'width: ' + syncRasProgress + '%'"
                                                                             v-bind:aria-valuenow="syncRasProgress"
                                                                             aria-valuemin="0"
                                                                             aria-valuemax="100"
                                                                        >
                                                                            Error
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <div v-if="isWorkspaceDetailsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Workspace
                                                                            details received from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-check"></span> Problem
                                                                            getting workspace details from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting workspace details from server...</p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-6">
                                                                    <div v-if="isDropdownsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Dropdown options saved to database.</p>
                                                                    </div>
                                                                    <div v-else-if="isDropdownsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No dropdowns found.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            saving dropdowns to database
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Saving dropdown options to database...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isOfflineRiskAuditsPosted">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Offline risk audits saved to server.</p>
                                                                    </div>
                                                                    <div v-else-if="isRiskAuditsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No offline
                                                                            risk audits to send to server.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            saving offline risk audits to server
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Saving offline risk audits to server...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isRiskAuditsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Risk audits
                                                                            synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isRiskAuditsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No risk audits to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing risk audits with application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing risk audits with application...</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else-if="isErSyncing">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="widget has-shadow">
                                                        <div class="widget-header bordered d-flex align-items-center section-header">
                                                            <h2>Syncing extinguisher inspections...</h2>
                                                        </div>
                                                        <div class="widget-body">
                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <div class="alert alert-info"
                                                                         v-if="isErSyncComplete === false">
                                                                        Please do not reload or exit this page.
                                                                    </div>
                                                                    <div class="alert alert-danger"
                                                                         v-else-if="syncError === true">
                                                                        There was an error. Please try again or contact
                                                                        an administrator.
                                                                        <pre>{{ syncErrorDetails }}</pre>
                                                                    </div>
                                                                    <div class="alert alert-success" v-else>
                                                                        <strong>Success!</strong> The application has
                                                                        successfully synced with the server. Please wait
                                                                        a moment...
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <div class="progress progress-lg mb-3">
                                                                        <div class="progress-bar bg-primary"
                                                                             v-if="!syncError"
                                                                             role="progressbar"
                                                                             v-bind:style="'width: ' + syncErsProgress + '%'"
                                                                             v-bind:aria-valuenow="syncErsProgress"
                                                                             aria-valuemin="0"
                                                                             aria-valuemax="100"
                                                                        >
                                                                        </div>
                                                                        <div class="progress-bar bg-danger" v-else
                                                                             role="progressbar"
                                                                             v-bind:style="'width: ' + syncErsProgress + '%'"
                                                                             v-bind:aria-valuenow="syncErsProgress"
                                                                             aria-valuemin="0"
                                                                             aria-valuemax="100"
                                                                        >
                                                                            Error
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <div v-if="isOfflineExtinguisherReportsPosted">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Offline extinguisher reports saved to server.</p>
                                                                    </div>
                                                                    <div v-else-if="isExtinguisherReportsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No offline
                                                                            extinguisher reports to send to server.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            saving offline extinguisher reports to server
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Saving offline extinguisher reports to server...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isOfflineExtinguishersPosted">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Offline extinguishers saved to server.</p>
                                                                    </div>
                                                                    <div v-else-if="isExtinguishersZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No offline
                                                                            extinguishers to send to server.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            saving offline extinguishers to server
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Saving offline extinguishers to server...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isWorkspaceDetailsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Workspace
                                                                            details received from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting workspace details from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting workspace details from server...</p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isExtinguisherOptionsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Report options received from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting report options from server
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting report options from server...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isExtinguisherReportsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Extinguisher reports
                                                                            recevied from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting extinguisher reports from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting extinguisher reports from server...</p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isExtinguishersLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Extinguishers
                                                                            received from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting extinguishers from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting extinguishers from server...</p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isWorkspaceDetailsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Workspace
                                                                            details received from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting workspace details from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting workspace details from server...</p>
                                                                    </div>
                                                                </div>
                                                                
                                                                <div class="col-md-6">
                                                                    <div v-if="isExtinguisherCapacitiesAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Extinguisher capacities synced with application.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing extinguisher capacities with application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing extinguisher capacities with application...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isExtinguisherFinishesAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Extinguisher finishes synced with application.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing extinguisher finishes with application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing extinguisher finishes with application...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isExtinguisherPositionsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Extinguisher positions synced with application.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing extinguisher positions with application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing extinguisher positions with application...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isExtinguisherTypesAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Extinguisher types synced with application.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing extinguisher types with application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing extinguisher types with application...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isExtinguisherReportsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Extinguisher reports
                                                                            synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isExtinguisherReportsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No extinguisher reports to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing extinguisher reports with application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing extinguisher reports with application...</p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isExtinguishersAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Extinguishers
                                                                            synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isExtinguishersZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No extinguishers to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing extinguishers with application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing extinguishers with application...</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else-if="isFsrSyncing">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="widget has-shadow">
                                                        <div class="widget-header bordered d-flex align-items-center section-header">
                                                            <h2>Syncing Fire Stopping Reports...</h2>
                                                        </div>
                                                        <div class="widget-body">
                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <div class="alert alert-info"
                                                                         v-if="isFsrSyncComplete === false">
                                                                        Please do not reload or exit this page.
                                                                    </div>
                                                                    <div class="alert alert-danger"
                                                                         v-else-if="syncError === true">
                                                                        There was an error. Please try again or contact
                                                                        an administrator.
                                                                        <pre>{{ syncErrorDetails }}</pre>
                                                                    </div>
                                                                    <div class="alert alert-success" v-else>
                                                                        <strong>Success!</strong> The application has
                                                                        successfully synced with the server. Please wait
                                                                        a moment...
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <div class="progress progress-lg mb-3">
                                                                        <div class="progress-bar bg-primary"
                                                                             v-if="!syncError"
                                                                             role="progressbar"
                                                                             v-bind:style="'width: ' + syncFsrProgress + '%'"
                                                                             v-bind:aria-valuenow="syncFsrProgress"
                                                                             aria-valuemin="0"
                                                                             aria-valuemax="100"
                                                                        >
                                                                        </div>
                                                                        <div class="progress-bar bg-danger" v-else
                                                                             role="progressbar"
                                                                             v-bind:style="'width: ' + syncFsrProgress + '%'"
                                                                             v-bind:aria-valuenow="syncFsrProgress"
                                                                             aria-valuemin="0"
                                                                             aria-valuemax="100"
                                                                        >
                                                                            Error
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <div v-if="isOfflineFireStoppingReportsPosted">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Offline Fire Stopping Reports saved to server.</p>
                                                                    </div>
                                                                    <div v-else-if="isFireStoppingReportsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No offline
                                                                            Fire Stopping Reports to send to server.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            saving offline Fire Stopping Reports to server
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Saving offline Fire Stopping Reports to server...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isOfflineFireStoppingReportSitePlansPosted">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Offline report site plans saved to server.</p>
                                                                    </div>
                                                                    <div v-else-if="isFireStoppingReportSitePlansZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No offline
                                                                            report site plans to send to server.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            saving offline report site plans to server
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Saving offline report site plans to server...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isOfflineFireStoppingReportItemsPosted">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Offline report items saved to server.</p>
                                                                    </div>
                                                                    <div v-else-if="isFireStoppingReportItemsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No offline
                                                                            report items to send to server.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            saving offline report items to server
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Saving offline report items to server...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isWorkspaceDetailsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Workspace
                                                                            details received from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting workspace details from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting workspace details from server...</p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isFireStoppingReportOptionsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Report options received from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting report options from server
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting report options from server...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isFireStoppingReportsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Fire Stopping Reports
                                                                            recevied from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting Fire Stopping Reports from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting Fire Stopping Reports from server...</p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isFireStoppingReportSitePlansLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Report site plans
                                                                            received from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting report site plans from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting report site plans from server...</p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isFireStoppingReportItemsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Report items
                                                                            received from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting report items from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting report items from server...</p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isWorkspaceDetailsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Workspace
                                                                            details received from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting workspace details from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting workspace details from server...</p>
                                                                    </div>
                                                                </div>
                                                                
                                                                <div class="col-md-6">
                                                                    <div v-if="isFsrFaultsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> FSR Fault Codes synced with application.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing FSR Fault Codes with application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing FSR Fault Codes with application...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isFsrMaterialsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Materials synced with application.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing materials with application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing materials with application...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isFsrProductsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Products synced with application.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing products with application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing products with application...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isFsrFireRatingsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Fire Ratings synced with application.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing Fire Ratings with application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing Fire Ratings with application...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isFsrSubstratesAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Substrates synced with application.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing substrates with application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing substrates with application...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isFsrConstructionTypesAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Construction Types synced with application.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing Construction Types with application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing Construction Types with application...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isFsrThermalInsulationsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Thermal Insulations synced with application.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing Thermal Insulations with application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing Thermal Insulations with application...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isFireStoppingReportsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Fire Stopping Reports
                                                                            synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isFireStoppingReportsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No Fire Stopping Reports to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing Fire Stopping Reports with application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing Fire Stopping Reports with application...</p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isFireStoppingReportSitePlansAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Report site plans
                                                                            synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isFireStoppingReportSitePlansZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No report site plans to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing report site plans with application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing report site plans with application...</p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isFireStoppingReportItemsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Report items
                                                                            synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isFireStoppingReportItemsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No report items to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing report items with application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing report items with application...</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else-if="isBsrSyncing">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="widget has-shadow">
                                                        <div class="widget-header bordered d-flex align-items-center section-header">
                                                            <h2>Syncing BAE Systems Reports...</h2>
                                                        </div>
                                                        <div class="widget-body">
                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <div class="alert alert-info"
                                                                         v-if="isBsrSyncComplete === false">
                                                                        Please do not reload or exit this page.
                                                                    </div>
                                                                    <div class="alert alert-danger"
                                                                         v-else-if="syncError === true">
                                                                        There was an error. Please try again or contact
                                                                        an administrator.
                                                                        <pre>{{ syncErrorDetails }}</pre>
                                                                    </div>
                                                                    <div class="alert alert-success" v-else>
                                                                        <strong>Success!</strong> The application has
                                                                        successfully synced with the server. Please wait
                                                                        a moment...
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <div class="progress progress-lg mb-3">
                                                                        <div class="progress-bar bg-primary"
                                                                             v-if="!syncError"
                                                                             role="progressbar"
                                                                             v-bind:style="'width: ' + syncBsrProgress + '%'"
                                                                             v-bind:aria-valuenow="syncBsrProgress"
                                                                             aria-valuemin="0"
                                                                             aria-valuemax="100"
                                                                        >
                                                                        </div>
                                                                        <div class="progress-bar bg-danger" v-else
                                                                             role="progressbar"
                                                                             v-bind:style="'width: ' + syncBsrProgress + '%'"
                                                                             v-bind:aria-valuenow="syncBsrProgress"
                                                                             aria-valuemin="0"
                                                                             aria-valuemax="100"
                                                                        >
                                                                            Error
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <div v-if="isOfflineBaeSystemsReportsPosted">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Offline BAE Systems Reports saved to server.</p>
                                                                    </div>
                                                                    <div v-else-if="isBaeSystemsReportsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No offline
                                                                                BAE Systems Reports to send to server.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            saving offline BAE Systems Reports to server
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Saving offline BAE Systems Reports to server...
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isWorkspaceDetailsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Workspace
                                                                            details received from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting workspace details from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting workspace details from server...</p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isBaeSystemsReportsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> BAE Systems Reports
                                                                            recevied from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting BAE Systems Reports from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting BAE Systems Reports from server...</p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isWorkspaceDetailsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Workspace
                                                                            details received from server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting workspace details from server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting workspace details from server...</p>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isBaeSystemsReportsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> BAE Systems Reports
                                                                            synced with application</p>
                                                                    </div>
                                                                    <div v-else-if="isBaeSystemsReportsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No BAE Systems Reports to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing BAE Systems Reports with application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing BAE Systems Reports with application...</p>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else-if="isFdirSyncing">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="widget has-shadow">
                                                        <div class="widget-header bordered d-flex align-items-center section-header">
                                                            <h2>Syncing...</h2>
                                                        </div>
                                                        <div class="widget-body">
                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <div class="alert alert-info"
                                                                         v-if="!isFdirSyncComplete">
                                                                        Please do not reload or exit this page.
                                                                    </div>
                                                                    <div class="alert alert-danger"
                                                                         v-else-if="syncError">
                                                                        There was an error. Please try again or contact
                                                                        an administrator.
                                                                        <pre>{{ syncErrorDetails }}</pre>
                                                                    </div>
                                                                    <div class="alert alert-success" v-else>
                                                                        <strong>Success!</strong> The application has
                                                                        successfully synced with the server. Please wait
                                                                        a moment...
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <div class="progress progress-lg mb-3">
                                                                        <div class="progress-bar bg-primary"
                                                                             v-if="!syncError"
                                                                             role="progressbar"
                                                                             v-bind:style="'width: ' + syncFdirProgress + '%'"
                                                                             v-bind:aria-valuenow="syncFdirProgress"
                                                                             aria-valuemin="0"
                                                                             aria-valuemax="100"
                                                                        >
                                                                        </div>
                                                                        <div class="progress-bar bg-danger" v-else
                                                                             role="progressbar"
                                                                             v-bind:style="'width: ' + syncFdirProgress + '%'"
                                                                             v-bind:aria-valuenow="syncFdirProgress"
                                                                             aria-valuemin="0"
                                                                             aria-valuemax="100"
                                                                        >
                                                                            Error
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <div v-if="isWorkspaceDetailsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Workspace
                                                                            details received from the server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-check"></span> Problem
                                                                            getting workspace details from the server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting workspace details from the server...</p>
                                                                    </div>

                                                        
                                                                    <div v-if="isAdditionalDoorFieldsOptionsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Additional fields options
                                                                                received from the server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting additional fields options from the server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting additional fields options from the server...
                                                                        </p>
                                                                    </div>

                                                                    <div v-if="isFdiReportsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door Installation reports
                                                                            received from the server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting Door Installation reports from the server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting Door Installation reports from the server...</p>
                                                                    </div>

                                                                    <div v-if="isFdirItemsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Doors data received from the server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting doors data from the server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting doors data from the server...</p>
                                                                    </div>

                                                                    <div v-if="isOfflineFdiReportsPosted">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Offline Door Installation reports saved to the server.</p>
                                                                    </div>
                                                                    <div v-else-if="isOfflineFdiReportsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No Door Installation reports to send to the server.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            saving Door Installation reports to the server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Saving offline Door Installation reports to server...</p>
                                                                    </div>

                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isWorkspaceDetailsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Workspace
                                                                            details synced with the application</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing workspace details with the application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing workspace details with the
                                                                            application...</p>
                                                                    </div>

                                                                    <div v-if="isDeclaredResistanceLevelsAdded && isLevelOptionsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Additional fields options
                                                                                    synced with the application</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing additional fields options with the
                                                                            application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing additional fields options with the
                                                                            application...</p>
                                                                    </div>

                                                                    <div v-if="isFdiReportsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door Installation reports
                                                                            synced with the application</p>
                                                                    </div>
                                                                    <div v-else-if="isFdiReportsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No Door Installation reports
                                                                                to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing Door Installation reports with the application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing Door Installation reports with the application...</p>
                                                                    </div>

                                                                    <div v-if="isFdirItemsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Doors data synced
                                                                                 with the application</p>
                                                                    </div>
                                                                    <div v-else-if="isFdirItemsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No doors data
                                                                            be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing doors data with the application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing doors data with the application...
                                                                        </p>
                                                                    </div>

                                                                    <div v-if="isOfflineFdirItemsPosted">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Offline doors data saved 
                                                                                to the server.</p>
                                                                    </div>
                                                                    <div v-else-if="isOfflineFdirItemsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No offline
                                                                            doors data to send to the server.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            saving offline doors data to the server
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Saving offline doors data to the server...
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else-if="isFdmrSyncing">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="widget has-shadow">
                                                        <div class="widget-header bordered d-flex align-items-center section-header">
                                                            <h2>Syncing...</h2>
                                                        </div>
                                                        <div class="widget-body">
                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <div class="alert alert-info"
                                                                         v-if="!isFdmrSyncComplete">
                                                                        Please do not reload or exit this page.
                                                                    </div>
                                                                    <div class="alert alert-danger"
                                                                         v-else-if="syncError">
                                                                        There was an error. Please try again or contact
                                                                        an administrator.
                                                                        <pre>{{ syncErrorDetails }}</pre>
                                                                    </div>
                                                                    <div class="alert alert-success" v-else>
                                                                        <strong>Success!</strong> The application has
                                                                        successfully synced with the server. Please wait
                                                                        a moment...
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-md-12">
                                                                    <div class="progress progress-lg mb-3">
                                                                        <div class="progress-bar bg-primary"
                                                                             v-if="!syncError"
                                                                             role="progressbar"
                                                                             v-bind:style="'width: ' + syncFdmrProgress + '%'"
                                                                             v-bind:aria-valuenow="syncFdmrProgress"
                                                                             aria-valuemin="0"
                                                                             aria-valuemax="100"
                                                                        >
                                                                        </div>
                                                                        <div class="progress-bar bg-danger" v-else
                                                                             role="progressbar"
                                                                             v-bind:style="'width: ' + syncFdmrProgress + '%'"
                                                                             v-bind:aria-valuenow="syncFdmrProgress"
                                                                             aria-valuemin="0"
                                                                             aria-valuemax="100"
                                                                        >
                                                                            Error
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <div v-if="isWorkspaceDetailsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Workspace
                                                                            details received from the server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-check"></span> Problem
                                                                            getting workspace details from the server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting workspace details from the server...</p>
                                                                    </div>

                                                        
                                                                    <div v-if="isAdditionalDoorFieldsOptionsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Additional fields options
                                                                                received from the server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting additional fields options from the server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting additional fields options from the server...
                                                                        </p>
                                                                    </div>

                                                                    <div v-if="isFdmReportsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door Maintenance reports
                                                                            received from the server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting Door Maintenance reports from the server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting Door Maintenance reports from the server...</p>
                                                                    </div>

                                                                    <div v-if="isFdmrItemsLoaded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Doors data received from the server</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            getting doors data from the server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Getting doors data from the server...</p>
                                                                    </div>

                                                                    <div v-if="isOfflineFdmReportsPosted">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Offline Door Maintenance reports saved to the server.</p>
                                                                    </div>
                                                                    <div v-else-if="isOfflineFdmReportsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No Door Maintenance reports to send to the server.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            saving Door Maintenance reports to the server</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Saving offline Door Maintenance reports to server...</p>
                                                                    </div>

                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div v-if="isWorkspaceDetailsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Workspace
                                                                            details synced with the application</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing workspace details with the application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing workspace details with the
                                                                            application...</p>
                                                                    </div>

                                                                    <div v-if="isDeclaredResistanceLevelsAdded && isLevelOptionsAdded && isClientDefinedRatingsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Additional fields options
                                                                                    synced with the application</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing additional fields options with the
                                                                            application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing additional fields options with the
                                                                            application...</p>
                                                                    </div>

                                                                    <div v-if="isFdmReportsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Door Maintenance reports
                                                                            synced with the application</p>
                                                                    </div>
                                                                    <div v-else-if="isFdmReportsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No Door Maintenance reports
                                                                                to be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing Door Maintenance reports with the application</p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing Door Maintenance reports with the application...</p>
                                                                    </div>

                                                                    <div v-if="isFdmrItemsAdded">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Doors data synced
                                                                                 with the application</p>
                                                                    </div>
                                                                    <div v-else-if="isFdmrItemsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No doors data
                                                                            be added.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            syncing doors data with the application
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Syncing doors data with the application...
                                                                        </p>
                                                                    </div>

                                                                    <div v-if="isOfflineFdmrItemsPosted">
                                                                        <p class="c-positive"><span
                                                                                class="fa fa-check"></span> Offline doors data saved 
                                                                                to the server.</p>
                                                                    </div>
                                                                    <div v-else-if="isOfflineFdmrItemsZeroLength">
                                                                        <p class="c-neutral"><span
                                                                                class="fa fa-check"></span> No offline
                                                                            doors data to send to the server.</p>
                                                                    </div>
                                                                    <div v-else-if="syncError">
                                                                        <p class="c-negative"><span
                                                                                class="fa fa-times"></span> Problem
                                                                            saving offline doors data to the server
                                                                        </p>
                                                                    </div>
                                                                    <div v-else>
                                                                        <p><span
                                                                                class="fa fa-spin fa-circle-notch"></span>
                                                                            Saving offline doors data to the server...
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <router-view/>
                                        </div>

                                    </div>
                                </div>

                            </div>

                            <app-footer :workspace="workspace"></app-footer>
                        </div>


                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<style type="text/css">
    :root {
        --primary-color: #AB2328;
        --primary-color-hover: #692328;
        --secondary-color: #4C5351;
        --secondary-color-hover: #2F3331;
    }

    .template-option--li {
        width: 30% !important;
    }

    .radio-as-buttons .template-option--radio-as-button__pass:checked + label {
        background: green !important;
        color: white;
    }

    .radio-as-buttons .template-option--radio-as-button__na:checked + label {
        background: grey !important;
        color: white;
    }

    .radio-as-buttons .template-option--radio-as-button__duetest:checked + label {
        background: orange !important;
    }

    .radio-as-buttons .template-option--radio-as-button__fail:checked + label {
        background: red !important;
        color: white;
    }

</style>

<script>

    // @ is an alias to /src
    import AppFooter from '@/components/AppFooter.vue'
    import AppHeader from '@/components/AppHeader.vue'
    import AppSidebar from '@/components/AppSidebar.vue'
    import * as idb from 'idb';
    import moment from 'moment'
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: 'App',
        components: {
            AppFooter,
            AppHeader,
            AppSidebar
        },
        validations: {
            user_email_address: { required },
            user_user_password: { required },
        },
        metaInfo() {
            return {
                link: [
                    { rel: 'manifest', href: '/' + this.dbName + '-manifest.json' },
                    { rel: 'icon', href: '/img/icons/' + this.dbName + '/favicon-32x32.png' },
                ],
                title: 'Audits | ' + this.appName,
            }
        },
        data: () => {
            return {
                userToken: null,

                initDb: false,
                initDbError: null,
                initApi: false,
                initApiError: null,
                initApiErrorStage: 0,

                isMenuActive: true,
                bgAlert: false,
                loginErrorOccurred: false,
                loginFailed: false,
                submitting: false,
                isLoggedIn: false,
                enabledModules: [],
                hasDoneFullSync: false,
                syncError: false,
                isSyncing: false,
                isSyncingInBg: false,
                isSyncComplete: false,
                doorReportsSyncStarted: false,
                isWorkspaceDetailsLoaded: false,
                isWorkspaceDetailsAdded: false,
                isDoorMaterialsLoaded: false,
                isDoorMaterialsAdded: false,
                isFrameMaterialsLoaded: false,
                isFrameMaterialsAdded: false,
                isLocationsLoaded: false,
                isLocationsAdded: false,
                iSubstrateTypesLoaded: false,
                iSubstrateTypesAdded: false,
                isDoorSetsLoaded: false,
                isDoorSetsAdded: false,
                isDoorTypesLoaded: false,
                isDoorTypesAdded: false,
                isReportConfigLoaded: false,
                isReportConfigAdded: false,
                isAdditionalDoorFieldsOptionsLoaded: false,
                isDeclaredResistanceLevelsAdded: false,
                isLevelOptionsAdded: false,
                isClientDefinedRatingsAdded: false,
                isCpiScheduleItemsAdded: false,
                isDoorFaultsLoaded: false,
                isDoorFaultsAdded: false,
                isDoorChecksLoaded: false,
                isDoorChecksAdded: false,
                isDoorCheckSitePlansLoaded: false,
                isDoorCheckSitePlansAdded: false,
                isDoorCheckDoorsLoaded: false,
                isDoorCheckDoorsAdded: false,
                isOfflineDoorChecksPosted: false,
                isOfflineDoorCheckSitePlansPosted: false,
                isOfflineDoorCheckDoorsPosted: false,
                isDropdownsLoaded: false,
                isDropdownsPosted: false,
                isRiskAuditsLoaded: false,
                isRiskAuditsAdded: false,
                isOfflineRiskAuditsPosted: false,
                isExtinguisherOptionsLoaded: false,
                isExtinguisherCapacitiesAdded: false,
                isExtinguisherFinishesAdded: false,
                isExtinguisherPositionsAdded: false,
                isExtinguisherTypesAdded: false,
                isOfflineExtinguisherReportsPosted: false,
                isOfflineExtinguishersPosted: false,
                isExtinguisherReportsLoaded: false,
                isExtinguishersLoaded: false,
                isExtinguisherReportsAdded: false,
                isExtinguishersAdded: false,
                isFireStoppingReportOptionsLoaded: false,
                isFsrFaultsAdded: false,
                isFsrMaterialsAdded: false,
                isFsrProductsAdded: false,
                isFsrFireRatingsAdded: false,
                isFsrSubstratesAdded: false,
                isFsrConstructionTypesAdded: false,
                isFsrThermalInsulationsAdded: false,
                isOfflineFireStoppingReportsPosted: false,
                isOfflineFireStoppingReportSitePlansPosted: false,
                isOfflineFireStoppingReportItemsPosted: false,
                isFireStoppingReportsLoaded: false,
                isFireStoppingReportSitePlansLoaded: false,
                isFireStoppingReportItemsLoaded: false,
                isFireStoppingReportsAdded: false,
                isFireStoppingReportSitePlansAdded: false,
                isFireStoppingReportItemsAdded: false,

                isOfflineDoorChecksZeroLength: false,
                isDoorCheckSitePlansZeroLength: false,
                isOfflineDoorChecksDoorZeroLength: false,
                isFrameMaterialsZeroLength: false,
                isLocationsZeroLength: false,
                isSubstrateTypesZeroLength: false,
                isDoorSetsZeroLength: false,
                isDoorTypesZeroLength: false,
                isDoorMaterialsZeroLength: false,
                isDoorFaultsZeroLength: false,
                isDoorChecksZeroLength: false,
                isDoorCheckDoorsZeroLength: false,
                isDropdownsZeroLength: false,
                isRiskAuditsZeroLength: false,
                isExtinguisherReportsZeroLength: false,
                isExtinguishersZeroLength: false,
                isFireStoppingReportsZeroLength: false,
                isFireStoppingReportSitePlansZeroLength: false,
                isFireStoppingReportItemsZeroLength: false,
                isOfflineFdiReportsZeroLength: false,
                isOfflineFdirItemsZeroLength: false,

                syncProgress: 0,

                rasBitPercentage: 50,
                riskAuditsSyncStarted: false,
                isRasSyncComplete: false,
                isRasSyncing: false,
                isRasSyncingInBg: false,
                syncRasProgress: 0,

                submittedRiskAuditConflictForm: false,
                showRiskAuditsSyncErrors: false,
                riskAuditConflicts: [],
                riskAuditsSyncErrors: [],
                riskAuditsToArchive: [],

                showDoorReportsSyncErrors: false,
                submittedDoorReportsConflictForm: false,
                doorReportsConflicts: [],
                doorReportsSyncErrors: [],
                doorReportsToArchive: [],
                doorsToArchive: [],

                extinguisherReportsSyncStarted: false,
                isErSyncComplete: false,
                isErSyncing: false,
                isErSyncingInBg: false,
                syncErsProgress: 0,

                submittedExtinguisherReportsConflictForm: false,
                showExtinguisherReportsSyncErrors: false,
                extinguisherReportsConflicts: [],
                extinguisherReportsErrors: [],
                extinguisherReportsToArchive: [],
                extinguishersToArchive: [],
                offlineExtinguisherReports: [],
                offlineExtinguishers: [],

                fireStoppingReportsSyncStarted: false,
                isFsrSyncComplete: false,
                isFsrSyncing: false,
                isFsrSyncingInBg: false,
                syncFsrProgress: 0,
                submittedFireStoppingReportsConflictForm: false,
                showFireStoppingReportsSyncErrors: false,
                fireStoppingReportsConflicts: [],
                fireStoppingReportsErrors: [],
                fireStoppingReportsToArchive: [],
                fireStoppingReportSitePlansToArchive: [],
                fireStoppingReportItemsToArchive: [],
                offlineFireStoppingReports: [],
                offlineFireStoppingReportSitePlans: [],
                offlineFireStoppingReportItems: [],

                baeSystemsReportsSyncStarted: false,
                isBsrSyncComplete: false,
                isBsrSyncing: false,
                isBsrSyncingInBg: false,
                syncBsrProgress: 0,
                submittedBaeSystemsReportsConflictForm: false,
                showBaeSystemsReportsSyncErrors: false,
                baeSystemsReportsConflicts: [],
                baeSystemsReportsErrors: [],
                baeSystemsReportsToArchive: [],
                offlineBaeSystemsReports: [],
                isOfflineBaeSystemsReportsPosted: false,
                isBaeSystemsReportsZeroLength: false,
                isBaeSystemsReportsLoaded: false,
                isBaeSystemsReportsAdded: false,

                fdirSyncStarted: false,
                isFdirSyncComplete: false,
                isFdirSyncing: false,
                isFdirSyncingInBg: false,
                syncFdirProgress: 0,
                isFdiReportsLoaded: false,
                isFdiReportsAdded: false,
                isFdirItemsLoaded: false,
                isFdirItemsAdded: false,
                isOfflineFdiReportsPosted: false,
                isOfflineFdirItemsPosted: false,
                isOfflineFdirItemsZeroLength: false,
                isOfflineFdiReportsZeroLength: false,
                showFdirSyncErrors: false,
                submittedFdirConflictForm: false,
                offlineFdiReports: [],
                offlineFdirItems: [],
                fdirConflicts: [],
                fdirSyncErrors: [],
                fdiReportsToArchive: [],
                fdirItemsToArchive: [],

                fdmrSyncStarted: false,
                isFdmrSyncComplete: false,
                isFdmrSyncing: false,
                isFdmrSyncingInBg: false,
                syncFdmrProgress: 0,
                isFdmReportsLoaded: false,
                isFdmReportsAdded: false,
                isFdmrItemsLoaded: false,
                isFdmrItemsAdded: false,
                isOfflineFdmReportsPosted: false,
                isOfflineFdmrItemsPosted: false,
                isOfflineFdmrItemsZeroLength: false,
                isOfflineFdmReportsZeroLength: false,
                showFdmrSyncErrors: false,
                submittedFdmrConflictForm: false,
                offlineFdmReports: [],
                offlineFdmrItems: [],
                fdmrConflicts: [],
                fdmrSyncErrors: [],
                fdmReportsToArchive: [],
                fdmrItemsToArchive: [],
                
                workspace: {
                    primary_colour: ' #666',
                    primary_colour_hover: '#000',
                    secondary_color: '#4C5351',
                    secondary_color_hover: '#2F3331',
                    workspace_name: 'Assessment App',
                    workspace_logo: 'default.png',
                    workspace_favicon: '',
                    last_updated: null,
                    risk_audit_last_updated: null,
                    has_access_to_fire_door_audit: true,
                    has_access_to_risk_audit: false,
                    has_access_to_extinguisher_report: false,
                    has_access_to_fire_stopping_report: false,
                    has_access_to_bae_system_report: false,
                    has_access_to_door_installation_report: false,
                    has_access_to_door_maintenance_report: false
                },

                user_email_address: null,
                user_user_password: null,

                dropdowns: [],
                fra_report_types: [],

                syncsOpen: false,
                isClearDbInfoExpanded: false,
            }
        },
        computed: {
            cssProps() {
                return {
                    '--primary-color': this.workspace.primary_colour,
                    '--primary-color-hover': this.workspace.primary_colour_hover,
                    '--secondary-color': this.workspace.secondary_colour,
                    '--secondary-color-hover': this.workspace.secondary_colour_hover,
                }
            },
            navigatorOnline() {
                return navigator.onLine;
            },
            getMenuState() {
                this.$nextTick(() => {
                    console.log(this.$refs.appHeader.menuActive)
                    this.$watch(() => this.$refs.appHeader.menuActive, (value) => { this.isMenuActive = value;})
                });
            }
        },
        mounted() {
            this.isLoggedIn = this.$session.get('user_id') && this.$session.get('user_token');
            const modulesData = this.$session.get('enabled_modules');
            if(this.isLoggedIn && modulesData) {
                this.enabledModules = modulesData;
            } else {
                this.enabledModules = [];
            }
            
            this.hasDoneFullSync = this.$session.get('has_done_full_sync');
            this.getWorkspaceDetails();
        },
        methods: {
            canAccessSitePlansForFD() {
                return this.dbName !== 'jpfire';
            },
            canAccessBMTradaOptions() {
                return this.dbName !== 'jpfire';
            },
            isModuleEnabled(moduleName) {
                return this.enabledModules.indexOf(moduleName) > -1;
            },
            clearDatabase() {
                if (!window.indexedDB) {
                    window.alert("Your browser doesn't support a stable version of IndexedDB.");
                    return false;
                }

                var dbName = this.getCmsDetails('dbname');
                var req = window.indexedDB.deleteDatabase(dbName);
                var vm = this;
                req.onsuccess = function () {
                    console.log("Deleted database successfully");
                    vm.$session.destroy();
                    vm.reloadPage();
                };
                req.onerror = function () {
                    console.error("Couldn't delete database");
                };
                req.onblocked = function () {
                    console.log("Couldn't delete database due to the operation being blocked");
                };
            },
            toggleClearDbInfo() {
                this.isClearDbInfoExpanded = !this.isClearDbInfoExpanded;
            },
            continueRiskAuditsSyncProcess(event) {
                event.preventDefault();
                if(this.submittedRiskAuditConflictForm) {
                    return;
                }
                this.submittedRiskAuditConflictForm = true;
                
                this.offlineRiskAudits.forEach((riskAudit, index, array) => {
                    if(riskAudit.update_flag == 'SAVE_AS_NEW') {
                        array[index].old_site_risk_audit_id = riskAudit.site_risk_audit_id;
                        array[index].site_risk_audit_id = Math.floor(new Date().getTime() / 1000)  + index;
                        array[index].ra_cover.reference_number += ' #' + array[index].site_risk_audit_id;
                    }
                });

                this.performActualRiskAuditsSync();
            },
            hideRiskAuditSyncErrors() {
                this.showRiskAuditsSyncErrors = false;
            },
            continueDoorReportsSyncProcess(event) {
                event.preventDefault();
                if(this.submittedDoorReportsConflictForm) {
                    return;
                }

                this.submittedDoorReportsConflictForm = true;
                
                this.offlineDoorChecks.forEach((doorReport, index, array) => {
                    if(doorReport.update_flag == 'SAVE_AS_NEW') {
                        array[index].old_site_door_check_id = doorReport.site_door_check_id;
                        array[index].site_door_check_id = Math.floor(new Date().getTime() / 1000)  + index;
                        array[index].document_id += ' #' + array[index].site_door_check_id;
                    }

                    this.offlineDoorCheckDoors.forEach((door, doorIndex, doorsArray) => {
                        if((doorReport.update_flag == 'SAVE_AS_NEW' && array[index].old_site_door_check_id == door.site_door_check_id) ||
                        (doorReport.update_flag != 'SAVE_AS_NEW' && doorReport.site_door_check_id == door.site_door_check_id)) {
                            doorsArray[doorIndex].update_flag = doorReport.update_flag;
                            if(doorReport.update_flag == 'SAVE_AS_NEW') {
                                doorsArray[doorIndex].site_door_check_id = array[index].site_door_check_id;
                                doorsArray[doorIndex].old_site_door_check_door_id = door.site_door_check_door_id;
                                doorsArray[doorIndex].site_door_check_door_id = Math.floor(new Date().getTime() / 1000) + index + doorIndex;  
                            }
                        }
                    });
                });

                this.performActualDoorReportsSync();
            },
            hideDoorReportsSyncErrors() {
                this.showDoorReportsSyncErrors = false;
            },
            invalidateDoorReportDoor(site_door_check_id) {
                this.offlineDoorCheckSitePlans.forEach((item, itemIndex, itemsArray) => {
                    if(item.site_door_check_id == site_door_check_id) {
                        itemsArray[itemIndex].report_ignored = true;
                    }
                });
                this.offlineDoorCheckDoors.forEach((door, doorIndex, doorsArray) => {
                    if(door.site_door_check_id == site_door_check_id) {
                        doorsArray[doorIndex].report_ignored = true;
                    }
                });
            },
            continueExtinguisherReportsSyncProcess(event) {
                event.preventDefault();
                if(this.submittedExtinguisherReportsConflictForm) {
                    return;
                }

                this.submittedExtinguisherReportsConflictForm = true;
                
                this.offlineExtinguisherReports.forEach((extinguisherReport, index, array) => {
                    if(extinguisherReport.update_flag == 'SAVE_AS_NEW') {
                        array[index].old_site_extinguisher_report_id = extinguisherReport.site_extinguisher_report_id;
                        array[index].site_extinguisher_report_id = Math.floor(new Date().getTime() / 1000)  + index;
                        array[index].document_id += ' #' + array[index].site_extinguisher_report_id;
                    }

                    this.offlineExtinguishers.forEach((extinguisher, extinguisherIndex, extinguishersArray) => {
                        if((extinguisherReport.update_flag == 'SAVE_AS_NEW' && array[index].old_site_extinguisher_report_id == extinguisher.site_extinguisher_report_id) ||
                        (extinguisherReport.update_flag != 'SAVE_AS_NEW' && extinguisherReport.site_extinguisher_report_id == extinguisher.site_extinguisher_report_id)) {
                            extinguishersArray[extinguisherIndex].update_flag = extinguisherReport.update_flag;
                            if(extinguisherReport.update_flag == 'SAVE_AS_NEW') {
                                extinguishersArray[extinguisherIndex].site_extinguisher_report_id = array[index].site_extinguisher_report_id;
                                extinguishersArray[extinguisherIndex].old_site_extinguisher_report_item_id = extinguisher.site_extinguisher_report_item_id;
                                extinguishersArray[extinguisherIndex].site_extinguisher_report_item_id = Math.floor(new Date().getTime() / 1000) + index + extinguisherIndex;  
                            }
                        }
                    });
                });

                this.performActualExtinguisherReportsSync();
            },
            hideExtinguisherReportsSyncErrors() {
                this.showExtinguisherReportsSyncErrors = false;
            },
            invalidateExtinguisherReport(site_extinguisher_report_id) {
                this.offlineExtinguishers.forEach((extinguisher, extinguisherIndex, extinguishersArray) => {
                    if(extinguisher.site_extinguisher_report_id == site_extinguisher_report_id) {
                        extinguishersArray[extinguisherIndex].report_ignored = true;
                    }
                });
            },
            hideFireStoppingReportsSyncErrors() {
                this.showFireStoppingReportsSyncErrors = false;
            },
            continueFireStoppingReportsSyncProcess(event) {
                event.preventDefault();
                if(this.submittedFireStoppingReportsConflictForm) {
                    return;
                }

                this.submittedFireStoppingReportsConflictForm = true;
                
                this.offlineFireStoppingReports.forEach((fireStoppingReport, index, array) => {
                    if(fireStoppingReport.update_flag == 'SAVE_AS_NEW') {
                        array[index].old_site_fire_stopping_report_id = fireStoppingReport.site_fire_stopping_report_id;
                        array[index].site_fire_stopping_report_id = Math.floor(new Date().getTime() / 1000)  + index;
                        array[index].sequential_reference_number += ' #' + array[index].site_fire_stopping_report_id;
                    }

                    this.offlineFireStoppingReportSitePlans.forEach((sitePlan, sitePlanIndex, sitePlansArray) => {
                        if((fireStoppingReport.update_flag == 'SAVE_AS_NEW' && array[index].old_site_fire_stopping_report_id == sitePlan.site_fire_stopping_report_id) ||
                        (fireStoppingReport.update_flag != 'SAVE_AS_NEW' && fireStoppingReport.site_fire_stopping_report_id == sitePlan.site_fire_stopping_report_id)) {
                            sitePlansArray[sitePlanIndex].update_flag = fireStoppingReport.update_flag;
                            if(fireStoppingReport.update_flag == 'SAVE_AS_NEW') {
                                sitePlansArray[sitePlanIndex].site_fire_stopping_report_id = array[index].site_fire_stopping_report_id;
                                sitePlansArray[sitePlanIndex].old_site_fire_stopping_report_site_plan_id = sitePlan.site_fire_stopping_report_site_plan_id;
                                sitePlansArray[sitePlanIndex].site_fire_stopping_report_site_plan_id = Math.floor(new Date().getTime() / 1000) + index + sitePlanIndex;    
                            }
                        }
                    });

                    this.offlineFireStoppingReportItems.forEach((reportItem, reportItemIndex, reportItemsArray) => {
                        if((fireStoppingReport.update_flag == 'SAVE_AS_NEW' && array[index].old_site_fire_stopping_report_id == reportItem.site_fire_stopping_report_id) ||
                        (fireStoppingReport.update_flag != 'SAVE_AS_NEW' && fireStoppingReport.site_fire_stopping_report_id == reportItem.site_fire_stopping_report_id)) {
                            reportItemsArray[reportItemIndex].update_flag = fireStoppingReport.update_flag;
                            if(fireStoppingReport.update_flag == 'SAVE_AS_NEW') {
                                let sitePlanIndex = this.offlineFireStoppingReportSitePlans.findIndex(s => s.old_site_fire_stopping_report_site_plan_id == reportItem.site_fire_stopping_report_site_plan_id);
                                reportItemsArray[reportItemIndex].site_fire_stopping_report_id = array[index].site_fire_stopping_report_id;
                                reportItemsArray[reportItemIndex].site_fire_stopping_report_site_plan_id = this.offlineFireStoppingReportSitePlans[sitePlanIndex].site_fire_stopping_report_site_plan_id;
                                reportItemsArray[reportItemIndex].old_site_fire_stopping_report_item_id = reportItem.site_fire_stopping_report_item_id;
                                reportItemsArray[reportItemIndex].site_fire_stopping_report_item_id = Math.floor(new Date().getTime() / 1000) + index + reportItemIndex;     
                            }
                        }
                    });
                });

                this.performActualFireStoppingReportsSync();
            },
            invalidateFireStoppingReport(site_fire_stopping_report_id) {
                this.offlineFireStoppingReportSitePlans.forEach((item, itemIndex, itemsArray) => {
                    if(item.site_fire_stopping_report_id == site_fire_stopping_report_id) {
                        itemsArray[itemIndex].report_ignored = true;
                    }
                });
                this.offlineFireStoppingReportItems.forEach((item, itemIndex, itemsArray) => {
                    if(item.site_fire_stopping_report_id == site_fire_stopping_report_id) {
                        itemsArray[itemIndex].report_ignored = true;
                    }
                });
            },
            continueBaeSystemsReportsSyncProcess(event) {
                event.preventDefault();
                if(this.submittedBaeSystemsReportsConflictForm) {
                    return;
                }

                this.submittedBaeSystemsReportsConflictForm = true;
                
                this.offlineBaeSystemsReports.forEach((report, index, array) => {
                    if(report.update_flag == 'SAVE_AS_NEW') {
                        array[index].old_site_bae_systems_report_id = report.site_bae_systems_report_id;
                        array[index].site_bae_systems_report_id = Math.floor(new Date().getTime() / 1000)  + index;
                    }
                });

                this.performActualBaeSystemsReportsSync();
            },
            hideAlert() {
                this.bgAlert = false;
            },
            getUserToken() {
                if(this.userToken == null) {
                    this.userToken = this.$session.get('user_token');
                }
            },
            initialSetUp() {
                var vm = this;
                this.getDb(function onConnected(db) {

                    axios.get(vm.cmsUrl + 'api/v1/workspace/details.json')
                        .then(response => {
                            var vmt = vm;
                            vm.workspace = response.data.workspace;
                            var transaction = db.transaction(['workspace_details'], 'readwrite');
                            var workspaceDetailsStore = transaction.objectStore('workspace_details');
                            try {

                                var putWDRequest = workspaceDetailsStore.put({
                                    workspace_id: vmt.workspace.workspace_id,
                                    primary_colour: vmt.workspace.primary_colour,
                                    primary_color_hover: vmt.workspace.primary_colour_hover,
                                    secondary_colour: vmt.workspace.secondary_colour,
                                    secondary_colour_hover: vmt.workspace.secondary_colour_hover,
                                    workspace_name: vmt.workspace.workspace_name,
                                    workspace_logo: vmt.workspace.workspace_logo,
                                    workspace_favicon: vmt.workspace.workspace_favicon,
                                    risk_audit_last_updated: vmt.workspace.risk_audit_last_updated,
                                    has_access_to_fire_door_audit: vmt.workspace.has_access_to_fire_door_audit,
                                    has_access_to_risk_audit: vmt.workspace.has_access_to_risk_audit,
                                    has_access_to_extinguisher_report: vmt.workspace.has_access_to_extinguisher_report,
                                    has_access_to_fire_stopping_report: vmt.workspace.has_access_to_fire_stopping_report,
                                    has_access_to_bae_system_report: vmt.workspace.has_access_to_bae_system_report,
                                    has_access_to_door_installation_report: vmt.workspace.has_access_to_door_installation_report,
                                    has_access_to_door_maintenance_report: vmt.workspace.has_access_to_door_maintenance_report
                                });
                                putWDRequest.onsuccess = function () {
                                    console.log('Workspace details added');
                                }

                                vmt.$session.set('doors_last_sync', new Date());
                            } catch (e) {
                                console.log('Workspace deets failed');
                                console.log(e);
                            }
                        })
                });
            },
            enableSubmitLoader() {
                this.submitting = true;
            },
            disableSubmitLoader() {
                this.submitting = false;
            },
            login() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.sendFormData();
                } else {
                    this.validationError();
                }
            },
            logout() {
                this.$session.remove('user_id');
                this.$session.remove('user_token');
                this.$session.remove('enabled_modules');
                this.userToken = null;
                this.isLoggedIn = false;
                this.enabledModules = [];
                this.$router.push('/');
            },
            sendFormData() {
                this.enableSubmitLoader();

                this.$session.start();
                axios
                    .post(this.cmsUrl + 'api/v1/workspace/user-login.json', {email_address: this.user_email_address, user_password: this.user_user_password})
                    .then(response => {
                        if (response.data.success) {
                            var user = response.data.user;
                            this.$session.set('user_id', user.user_id);
                            this.$session.set('user_token', user.user_token);
                            this.$session.set('enabled_modules', response.data.enabled_modules);
                            this.userToken = user.user_token;
                            this.isLoggedIn = true;
                            this.enabledModules = response.data.enabled_modules;
                            this.$router.push({ name: 'home' });
                        } else {
                            this.loginFailed = true;
                        }
                        this.disableSubmitLoader();
                    }).catch(error => {
                    console.log(error);
                    this.loginErrorOccurred = true;
                    this.disableSubmitLoader();
                });
            },
            syncRiskAudits(inBg) {
                if (navigator.onLine && !this.riskAuditsSyncStarted) {

                    this.riskAuditsSyncStarted = true;
                    this.isRasSyncComplete = false;
                    this.isRasSyncing = inBg !== true;
                    this.isRasSyncingInBg = inBg === true;
                    this.syncRasProgress = 0;

                    this.isWorkspaceDetailsLoaded = false;
                    this.isWorkspaceDetailsAdded = false;

                    this.isDropdownsLoaded = false;
                    this.isDropdownsPosted = false;

                    this.isRiskAuditsLoaded = false;
                    this.isRiskAuditsAdded = false;
                    this.isOfflineRiskAuditsPosted = false;

                    this.showRiskAuditsSyncErrors = false;
                    this.submittedRiskAuditConflictForm = false;
                    this.riskAuditConflicts = [];
                    this.riskAuditsSyncErrors = [];
                    this.riskAuditsToArchive = [];

                    var vmts = this;
                    this.getDb(function onConnected(db) {
                        vmts.initDb = true;

                        // Get workspace details first?
                        var uploadTransaction = db.transaction([
                            'workspace_details',
                            'door_checks',
                            'door_check_doors',
                            'risk_assessments',
                        ]);

                        var localRiskAuditsStore = uploadTransaction.objectStore('risk_assessments');

                        var vm = vmts;
                        vm.getUserToken();

                        uploadTransaction.oncomplete = function (event) {
                            if (vm.offlineRiskAudits.length === 0) {
                                vm.isRiskAuditsZeroLength = true;
                                vm.performActualRiskAuditsSync();
                            } else {
                                //Perform versions check
                                var reportsVersions = [];
                                vm.offlineRiskAudits.forEach(riskAudit => {
                                    var reportVersion = null;
                                    if(riskAudit.hasOwnProperty('report_version')) {
                                        reportVersion = riskAudit.report_version;
                                    }
                                    reportsVersions.push({
                                        'site_risk_audit_id': riskAudit.site_risk_audit_id,
                                        'report_version': reportVersion
                                    });
                                });
                                axios.post(vm.cmsUrl + 'api/v1/risk-audits/check-versions.json', reportsVersions, {headers: {'Authorization': 'Bearer ' + vm.userToken}})
                                .then(response => {
                                    console.log('Received response from check-versions');
                                    //Go through records and check if there are conflicts, if so then display options, otherwise continue
                                    if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                                        response.data.data.forEach((report, index) => {
                                            var localReportVersion = reportsVersions[index]['report_version'];
                                            var remoteReportVersion = report['report_version'];

                                            vm.offlineRiskAudits[index].update_flag = 'OVERWRITE';

                                            if(remoteReportVersion != null && localReportVersion != remoteReportVersion) {
                                                vm.offlineRiskAudits[index].remote_report_version = remoteReportVersion;
                                                vm.riskAuditConflicts.push(index);
                                            }
                                        });

                                        console.log('Number of risk audits to sync: ' + vm.riskAuditConflicts.length)

                                        if(vm.riskAuditConflicts.length == 0) {
                                            vm.performActualRiskAuditsSync();
                                        }
                                    } else {
                                        console.log('Server returned invalid response while verifying versions of reports');
                                        throw 'Server returned invalid response while verifying versions of reports';
                                    }
                                })
                                .catch(e => {
                                    console.log('Catched error: ' + e);
                                    vm.syncErrorDetails = e;
                                    vm.isRasSyncComplete = true;
                                    vm.riskAuditsSyncStarted = false;
                                    vm.syncError = true;
                                });
                            }
                        };

                        uploadTransaction.onerror = function (error) {
                            vm.initApiError = error;
                            vm.initApiErrorStage = 'rauploadTransaction';
                            console.log(error);
                        };

                        vm.offlineRiskAudits = [];
                        try {
                            if (localRiskAuditsStore) {
                                localRiskAuditsStore.openCursor().onsuccess = function (event) {
                                    var cursor = event.target.result;

                                    if (cursor) {
                                        if (vm.offlineRiskAudits) {
                                            vm.offlineRiskAudits.push(cursor.value)
                                        }
                                        cursor.continue();
                                    }
                                };
                            }

                        } catch (e) {
                            vm.initApiError = e;
                            vm.initApiErrorStage = 'offlineRiskAudits';
                            console.log(e);
                            console.log(e);
                        }
                    });
                }
            },
            performActualRiskAuditsSync() {
                console.log('Entered performActualRiskAuditsSync()');
                var rasBitPercentage = 14.5;

                axios.post(this.cmsUrl + 'api/v1/risk-audits/dropdowns.json', {}, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                .then(response => {
                    this.syncRasProgress = (this.syncRasProgress + rasBitPercentage);
                    this.isDropdownsLoaded = true;
                    this.dropdowns = response.data.ra_dropdowns;
                    this.fra_report_types = response.data.fra_report_types;
                    return axios.post(this.cmsUrl + 'api/v1/risk-audits/add-risk-audits.json?ver=' + this.appNumericVersion, this.offlineRiskAudits, {headers: {'Authorization': 'Bearer ' + this.userToken}});
                }).then(response => {
                    
                    console.log('Received response to add-risk-audits');

                    return new Promise(async (resolve, reject) => { 
                        console.log('Entered promise after receiving response')
                        if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                            console.log(response.data.data);
                            var vm = this;
                            response.data.data.forEach((report, index) => {
                                console.log('Report @ index ' + index + ' is complete? ' + vm.offlineRiskAudits[index]['is_complete']);
                                var archiveReport = vm.offlineRiskAudits[index]['is_complete'] || vm.offlineRiskAudits[index]['update_flag'] == 'REJECT';

                                if(report['status']) {
                                    vm.offlineRiskAudits[index].report_version = report['report_version'];
                                } else if(report['reason'] == 'complete' || report['reason'] == 'deleted') {
                                    //We move reports marked on the server as complete or deleted to archive, so they're not sent to the server again
                                    archiveReport = true;
                                } else if(report['reason'] == 'validation' || report['reason'] == 'failed_to_duplicate_report') {
                                    var failMsg = 'Report #' + vm.offlineRiskAudits[index].site_risk_audit_id + ((vm.offlineRiskAudits[index].reference_number != null && vm.offlineRiskAudits[index].reference_number.length > 0) ? (' (' + vm.offlineRiskAudits[index].reference_number + ')') : '') + ' failed to sync because of validation error (serverside). Please contact Support Team';
                                    vm.riskAuditsSyncErrors.push(failMsg);
                                    archiveReport = false;
                                }

                                if(archiveReport) {
                                    vm.riskAuditsToArchive.push(index);
                                }
                            });

                            await this.getDbNew().then(db => {
                                console.log('Retrieved DB object and can start updating reports');
                                //Make sure we await results here!!

                                var transaction = db.transaction([
                                    'risk_assessments',
                                    'risk_assessments_archived'
                                ], 'readwrite');

                                var riskAssessmentsStore = transaction.objectStore('risk_assessments');
                                var archivedRiskAssessmentsStore = transaction.objectStore('risk_assessments_archived');

                                //Test it!!
                                transaction.oncomplete = function (event) {
                                    console.log('Completed updating versions / moving reports to archive');
                                    if(!response.data.success) { //It's set to false only on validation error for at least one report
                                        vm.showRiskAuditsSyncErrors = true;
                                        reject('Failed to sync risk audit reports');
                                    } else {
                                        resolve();
                                    }
                                };

                                transaction.onerror = function (error) {
                                    reject(error);
                                };

                                console.log(vm.riskAuditsToArchive);
                                vm.offlineRiskAudits.forEach((riskAudit, index) => {
                                    console.log('Processing risk audit @ index #' + index);
                                    if(vm.riskAuditsToArchive.includes(index)) {
                                        var archiveRiskAuditRequest = archivedRiskAssessmentsStore.put(riskAudit);
                                        console.log('Setting up callback to remove old risk audit');
                                        archiveRiskAuditRequest.onsuccess = function() {
                                            var reportIdToDelete = riskAudit['site_risk_audit_id'];
                                            if(riskAudit['update_flag'] == 'SAVE_AS_NEW') {
                                                reportIdToDelete = riskAudit['old_site_risk_audit_id'];
                                            }
                                            console.log('Executing callback to remove old risk audit #'+ reportIdToDelete);
                                            riskAssessmentsStore.delete(reportIdToDelete);
                                        };
                                    } else {
                                        var saveRiskAuditRequest = riskAssessmentsStore.put(riskAudit);
                                        if(riskAudit['update_flag'] == 'SAVE_AS_NEW') {
                                            console.log('Setting up callback to remove old risk audit');
                                            saveRiskAuditRequest.onsuccess = function() {
                                                console.log('Executing callback to remove old risk audit #'+ riskAudit['old_site_risk_audit_id']);
                                                riskAssessmentsStore.delete(riskAudit['old_site_risk_audit_id']);
                                            };
                                        }
                                    }
                                });
                            }).catch(e => {
                                reject(e);
                            });  
                            
                            console.log('Continue to execute sync process after updating on-device reports');
                        } else {
                            resolve();
                        }
                    }).then(() => {
                        console.log('About to retrieve risk audits from database');

                        this.syncRasProgress = (this.syncRasProgress + rasBitPercentage);
                        this.isOfflineRiskAuditsPosted = true;

                        return axios.post(this.cmsUrl + 'api/v1/risk-audits/get-risk-audits.json', {}, {headers: {'Authorization': 'Bearer ' + this.userToken}});
                    });
                }).then(response => {
                    //console.log(response.data.risk_audits);
                    this.isRiskAuditsLoaded = true;
                    this.riskAudits = response.data.risk_audits;
                    return axios.get(this.cmsUrl + 'api/v1/workspace/details.json');
                }).then(response => {
                    this.syncRasProgress = (this.syncRasProgress + rasBitPercentage);
                    this.workspace = response.data.workspace;
                    this.isWorkspaceDetailsLoaded = true;
                    var vmts = this;
                    this.getDb(function onConnectedSaveAllTheThings(db) {

                        var transaction = db.transaction([
                            'workspace_details',
                            'dropdowns',
                            'risk_assessments',
                            'fra_report_types'
                        ], 'readwrite');

                        var workspaceDetailsStore = transaction.objectStore('workspace_details');
                        var dropdownsStore = transaction.objectStore('dropdowns');
                        var riskAssessmentsStore = transaction.objectStore('risk_assessments');
                        var fraReportTypesStore = transaction.objectStore('fra_report_types');

                        var vmt = vmts;
                        transaction.oncomplete = function (event) {
                            //console.log(vmt.riskAudits);
                            vmt.isRasSyncComplete = true;
                            vmt.riskAuditsSyncStarted = false;
                            vmt.syncsOpen = false;
                            vmt.initApi = true;
                            vmt.$session.set('has_done_full_sync', true);
                            vmt.$session.set('risk_audits_last_sync', new Date());
                            vmt.hasDoneFullSync = true;
                            window.setTimeout(vmt.reload, 5000);
                        };

                        transaction.onerror = function (error) {
                            console.log('Transaction failed');
                            console.log(error);
                            vmt.syncErrorDetails = error;
                            vmt.isRasSyncComplete = true;
                            vmt.riskAuditsSyncStarted = false;
                            vmt.syncError = true;
                        };

                        try {
                            var putWDRequest = workspaceDetailsStore.put({
                                workspace_id: vmt.workspace.workspace_id,
                                primary_colour: vmt.workspace.primary_colour,
                                primary_color_hover: vmt.workspace.primary_colour_hover,
                                secondary_colour: vmt.workspace.secondary_colour,
                                secondary_colour_hover: vmt.workspace.secondary_colour_hover,
                                workspace_name: vmt.workspace.workspace_name,
                                workspace_logo: vmt.workspace.workspace_logo,
                                workspace_favicon: vmt.workspace.workspace_favicon,
                                has_access_to_fire_door_audit: vmt.workspace.has_access_to_fire_door_audit,
                                has_access_to_risk_audit: vmt.workspace.has_access_to_risk_audit,
                                has_access_to_extinguisher_report: vmt.workspace.has_access_to_extinguisher_report,
                                has_access_to_fire_stopping_report: vmt.workspace.has_access_to_fire_stopping_report,
                                has_access_to_bae_system_report: vmt.workspace.has_access_to_bae_system_report,
                                has_access_to_door_installation_report: vmt.workspace.has_access_to_door_installation_report,
                                has_access_to_door_maintenance_report: vmt.workspace.has_access_to_door_maintenance_report
                            });
                            putWDRequest.onsuccess = function () {


                                vmt.isWorkspaceDetailsAdded = true;
                                // Sync add
                                vmt.syncRasProgress = (vmt.syncRasProgress + rasBitPercentage);
                            }
                        } catch (e) {
                            vmt.initApi = false;
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'RAIMPWorkspaceDetails';

                            console.log('Workspace deets failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.riskAuditsSyncStarted = false;
                        }

                        if (vmt.workspace.has_access_to_risk_audit) {
                            try {
                                dropdownsStore.clear();
                                if (vmt.dropdowns.length === 0) {
                                    vmt.isDropdownsZeroLength = true;
                                } else {
                                    for (var di in vmt.dropdowns) {
                                        var putDropdownRequest = dropdownsStore.put({
                                            dropdown_id: vmt.dropdowns[di]['dropdown_id'],
                                            question_id: vmt.dropdowns[di]['question_id'],
                                            dropdown: vmt.dropdowns[di]['dropdown'],
                                            colour: vmt.dropdowns[di]['colour'],
                                        });
                                    }
                                    putDropdownRequest.onsuccess = function () {
                                        vmt.isDropdownsPosted = true;
                                    }
                                }

                                fraReportTypesStore.clear();
                                if (vmt.fra_report_types.length > 0) {
                                    for (var rti in vmt.fra_report_types) {
                                        fraReportTypesStore.put({
                                            fra_report_type_id: vmt.fra_report_types[rti]['fra_report_type_id'],
                                            fra_report_type_name: vmt.fra_report_types[rti]['fra_report_type_name']
                                        });
                                    }
                                }

                                // Sync add
                                vmt.syncRasProgress = (vmt.syncRasProgress + rasBitPercentage);
                            } catch (e) {
                                vmt.initApiError = e;
                                vmt.initApiErrorStage = 'IMPDropdowns';

                                console.log('Dropdowns failed');
                                console.log(e);
                                vmt.syncErrorDetails = e;
                                vmt.syncError = true;
                                vmt.riskAuditsSyncStarted = false;
                            }
                        }

                        if (vmt.workspace.has_access_to_risk_audit) {
                            try {
                                if (vmt.riskAudits.length === 0) {
                                    vmt.isRiskAuditZeroLength = true;
                                    vmt.riskAuditConflicts = [];
                                    riskAssessmentsStore.openCursor().onsuccess = function (event) {
                                        var cursor = event.target.result;

                                        if (cursor) {
                                            var record = cursor.value;
                                            record.status_changed = false;
                                            cursor.update(record);
                                            cursor.continue();
                                        }
                                    };
                                } else {
                                    for (var ra in vmt.riskAudits) {
                                        //console.log('Processing downloaded record: ', vmt.riskAudits[ra]['site_risk_audit_id']);
                                        vmt.riskAudits[ra]['site_risk_audit_id'] = parseInt(vmt.riskAudits[ra]['site_risk_audit_id']);
                                        vmt.riskAudits[ra]['offline_images'] = [];
                                        for (var rap in vmt.riskAudits[ra]['ra_photos']) {
                                            vmt.riskAudits[ra]['ra_photos'][rap]['photo_url'] = vmt.cmsUrl + vmt.riskAudits[ra]['ra_photos'][rap]['photo_url'];
                                        }
                                        var putRiskAuditsRequest = riskAssessmentsStore.put(vmt.riskAudits[ra]);
                                    }
                                    putRiskAuditsRequest.onsuccess = function () {
                                        //console.log('Risk Assessment added, now updating status_changed field..');
                                        riskAssessmentsStore.openCursor().onsuccess = function (event) {
                                            var cursor = event.target.result;

                                            if (cursor) {
                                                var record = cursor.value;
                                                record.status_changed = false;
                                                //console.log('Updating record: ', record['site_risk_audit_id']);
                                                cursor.update(record);
                                                cursor.continue();
                                            }
                                        };
                                        vmt.isRiskAuditsAdded = true;
                                        vmt.riskAuditConflicts = [];
                                    }
                                }
                                // Sync add
                                vmt.syncRasProgress = (vmt.syncRasProgress + rasBitPercentage);
                            } catch (e) {
                                vmt.initApiError = e;
                                vmt.initApiErrorStage = 'IMPRiskAudits';

                                console.log('Risk Audits failed');
                                console.log(e);
                                vmt.syncErrorDetails = e;
                                vmt.syncError = true;
                                vmt.riskAuditsSyncStarted = false;
                            }
                        }
                    });

                }).catch(error => {
                    console.log('Axios failed?');
                    console.log(error);
                    this.syncErrorDetails = error;
                    this.isRasSyncComplete = true;
                    this.syncError = true;
                    this.riskAuditsSyncStarted = false;

                    this.initApiError = error;
                    this.initApiErrorStage = 'RAaxios';
                });
            },
            syncDoorApps(inBg) {
                if (navigator.onLine && !this.doorReportsSyncStarted) {

                    this.doorReportsSyncStarted = true;
                    this.isSyncComplete = false;
                    this.isSyncing = inBg !== true;
                    this.isSyncingInBg = inBg === true;
                    this.syncProgress = 0;

                    this.isWorkspaceDetailsLoaded = false;
                    this.isWorkspaceDetailsAdded = false;
                    this.isDoorMaterialsLoaded = false;
                    this.isDoorMaterialsAdded = false;
                    this.isFrameMaterialsLoaded = false;
                    this.isFrameMaterialsAdded = false;
                    this.isLocationsLoaded = false;
                    this.isLocationsAdded = false;
                    this.iSubstrateTypesLoaded = false;
                    this.iSubstrateTypesAdded = false;
                    this.isDoorSetsLoaded = false;
                    this.isDoorSetsAdded = false;
                    this.isDoorTypesLoaded = false;
                    this.isDoorTypesAdded = false;
                    this.isReportConfigLoaded = false;
                    this.isReportConfigAdded = false;
                    this.isDoorFaultsLoaded = false;
                    this.isDoorFaultsAdded = false;
                    this.isDoorChecksLoaded = false;
                    this.isDoorChecksAdded = false;
                    this.isDoorCheckSitePlansLoaded = false;
                    this.isDoorCheckSitePlansAdded = false;
                    this.isDoorCheckDoorsLoaded = false;
                    this.isDoorCheckDoorsAdded = false;
                    this.isOfflineDoorChecksPosted = false;
                    this.isOfflineDoorCheckSitePlansPosted = false;
                    this.isAdditionalDoorFieldsOptionsLoaded = false;
                    this.isDeclaredResistanceLevelsAdded = false;
                    this.isLevelOptionsAdded = false;
                    this.isClientDefinedRatingsAdded = false;
                    this.isCpiScheduleItemsAdded = false;

                    this.showDoorReportsSyncErrors = false;
                    this.submittedDoorReportsConflictForm = false;
                    this.doorReportsConflicts = [];
                    this.doorReportsSyncErrors = [];
                    this.doorReportsToArchive = [];
                    this.doorReportSitePlansToArchive = [];
                    this.doorsToArchive = [];

                    var vmts = this;
                    this.getDb(function onConnected(db) {
                        vmts.initDb = true;

                        var uploadTransaction = db.transaction([
                            'door_checks',
                            'door_check_site_plans',
                            'door_check_doors',
                        ]);

                        var localDoorChecksStore = uploadTransaction.objectStore('door_checks');
                        var localDoorCheckSitePlansStore = uploadTransaction.objectStore('door_check_site_plans');
                        var localdoorCheckDoorsStore = uploadTransaction.objectStore('door_check_doors');

                        var vm = vmts;
                        vm.getUserToken();

                        uploadTransaction.oncomplete = function (event) {
                            if (vm.offlineDoorCheckSitePlans.length === 0) {
                                vm.isDoorCheckSitePlansZeroLength = true;
                            }

                            if (vm.offlineDoorCheckDoors.length === 0) {
                                vm.isOfflineDoorChecksDoorZeroLength = true;
                            }

                            if (vm.offlineDoorChecks.length === 0) {
                                vm.isOfflineDoorChecksZeroLength = true;
                                vm.performActualDoorReportsSync();
                            } else {
                                var reportsVersions = [];
                                vm.offlineDoorChecks.forEach(doorReport => {
                                    var reportVersion = null;
                                    if(doorReport.hasOwnProperty('report_version')) {
                                        reportVersion = doorReport.report_version;
                                    }
                                    reportsVersions.push({
                                        'site_door_check_id': doorReport.site_door_check_id,
                                        'report_version': reportVersion
                                    });
                                });

                                axios.post(vm.cmsUrl + 'api/v1/door-checks/check-versions.json', reportsVersions, {headers: {'Authorization': 'Bearer ' + vm.userToken}})
                                .then(response => {
                                    console.log('Received response from check-versions');
                                    //Go through records and check if there are conflicts, if so then display options, otherwise continue
                                    if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                                        response.data.data.forEach((report, index) => {
                                            var localReportVersion = reportsVersions[index]['report_version'];
                                            var remoteReportVersion = report['report_version'];

                                            vm.offlineDoorChecks[index].update_flag = 'OVERWRITE';

                                            if(remoteReportVersion != null && localReportVersion != remoteReportVersion) {
                                                vm.offlineDoorChecks[index].remote_report_version = remoteReportVersion;
                                                vm.doorReportsConflicts.push(index);
                                            }
                                        });

                                        console.log('Number of door reports to sync: ' + vm.doorReportsConflicts.length)

                                        if(vm.doorReportsConflicts.length == 0) {
                                            vm.performActualDoorReportsSync();
                                        }
                                    } else {
                                        console.log('Server returned invalid response while verifying versions of reports');
                                        throw 'Server returned invalid response while verifying versions of reports';
                                    }
                                })
                                .catch(e => {
                                    console.log('Catched error: ' + e);
                                    vm.syncErrorDetails = e;
                                    vm.isSyncComplete = true;
                                    vm.doorReportsSyncStarted = false;
                                    vm.syncError = true;
                                });
                            }
                        };

                        uploadTransaction.onerror = function (error) {
                            vm.initApiError = error;
                            vm.initApiErrorStage = 'uploadTransaction';
                            console.log(error);
                        };

                        vm.offlineDoorChecks = [];
                        try {
                            if (localDoorChecksStore) {
                                localDoorChecksStore.openCursor().onsuccess = function (event) {
                                    var cursor = event.target.result;

                                    if (cursor) {
                                        if (vm.offlineDoorChecks) {
                                            vm.offlineDoorChecks.push(cursor.value)
                                        }
                                        cursor.continue();
                                    }
                                };
                            }

                        } catch (e) {
                            vm.initApiError = e;
                            vm.initApiErrorStage = 'offlineDoorChecks';
                            console.log(e);
                        }

                        vm.offlineDoorCheckSitePlans = [];
                        if(vm.canAccessSitePlansForFD()) {
                            try {
                                if (localDoorCheckSitePlansStore) {
                                    localDoorCheckSitePlansStore.openCursor().onsuccess = function (event) {
                                        var cursor = event.target.result;

                                        if (cursor) {
                                            if (vm.offlineDoorCheckSitePlans) {
                                                vm.offlineDoorCheckSitePlans.push(cursor.value);
                                            }
                                            cursor.continue();
                                        }
                                    };
                                }

                            } catch (e) {
                                vm.initApiError = e;
                                vm.initApiErrorStage = 'offlineDoorCheckSitePlans';
                                console.log(e);
                            }
                        }

                        vm.offlineDoorCheckDoors = [];
                        try {
                            if (localdoorCheckDoorsStore) {
                                localdoorCheckDoorsStore.openCursor().onsuccess = function (event) {
                                    var cursor = event.target.result;

                                    if (cursor) {
                                        if (vm.offlineDoorCheckDoors) {
                                            vm.offlineDoorCheckDoors.push(cursor.value)
                                        }
                                        cursor.continue();
                                    }
                                };
                            }

                        } catch (e) {
                            vm.initApiError = e;
                            vm.initApiErrorStage = 'offlineDoorCheckDoors';
                            console.log(e);
                            console.log(e);
                        }
                    });

                }
            },
            performActualDoorReportsSync() {
                console.log('Entered performActualDoorReportsSync()');
                var numberOfRequests = 14;

                if(this.canAccessSitePlansForFD()) {
                    numberOfRequests++;
                }
                if(this.canAccessBMTradaOptions()) {
                    numberOfRequests += 2;
                }

                var bitPerCentage = 100 / numberOfRequests;

                axios.post(this.cmsUrl + 'api/v1/door-checks/add-door-checks.json?ver=' + this.appNumericVersion, this.offlineDoorChecks, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                .then(response => {
                    console.log('Received response to add-door-checks');

                    return new Promise(async (resolve, reject) => { 
                        console.log('Entered promise after receiving response from add-door-checks')
                        if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                            console.log(response.data.data);
                            var vm = this;
                            response.data.data.forEach((report, index) => {
                                console.log('Report @ index ' + index + ' is complete? ' + vm.offlineDoorChecks[index]['is_complete']);
                                var archiveReport = vm.offlineDoorChecks[index]['is_complete'] || vm.offlineDoorChecks[index]['update_flag'] == 'REJECT';

                                if(report['status']) {
                                    vm.offlineDoorChecks[index].report_version = report['report_version'];
                                } else if(report['reason'] == 'complete' || report['reason'] == 'deleted') {
                                    //We move reports marked on the server as complete or deleted to archive, so they're not sent to the server again
                                    archiveReport = true;
                                    vm.invalidateDoorReportDoor(vm.offlineDoorChecks[index].site_door_check_id);
                                } else if(report['reason'] == 'validation' || report['reason'] == 'failed_to_duplicate_report') {
                                    var failMsg = 'Report #' + vm.offlineDoorChecks[index].site_door_check_id + ((vm.offlineDoorChecks[index].document_id != null && vm.offlineDoorChecks[index].document_id.length > 0) ? (' (' + vm.offlineDoorChecks[index].document_id + ')') : '') + ' failed to sync because of validation error (serverside). Please contact Support Team';
                                    vm.doorReportsSyncErrors.push(failMsg);
                                    archiveReport = false;
                                }

                                if(archiveReport) {
                                    vm.doorReportsToArchive.push(index);
                                }
                            });

                            await this.getDbNew().then(db => {
                                console.log('Retrieved DB object and can start updating door reports');

                                var transaction = db.transaction([
                                    'door_checks',
                                    'door_checks_archived'
                                ], 'readwrite');

                                var doorChecksStore = transaction.objectStore('door_checks');
                                var archivedDoorChecksStore= transaction.objectStore('door_checks_archived');

                                transaction.oncomplete = function (event) {
                                    console.log('Completed updating versions / moving door reports to archive');
                                    if(!response.data.success) { //It's set to false only on validation error for at least one report
                                        vm.showDoorReportsSyncErrors = true;
                                        reject('Failed to sync door reports');
                                    } else {
                                        resolve();
                                    }
                                };

                                transaction.onerror = function (error) {
                                    reject(error);
                                };

                                console.log(vm.doorReportsToArchive);
                                vm.offlineDoorChecks.forEach((doorsReport, index) => {
                                    console.log('Processing doors report @ index #' + index);
                                    if(vm.doorReportsToArchive.includes(index)) {
                                        var archiveDoorsReportRequest = archivedDoorChecksStore.put(doorsReport);
                                        console.log('Setting up callback to remove old doors report');
                                        archiveDoorsReportRequest.onsuccess = function() {
                                            var reportIdToDelete = doorsReport['site_door_check_id'];
                                            if(doorsReport['update_flag'] == 'SAVE_AS_NEW') {
                                                reportIdToDelete = doorsReport['old_site_door_check_id'];
                                            }
                                            console.log('Executing callback to remove old doors report #'+ reportIdToDelete);
                                            doorChecksStore.delete(reportIdToDelete);
                                        };
                                    } else {
                                        var saveDoorsReportRequest = doorChecksStore.put(doorsReport);
                                        if(doorsReport['update_flag'] == 'SAVE_AS_NEW') {
                                            console.log('Setting up callback to remove old doors report');
                                            saveDoorsReportRequest.onsuccess = function() {
                                                console.log('Executing callback to remove old doors report #'+ doorsReport['old_site_door_check_id']);
                                                doorChecksStore.delete(doorsReport['old_site_door_check_id']);
                                            };
                                        }
                                    }
                                });
                            }).catch(e => {
                                reject(e);
                            });  
                            
                            console.log('Continue to execute sync process after updating on-device doors reports');
                        } else {
                            resolve();
                        }
                    }).then(() => {
                        this.doorReportsConflicts = [];
                        this.isOfflineDoorChecksPosted = true;
                        this.syncProgress += bitPerCentage;
                        

                        if(this.canAccessSitePlansForFD()) {
                            console.log('About to save site plans to database');
                            return axios.post(this.cmsUrl + 'api/v1/door-checks/add-site-plans.json?ver=' + this.appNumericVersion, this.offlineDoorCheckSitePlans, {headers: {'Authorization': 'Bearer ' + this.userToken}});
                        } else {
                            return Promise.resolve([]);   
                        }

                    }).then(response => {
                        if(this.canAccessSitePlansForFD()) {
                            console.log('Received response to add-site-plans');

                            return new Promise(async (resolve, reject) => { 
                                console.log('Entered promise after receiving response from add-site-plans endpoint')
                                if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                                    var vm = this;
                                    vm.doorReportsSyncErrors = [];
                                    response.data.data.forEach((item, index) => {
                                        //console.log('Item @ index ' + index + ' is complete? ' + item['is_complete']);
                                        var archiveItem = item['is_complete'] || vm.offlineDoorCheckSitePlans[index]['update_flag'] == 'REJECT';

                                        if(!item['status'] && item['reason'] == 'validation') {
                                            var failMsg = 'Site Plan #' + vm.offlineDoorCheckSitePlans[index].site_fire_stopping_report_site_plan_id + ' failed to sync because of validation error (serverside). Please contact Support Team';
                                            vm.doorReportsSyncErrors.push(failMsg);
                                            archiveItem = false;
                                        }

                                        if(archiveItem) {
                                            vm.doorReportSitePlansToArchive.push(index);
                                        }
                                    });

                                    await this.getDbNew().then(db => {
                                        var transaction = db.transaction([
                                            'door_check_site_plans',
                                            'door_check_site_plans_archived'
                                        ], 'readwrite');

                                        var doorCheckSitePlansStore = transaction.objectStore('door_check_site_plans');
                                        var archivedDoorCheckSitePlansStoreStore = transaction.objectStore('door_check_site_plans_archived');

                                        transaction.oncomplete = function (event) {
                                            if(!response.data.success) {
                                                vm.showDoorReportsSyncErrors = true;
                                                reject('Failed to sync site plans');
                                            } else {
                                                resolve();
                                            }
                                        };

                                        transaction.onerror = function (error) {
                                            reject(error);
                                        };

                                        vm.offlineDoorCheckSitePlans.forEach((item, index) => {
                                            var updateFlag = item['update_flag'];
                                            item['update_flag'] = null;
                                            if(vm.doorReportSitePlansToArchive.includes(index)) {
                                                var archiveItemRequest = archivedDoorCheckSitePlansStoreStore.put(item);
                                                archiveItemRequest.onsuccess = function() {
                                                    var reportIdToDelete = item['site_door_check_site_plan_id'];
                                                    if(updateFlag == 'SAVE_AS_NEW') {
                                                        reportIdToDelete = item['old_site_door_check_site_plan_id'];
                                                    }
                                                    doorCheckSitePlansStore.delete(reportIdToDelete);
                                                };
                                            } else {
                                                var saveItemRequest = doorCheckSitePlansStore.put(item);
                                                if(updateFlag == 'SAVE_AS_NEW') {
                                                    saveItemRequest.onsuccess = function() {
                                                        doorCheckSitePlansStore.delete(item['old_site_door_check_site_plan_id']);
                                                    };
                                                }
                                            }
                                        });
                                    }).catch(e => {
                                        reject(e);
                                    });  
                                    
                                    console.log('Continue to execute sync process after updating on-device site plans');
                                } else {
                                    resolve();
                                }
                            });

                        } else {
                            return Promise.resolve();
                        } 
                    }).then(() => {
                        if(this.canAccessSitePlansForFD()) {
                            this.syncProgress += bitPerCentage;
                            this.isOfflineDoorCheckSitePlansPosted = true;
                        }

                        console.log('About to save doors to database');
                        return axios.post(this.cmsUrl + 'api/v1/door-checks/add-door-check-doors.json?ver=' + this.appNumericVersion, this.offlineDoorCheckDoors, {headers: {'Authorization': 'Bearer ' + this.userToken}});
                    }).then(response => {
                        console.log('Received response to add-door-check-doors');

                        return new Promise(async (resolve, reject) => { 
                            console.log('Entered promise after receiving response from add-door-check-doors endpoint')
                            if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                                console.log(response.data.data);
                                var vm = this;
                                vm.doorReportsSyncErrors = [];
                                response.data.data.forEach((door, index) => {
                                    console.log('Door @ index ' + index + ' is complete? ' + door['is_complete']);
                                    var archiveReport = door['is_complete'] || vm.offlineDoorCheckDoors[index]['update_flag'] == 'REJECT';

                                    if(!door['status'] && door['reason'] == 'validation') {
                                        var failMsg = 'Door #' + vm.offlineDoorCheckDoors[index].site_door_check_door_id + ((vm.offlineDoorCheckDoors[index].door_id != null && vm.offlineDoorCheckDoors[index].door_id.length > 0) ? (' (ID: ' + vm.offlineDoorCheckDoors[index].door_id + ')') : '') + ' failed to sync because of validation error (serverside). Please contact Support Team';
                                        vm.doorReportsSyncErrors.push(failMsg);
                                        archiveReport = false;
                                    }

                                    if(archiveReport) {
                                        vm.doorsToArchive.push(index);
                                    }
                                });

                                await this.getDbNew().then(db => {
                                    console.log('Retrieved DB object and can start updating doors');

                                    var transaction = db.transaction([
                                        'door_check_doors',
                                        'door_check_doors_archived'
                                    ], 'readwrite');

                                    var doorCheckDoorsStore = transaction.objectStore('door_check_doors');
                                    var archivedDoorCheckDoorsStore = transaction.objectStore('door_check_doors_archived');

                                    transaction.oncomplete = function (event) {
                                        console.log('Completed updating / moving doors to archive');
                                        if(!response.data.success) { //It's set to false only on validation error for at least one door
                                            vm.showDoorReportsSyncErrors = true;
                                            reject('Failed to sync doors');
                                        } else {
                                            resolve();
                                        }
                                    };

                                    transaction.onerror = function (error) {
                                        reject(error);
                                    };

                                    console.log(vm.doorsToArchive);
                                    vm.offlineDoorCheckDoors.forEach((door, index) => {
                                        var updateFlag = door['update_flag'];
                                        door['update_flag'] = null;
                                        console.log('Processing doors @ index #' + index);
                                        if(vm.doorsToArchive.includes(index)) {
                                            var archiveDoorRequest = archivedDoorCheckDoorsStore.put(door);
                                            console.log('Setting up callback to remove old door');
                                            archiveDoorRequest.onsuccess = function() {
                                                var reportIdToDelete = door['site_door_check_door_id'];
                                                if(updateFlag == 'SAVE_AS_NEW') {
                                                    reportIdToDelete = door['old_site_door_check_door_id'];
                                                }
                                                console.log('Executing callback to remove old door #'+ reportIdToDelete);
                                                doorCheckDoorsStore.delete(reportIdToDelete);
                                            };
                                        } else {
                                            var saveDoorRequest = doorCheckDoorsStore.put(door);
                                            if(updateFlag == 'SAVE_AS_NEW') {
                                                console.log('Setting up callback to remove old door');
                                                saveDoorRequest.onsuccess = function() {
                                                    console.log('Executing callback to remove old door #'+ door['old_site_door_check_door_id']);
                                                    doorCheckDoorsStore.delete(door['old_site_door_check_door_id']);
                                                };
                                            }
                                        }
                                    });
                                }).catch(e => {
                                    reject(e);
                                });  
                                
                                console.log('Continue to execute sync process after updating on-device doors');
                            } else {
                                resolve();
                            }
                        }).then(() => {
                            console.log('About to get workspace details from database');

                            this.isOfflineDoorCheckDoorsPosted = true;
                            // Sync add
                            this.syncProgress += bitPerCentage;
                            return axios.get(this.cmsUrl + 'api/v1/workspace/details.json');
                        });    
                    });
                }).then(response => {
                    // Sync add
                    this.syncProgress += bitPerCentage;
                    this.workspace = response.data.workspace;
                    this.isWorkspaceDetailsLoaded = true;
                    return axios.get(this.cmsUrl + 'api/v1/workspace/door-materials.json', {headers: {'Authorization': 'Bearer ' + this.userToken}});
                }).then(response => {
                    // Sync add
                    this.syncProgress += bitPerCentage;
                    this.isDoorMaterialsLoaded = true;
                    this.door_materials = response.data.door_materials;
                    return axios.get(this.cmsUrl + 'api/v1/workspace/frame-materials.json', {headers: {'Authorization': 'Bearer ' + this.userToken}});
                })
                .then(response => {
                    // Sync add
                    this.syncProgress += bitPerCentage;
                    this.isFrameMaterialsLoaded = true;
                    this.frame_materials = response.data.frame_materials;
                    return axios.get(this.cmsUrl + 'api/v1/workspace/door-sets.json', {headers: {'Authorization': 'Bearer ' + this.userToken}});
                })
                .then(response => {
                    // Sync add
                    this.syncProgress += bitPerCentage;
                    this.isDoorSetsLoaded = true;
                    this.door_sets = response.data.door_sets;
                    return axios.get(this.cmsUrl + 'api/v1/workspace/door-faults.json', {headers: {'Authorization': 'Bearer ' + this.userToken}});
                })
                .then(response => {
                    // Sync add
                    this.syncProgress += bitPerCentage;
                    this.isDoorFaultsLoaded = true;
                    this.doorFaults = response.data.door_faults;
                    return axios.get(this.cmsUrl + 'api/v1/workspace/locations.json', {headers: {'Authorization': 'Bearer ' + this.userToken}});
                })
                .then(response => {
                    // Sync add
                    this.syncProgress += bitPerCentage;
                    this.isLocationsLoaded = true;
                    this.locations = response.data.locations;
                    return axios.get(this.cmsUrl + 'api/v1/workspace/substrate-types.json', {headers: {'Authorization': 'Bearer ' + this.userToken}});
                })
                .then(response => {
                    // Sync add
                    this.syncProgress += bitPerCentage;
                    this.iSubstrateTypesLoaded = true;
                    this.substrateTypes = response.data.substrate_types;
                    return axios.get(this.cmsUrl + 'api/v1/door-checks/door-check-report-configuration.json', {headers: {'Authorization': 'Bearer ' + this.userToken}});
                })
                .then(response => {
                    // Sync add
                    this.syncProgress += bitPerCentage;
                    this.isReportConfigLoaded = true;
                    this.door_check_report_configurations = response.data.door_check_report_configuration;
                    return axios.get(this.cmsUrl + 'api/v1/workspace/door-types.json', {headers: {'Authorization': 'Bearer ' + this.userToken}});
                })
                .then(response => {
                    // Sync add
                    this.syncProgress += bitPerCentage;
                    this.isDoorTypesLoaded = true;
                    this.door_types = response.data.door_types;

                    if(this.canAccessBMTradaOptions()) {
                        return axios.get(this.cmsUrl + 'api/v1/workspace/additional-door-fields-options.json', {headers: {'Authorization': 'Bearer ' + this.userToken}});
                    } else {
                        return Promise.resolve([]);   
                    }
                })
                .then(response => {
                    if(this.canAccessBMTradaOptions()) {
                        this.syncProgress += bitPerCentage;
                        this.declared_resistance_levels = response.data.declared_resistance_levels;
                        this.level_options = response.data.level_options;
                        this.client_defined_ratings = response.data.client_defined_ratings;
                        this.cpi_schedule_items = response.data.cpi_schedule_items;
                        this.isAdditionalDoorFieldsOptionsLoaded = true;
                    } 

                    return axios.post(this.cmsUrl + 'api/v1/door-checks/incomplete.json', {}, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                })
                .then(response => {
                    // Sync add
                    this.syncProgress += bitPerCentage;
                    this.isDoorChecksLoaded = true;
                    this.door_checks = response.data.incomplete_surveys;


                    if(this.canAccessSitePlansForFD()) {
                        return axios.post(this.cmsUrl + 'api/v1/door-checks/incomplete-site-plans.json', {}, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                    } else {
                        return Promise.resolve([]);   
                    }
                    
                }).then(response => {
                    if(this.canAccessSitePlansForFD()) {
                        this.syncProgress += bitPerCentage;
                        this.door_check_site_plans = response.data.site_plans;
                        this.isDoorCheckSitePlansLoaded = true;
                    } 

                    return axios.post(this.cmsUrl + 'api/v1/door-check-doors/all-door-check-doors.json', {}, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                }).then(response => {
                    // Sync add
                    this.syncProgress += bitPerCentage;
                    this.isDoorCheckDoorsLoaded = true;
                    this.door_check_doors = response.data.door_check_doors;

                    var vmts = this;
                    this.getDb(function onConnectedSaveAllTheThings(db) {

                        var transaction = db.transaction([
                            'workspace_details',
                            'door_materials',
                            'frame_materials',
                            'door_sets',
                            'door_faults',
                            'locations',
                            'substrate_types',
                            'door_materials',
                            'door_checks',
                            'door_check_site_plans',
                            'door_check_doors',
                            'door_check_report_configurations',
                            'door_types',
                            'declared_resistance_levels',
                            'level_options',
                            'client_defined_ratings',
                            'cpi_schedule_items'
                        ], 'readwrite');

                        var workspaceDetailsStore = transaction.objectStore('workspace_details');
                        var doorMaterialsStore = transaction.objectStore('door_materials');
                        var frameMaterialsStore = transaction.objectStore('frame_materials');
                        var doorSetsStore = transaction.objectStore('door_sets');
                        var doorFaultsStore = transaction.objectStore('door_faults');
                        var locationsStore = transaction.objectStore('locations');
                        var substrateTypesStore = transaction.objectStore('substrate_types');
                        var reportConfigurationStore = transaction.objectStore('door_check_report_configurations');
                        var doorChecksStore = transaction.objectStore('door_checks');
                        var doorCheckSitePlansStore = transaction.objectStore('door_check_site_plans');
                        var doorCheckDoorsStore = transaction.objectStore('door_check_doors');
                        var doorTypesStore = transaction.objectStore('door_types');
                        var declaredResistanceLevelsStore = transaction.objectStore('declared_resistance_levels');
                        var levelOptionsStore = transaction.objectStore('level_options');
                        var clientDefinedRatingsStore = transaction.objectStore('client_defined_ratings');
                        var cpiScheduleItemsStore = transaction.objectStore('cpi_schedule_items');

                        var vmt = vmts;
                        transaction.oncomplete = function (event) {
                            vmt.isSyncComplete = true;
                            vmt.doorReportsSyncStarted = false;
                            vmt.syncsOpen = false;
                            vmt.initApi = true;
                            vmt.$session.set('has_done_full_sync', true);
                            vmt.$session.set('doors_last_sync', new Date());
                            vmt.hasDoneFullSync = true;
                            window.setTimeout(vmt.reload, 5000);
                        };

                        transaction.onerror = function (error) {
                            console.log('Transaction failed');
                            console.log(error);
                            vmt.syncErrorDetails = error;
                            vmt.isSyncComplete = true;
                            vmt.doorReportsSyncStarted = false;
                            vmt.syncError = true;
                        };

                        try {
                            var putWDRequest = workspaceDetailsStore.put({
                                workspace_id: vmt.workspace.workspace_id,
                                primary_colour: vmt.workspace.primary_colour,
                                primary_color_hover: vmt.workspace.primary_colour_hover,
                                secondary_colour: vmt.workspace.secondary_colour,
                                secondary_colour_hover: vmt.workspace.secondary_colour_hover,
                                workspace_name: vmt.workspace.workspace_name,
                                workspace_logo: vmt.workspace.workspace_logo,
                                workspace_favicon: vmt.workspace.workspace_favicon,
                                last_updated: new Date(),
                                risk_audit_last_updated: vmt.workspace.risk_audit_last_updated,
                                has_access_to_fire_door_audit: vmt.workspace.has_access_to_fire_door_audit,
                                has_access_to_risk_audit: vmt.workspace.has_access_to_risk_audit,
                                has_access_to_extinguisher_report: vmt.workspace.has_access_to_extinguisher_report,
                                has_access_to_fire_stopping_report: vmt.workspace.has_access_to_fire_stopping_report,
                                has_access_to_bae_system_report: vmt.workspace.has_access_to_bae_system_report,
                                has_access_to_door_installation_report: vmt.workspace.has_access_to_door_installation_report,
                                has_access_to_door_maintenance_report: vmt.workspace.has_access_to_door_maintenance_report
                            });
                            putWDRequest.onsuccess = function () {
                                vmt.isWorkspaceDetailsAdded = true;
                                // Sync add
                                vmt.syncProgress = (vmt.syncProgress + bitPerCentage);
                            }
                        } catch (e) {
                            vmt.initApi = false;
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPWorkspaceDetails';

                            console.log('Workspace deets failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.doorReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.door_materials.length === 0) {
                                vmt.isDoorMaterialsZeroLength = true;
                            } else {
                                for (var i in vmt.door_materials) {
                                    var putDMRquest = doorMaterialsStore.put({
                                        door_material_id: vmt.door_materials[i]['door_material_id'],
                                        material_name: vmt.door_materials[i]['material_name'],
                                    });
                                }
                                putDMRquest.onsuccess = function () {
                                    vmt.isDoorMaterialsAdded = true;
                                }
                            }
                            // Sync add
                            vmt.syncProgress = (vmt.syncProgress + bitPerCentage);
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPDoorMaterials';

                            console.log('Door materials failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.doorReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.frame_materials.length === 0) {
                                vmt.isFrameMaterialsZeroLength = true;
                            } else {
                                for (var i in vmt.frame_materials) {
                                    var putFMRequest = frameMaterialsStore.put({
                                        frame_material_id: vmt.frame_materials[i]['frame_material_id'],
                                        material_name: vmt.frame_materials[i]['material_name'],
                                    });
                                }
                                putFMRequest.onsuccess = function () {
                                    vmt.isFrameMaterialsAdded = true;
                                }
                            }
                            // Sync add
                            vmt.syncProgress = (vmt.syncProgress + bitPerCentage);
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPFrameMaterials';

                            console.log('Frame materials failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.doorReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.door_sets.length === 0) {
                                vmt.isDoorSetsZeroLength = true;
                            } else {
                                for (var i in vmt.door_sets) {
                                    var putDSRequest = doorSetsStore.put({
                                        door_set_id: vmt.door_sets[i]['door_set_id'],
                                        door_set_name: vmt.door_sets[i]['door_set_name'],
                                    });
                                }
                                putDSRequest.onsuccess = function () {
                                    vmt.isDoorSetsAdded = true;
                                }
                            }
                            // Sync add
                            vmt.syncProgress = (vmt.syncProgress + bitPerCentage);
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPDoorSets';

                            console.log('Door sets failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.doorReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.doorFaults.length === 0) {
                                vmt.isDoorFaultsZeroLength = true;
                            } else {
                                for (var i in vmt.doorFaults) {
                                    var putDFRequest = doorFaultsStore.put({
                                        door_fault_id: vmt.doorFaults[i]['door_fault_id'],
                                        fault_description: vmt.doorFaults[i]['fault_description'],
                                        fault_code: vmt.doorFaults[i]['fault_code'],
                                        door_part: vmt.doorFaults[i]['door_part'],
                                    });
                                }
                                putDFRequest.onsuccess = function () {
                                    vmt.isDoorFaultsAdded = true;
                                }
                            }
                            // Sync add
                            vmt.syncProgress = (vmt.syncProgress + bitPerCentage);
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPDoorFaults';

                            console.log('Door faults failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.doorReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.locations.length === 0) {
                                vmt.isLocationsZeroLength = true;
                            } else {
                                for (var i in vmt.locations) {
                                    var putLocationsRequest = locationsStore.put({
                                        location_id: vmt.locations[i]['location_id'],
                                        location_name: vmt.locations[i]['location_name'],
                                    });
                                }
                                putLocationsRequest.onsuccess = function () {
                                    vmt.isLocationsAdded = true;
                                }
                            }
                            // Sync add
                            vmt.syncProgress = (vmt.syncProgress + bitPerCentage);
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPLocations';

                            console.log('Locations failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.doorReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.substrateTypes.length === 0) {
                                vmt.isSubstrateTypesZeroLength = true;
                            } else {
                                for (var i in vmt.substrateTypes) {
                                    var putSTRequest = substrateTypesStore.put({
                                        substrate_type_id: vmt.substrateTypes[i]['substrate_type_id'],
                                        substrate_type_name: vmt.substrateTypes[i]['substrate_type_name'],
                                    });
                                }
                                putSTRequest.onsuccess = function () {
                                    vmt.iSubstrateTypesAdded = true;
                                }
                            }
                            // Sync add
                            vmt.syncProgress = (vmt.syncProgress + bitPerCentage);
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPSubstrateTypes';

                            console.log('Substrate types failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.doorReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.door_checks.length === 0) {
                                vmt.isDoorChecksZeroLength = true;
                            } else {
                                for (var i in vmt.door_checks) {
                                    var putDoorCheckRequest = doorChecksStore.put({
                                        site_door_check_id: parseInt(vmt.door_checks[i]['site_door_check_id']),
                                        client_site: vmt.door_checks[i]['client_site'],
                                        rma_form_sequential_ref_no: vmt.door_checks[i]['rma_form_sequential_ref_no'] !== undefined ? vmt.door_checks[i]['rma_form_sequential_ref_no'] : null,
                                        created: vmt.door_checks[i]['created'],
                                        date_of_inspection: vmt.door_checks[i]['date_of_inspection'],
                                        disclaimer: vmt.door_checks[i]['disclaimer'],
                                        client_provided_info_schedule: vmt.door_checks[i]['client_provided_info_schedule'],
                                        prepared_by: vmt.door_checks[i]['prepared_by'],
                                        edited_by: vmt.door_checks[i]['edited_by'],
                                        document_id: vmt.door_checks[i]['document_id'],
                                        document_title: vmt.door_checks[i]['document_title'],
                                        door_check_doors: vmt.door_checks[i]['door_check_doors'],
                                        pdf_link: vmt.door_checks[i]['door_check_pdfs'] !== undefined && vmt.door_checks[i]['door_check_pdfs'][0] !== undefined && vmt.door_checks[i]['door_check_pdfs'][0]['file_name'] !== undefined ? vmt.door_checks[i]['door_check_pdfs'][0]['file_name'] : null,
                                        door_check_id: vmt.door_checks[i]['door_check_id'],
                                        include_notes_on_report: vmt.door_checks[i]['include_notes_on_report'],
                                        is_report_unbranded: vmt.door_checks[i]['is_report_unbranded'],
                                        use_bm_trada_template: vmt.door_checks[i]['use_bm_trada_template'] !== undefined ? vmt.door_checks[i]['use_bm_trada_template'] : false,
                                        is_third_party_report: vmt.door_checks[i]['is_third_party_report'] !== undefined ? vmt.door_checks[i]['is_third_party_report'] : false,
                                        location: vmt.door_checks[i]['location'],
                                        country: vmt.door_checks[i]['country'] !== undefined ? vmt.door_checks[i]['country'] : 'England',
                                        modified: vmt.door_checks[i]['modified'],
                                        notes: vmt.door_checks[i]['notes'],
                                        user: vmt.door_checks[i]['user'],
                                        user_id: vmt.door_checks[i]['user_id'],
                                        client_signature_image: vmt.door_checks[i]['client_signature_image'],
                                        offline_client_signature_image: null,
                                        engineer_signature_image: vmt.door_checks[i]['engineer_signature_image'],
                                        offline_engineer_signature_image: null,
                                        client_signed_by: vmt.door_checks[i]['client_signed_by'],
                                        report_version: vmt.door_checks[i]['report_version'],
                                    });
                                }
                                putDoorCheckRequest.onsuccess = function () {
                                    vmt.isDoorChecksAdded = true;
                                }
                            }
                            // Sync add
                            vmt.syncProgress = (vmt.syncProgress + bitPerCentage);
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPDoorChecksImport';

                            console.log('Door checks failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.doorReportsSyncStarted = false;
                        }

                        if(vmt.canAccessSitePlansForFD()) {
                            try {
                                if (vmt.door_check_site_plans.length === 0) {
                                    vmt.isDoorCheckSitePlansZeroLength = true;
                                    vmt.syncProgress += bitPerCentage;
                                } else {
                                    for (var i in vmt.door_check_site_plans) {
                                        var putDoorCheckSitePlansRequest = doorCheckSitePlansStore.put({
                                            door_check_site_plan_id: vmt.door_check_site_plans[i]['door_check_site_plan_id'],
                                            site_door_check_site_plan_id: parseInt(vmt.door_check_site_plans[i]['site_door_check_site_plan_id']),
                                            site_door_check_id: parseInt(vmt.door_check_site_plans[i]['site_door_check_id']),
                                            door_check_report_id: vmt.door_check_site_plans[i]['door_check_report_id'],
                                            site_plan_title: vmt.door_check_site_plans[i]['site_plan_title'],
                                            site_plan_image: vmt.door_check_site_plans[i]['site_plan_image'],
                                            offline_site_plan_image: null
                                        });
                                    }
                                    putDoorCheckSitePlansRequest.onsuccess = function () {
                                        vmt.isDoorCheckSitePlansAdded = true;
                                        vmt.syncProgress += bitPerCentage;
                                    }
                                }
                            } catch (e) {
                                vmt.initApiError = e;
                                vmt.initApiErrorStage = 'IMPDoorCheckSitePlansImport';

                                console.log('FDR Site Plans failed');
                                console.log(e);
                                vmt.syncErrorDetails = e;
                                vmt.syncError = true;
                                vmt.doorReportsSyncStarted = false;
                            }
                        }

                        try {
                            if (vmt.door_check_doors === null || vmt.door_check_doors === undefined || vmt.door_check_doors.length === 0) {
                                console.log('Just kill me now.');
                                vmt.isDoorCheckDoorsZeroLength = true;
                            } else {
                                for (var i in vmt.door_check_doors) {
                                    console.log(vmt.door_check_doors[i]['door_check_door_id']);
                                    var putDoorCheckDoorRequest = doorCheckDoorsStore.put({
                                        door_check_door_id: vmt.door_check_doors[i]['door_check_door_id'],
                                        site_door_check_door_id: parseInt(vmt.door_check_doors[i]['site_door_check_door_id']),
                                        site_door_check_id: parseInt(vmt.door_check_doors[i]['site_door_check_id']),
                                        door_check_id: vmt.door_check_doors[i]['door_check_id'],
                                        site_door_check_site_plan_id: vmt.door_check_doors[i]['site_door_check_site_plan_id'] !== undefined ? vmt.door_check_doors[i]['site_door_check_site_plan_id'] : null,
                                        door_check_site_plan_id: vmt.door_check_doors[i]['door_check_site_plan_id'] !== undefined ? vmt.door_check_doors[i]['door_check_site_plan_id'] : null,
                                        site_plan_image_position_x: vmt.door_check_doors[i]['site_plan_image_position_x'] !== undefined ? vmt.door_check_doors[i]['site_plan_image_position_x'] : null,
                                        site_plan_image_position_y: vmt.door_check_doors[i]['site_plan_image_position_y'] !== undefined ? vmt.door_check_doors[i]['site_plan_image_position_y'] : null,
                                        site_plan_image_zoom_level: vmt.door_check_doors[i]['site_plan_image_zoom_level'] !== undefined ? vmt.door_check_doors[i]['site_plan_image_zoom_level'] : null,
                                        pin_number: vmt.door_check_doors[i]['pin_number'] !== undefined ? vmt.door_check_doors[i]['pin_number'] : null,
                                        door_id: vmt.door_check_doors[i]['door_id'],
                                        barcode: vmt.door_check_doors[i]['barcode'],
                                        door_type: vmt.door_check_doors[i]['door_type'],
                                        client_defined_rating: vmt.door_check_doors[i]['client_defined_rating'] !== undefined ? vmt.door_check_doors[i]['client_defined_rating'] : null,
                                        door_location: vmt.door_check_doors[i]['door_location'],
                                        glazing_panels: vmt.door_check_doors[i]['glazing_panels'],
                                        glazing_panels_number: vmt.door_check_doors[i]['glazing_panels_number'],
                                        glazing_panels_sizes: vmt.door_check_doors[i]['glazing_panels_sizes'],
                                        glazing_panels_type: vmt.door_check_doors[i]['glazing_panels_type'] !== undefined ? vmt.door_check_doors[i]['glazing_panels_type'] : null,
                                        substrate_type: vmt.door_check_doors[i]['substrate_type'],
                                        door_inspected_by: vmt.door_check_doors[i]['door_inspected_by'] !== undefined ? vmt.door_check_doors[i]['door_inspected_by'] : null,
                                        gap_head: vmt.door_check_doors[i]['gap_head'],
                                        gap_closing_edge: vmt.door_check_doors[i]['gap_closing_edge'],
                                        gap_meeting_edge: vmt.door_check_doors[i]['gap_meeting_edge'],
                                        gap_hinge_edge_1: vmt.door_check_doors[i]['gap_hinge_edge_1'],
                                        gap_hinge_edge_2: vmt.door_check_doors[i]['gap_hinge_edge_2'],
                                        gap_still: vmt.door_check_doors[i]['gap_still'],
                                        door_material: vmt.door_check_doors[i]['door_material'],
                                        frame_material: vmt.door_check_doors[i]['frame_material'],
                                        declared_resistance_level: vmt.door_check_doors[i]['declared_resistance_level'] !== undefined ? vmt.door_check_doors[i]['declared_resistance_level'] : null,
                                        level: vmt.door_check_doors[i]['level'] !== undefined ? vmt.door_check_doors[i]['level'] : null,
                                        plugs_labels_present: vmt.door_check_doors[i]['plugs_labels_present'] !== undefined ? vmt.door_check_doors[i]['plugs_labels_present'] : false,
                                        test_evidence_available: vmt.door_check_doors[i]['test_evidence_available'] !== undefined ? vmt.door_check_doors[i]['test_evidence_available'] : false,
                                        dimensions: vmt.door_check_doors[i]['dimensions'],
                                        door_set: vmt.door_check_doors[i]['door_set'],
                                        frame_pass_status: vmt.door_check_doors[i]['frame_pass_status'],
                                        frame_pass_additional_comments: vmt.door_check_doors[i]['frame_pass_additional_comments'],
                                        hinge_pass_status: vmt.door_check_doors[i]['hinge_pass_status'],
                                        hinge_pass_additional_comments: vmt.door_check_doors[i]['hinge_pass_additional_comments'],
                                        lock_pass_status: vmt.door_check_doors[i]['lock_pass_status'],
                                        lock_pass_additional_comments: vmt.door_check_doors[i]['lock_pass_additional_comments'],
                                        glass_pass_status: vmt.door_check_doors[i]['glass_pass_status'],
                                        glass_pass_additional_comments: vmt.door_check_doors[i]['glass_pass_additional_comments'],
                                        seals_pass_status: vmt.door_check_doors[i]['seals_pass_status'],
                                        seals_pass_additional_comments: vmt.door_check_doors[i]['seals_pass_additional_comments'],
                                        closer_pass_status: vmt.door_check_doors[i]['closer_pass_status'],
                                        closer_pass_additional_comments: vmt.door_check_doors[i]['closer_pass_additional_comments'],
                                        structure_pass_status: vmt.door_check_doors[i]['structure_pass_status'],
                                        structure_pass_additional_comments: vmt.door_check_doors[i]['structure_pass_additional_comments'],
                                        signage_pass_status: vmt.door_check_doors[i]['signage_pass_status'],
                                        signage_pass_additional_comments: vmt.door_check_doors[i]['signage_pass_additional_comments'],
                                        gaps_pass_status: vmt.door_check_doors[i]['gaps_pass_status'],
                                        gaps_pass_additional_comments: vmt.door_check_doors[i]['gaps_pass_additional_comments'],
                                        additional_inspector_notes: vmt.door_check_doors[i]['additional_inspector_notes'],
                                        include_inspector_notes_on_report: vmt.door_check_doors[i]['include_inspector_notes_on_report'],
                                        door_status: vmt.door_check_doors[i]['door_status'] !== undefined ? vmt.door_check_doors[i]['door_status'] : null,
                                        installation_date: vmt.door_check_doors[i]['installation_date'] !== undefined ? vmt.door_check_doors[i]['installation_date'] : null,
                                        installation_comments: vmt.door_check_doors[i]['installation_comments'] !== undefined ? vmt.door_check_doors[i]['installation_comments'] : null,
                                        installed_by: vmt.door_check_doors[i]['installed_by'] !== undefined ? vmt.door_check_doors[i]['installed_by'] : null,
                                        engineer_signature_image: vmt.door_check_doors[i]['engineer_signature_image'] !== undefined ? vmt.door_check_doors[i]['engineer_signature_image'] : null,
                                        audit_date: vmt.door_check_doors[i]['audit_date'] !== undefined ? vmt.door_check_doors[i]['audit_date'] : null,
                                        audit_comments: vmt.door_check_doors[i]['audit_comments'] !== undefined ? vmt.door_check_doors[i]['audit_comments'] : null,
                                        audited_by: vmt.door_check_doors[i]['audited_by'] !== undefined ? vmt.door_check_doors[i]['audited_by'] : null,
                                        sign_off_signature_image: vmt.door_check_doors[i]['sign_off_signature_image'] !== undefined ? vmt.door_check_doors[i]['sign_off_signature_image'] : null,
                                        user_id: vmt.door_check_doors[i]['user_id'],
                                        door_check: vmt.door_check_doors[i]['door_check'],
                                        any_faults: vmt.door_check_doors[i]['any_faults'],
                                        frame_faults: vmt.door_check_doors[i]['frame_faults'],
                                        hinge_faults: vmt.door_check_doors[i]['hinge_faults'],
                                        lock_faults: vmt.door_check_doors[i]['lock_faults'],
                                        glass_faults: vmt.door_check_doors[i]['glass_faults'],
                                        seals_faults: vmt.door_check_doors[i]['seals_faults'],
                                        closer_faults: vmt.door_check_doors[i]['closer_faults'],
                                        structure_faults: vmt.door_check_doors[i]['structure_faults'],
                                        signage_faults: vmt.door_check_doors[i]['signage_faults'],
                                        gaps_faults: vmt.door_check_doors[i]['gaps_faults'],
                                        door_check_door_images: vmt.door_check_doors[i]['door_check_door_images'],
                                        actioned_faults: vmt.door_check_doors[i]['actioned_faults'] !== undefined ? vmt.door_check_doors[i]['actioned_faults'] : [],
                                        offline_images: [],
                                        offline_engineer_signature_image: null,
                                        offline_sign_off_signature_image: null
                                    });
                                }

                            }
                            vmt.isDoorCheckDoorsAdded = true;
                            // Sync add
                            vmt.syncProgress = (vmt.syncProgress + bitPerCentage);
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'DoorCheckDoorsImport';

                            console.log('Door check doors failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.doorReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.door_types.length === 0) {
                                vmt.isDoorTypesZeroLength = true;
                            } else {
                                for (var i in vmt.door_types) {
                                    var putRequest = doorTypesStore.put({
                                        door_type_id: vmt.door_types[i]['door_type_id'],
                                        door_type_name: vmt.door_types[i]['door_type_name'],
                                    });
                                }
                                putRequest.onsuccess = function () {
                                    vmt.isDoorTypesAdded = true;
                                }
                            }
                            // Sync add
                            vmt.syncProgress = (vmt.syncProgress + bitPerCentage);
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'DoorTypes';

                            console.log('Door types failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.doorReportsSyncStarted = false;
                        }

                        try {
                            var putDCRCRequest = reportConfigurationStore.put({
                                door_check_report_configuration_id: vmt.door_check_report_configurations['door_check_report_configuration_id'],
                                default_disclaimer: vmt.door_check_report_configurations['default_disclaimer'],
                                default_disclaimer_scotland: vmt.door_check_report_configurations['default_disclaimer_scotland'],
                                confidentiality_statement: vmt.door_check_report_configurations['confidentiality_statement'],
                                default_inspector_notes_per_door: vmt.door_check_report_configurations['default_inspector_notes_per_door'] 
                            });
                            putDCRCRequest.onsuccess = function () {
                                vmt.isReportConfigAdded = true;
                                // Sync add
                                vmt.syncProgress = (vmt.syncProgress + bitPerCentage);
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'DCRC';

                            console.log('Report config failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.doorReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.declared_resistance_levels !== undefined && vmt.declared_resistance_levels.length > 0) {
                                for (var i in vmt.declared_resistance_levels) {
                                    var putRequest = declaredResistanceLevelsStore.put({
                                        declared_resistance_level_id: vmt.declared_resistance_levels[i]['declared_resistance_level_id'],
                                        declared_resistance_level_title: vmt.declared_resistance_levels[i]['declared_resistance_level_title'],
                                    });
                                }
                                putRequest.onsuccess = function () {
                                    vmt.isDeclaredResistanceLevelsAdded = true;
                                }
                            }
                            // Sync add
                            vmt.syncProgress = (vmt.syncProgress + bitPerCentage);
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'DeclaredResistanceLevels';

                            console.log('Declared Resistance Levels failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.doorReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.client_defined_ratings !== undefined && vmt.client_defined_ratings.length > 0) {
                                for (var i in vmt.client_defined_ratings) {
                                    var putRequest = clientDefinedRatingsStore.put({
                                        client_defined_rating_id: vmt.client_defined_ratings[i]['client_defined_rating_id'],
                                        client_defined_rating_name: vmt.client_defined_ratings[i]['client_defined_rating_name'],
                                    });
                                }
                                putRequest.onsuccess = function () {
                                    vmt.isClientDefinedRatingsAdded = true;
                                }
                            }
                            // Sync add
                            vmt.syncProgress = (vmt.syncProgress + bitPerCentage);
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'ClientDefinedRatings';

                            console.log('Level Options failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.doorReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.level_options !== undefined && vmt.level_options.length > 0) {
                                for (var i in vmt.level_options) {
                                    var putRequest = levelOptionsStore.put({
                                        level_option_id: vmt.level_options[i]['level_option_id'],
                                        level_option_title: vmt.level_options[i]['level_option_title'],
                                    });
                                }
                                putRequest.onsuccess = function () {
                                    vmt.isLevelOptionsAdded = true;
                                }
                            }
                            // Sync add
                            vmt.syncProgress = (vmt.syncProgress + bitPerCentage);
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'LevelOptions';

                            console.log('Level Options failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.doorReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.cpi_schedule_items !== undefined && vmt.cpi_schedule_items.length > 0) {
                                for (var i in vmt.cpi_schedule_items) {
                                    var putRequest = cpiScheduleItemsStore.put({
                                        cpi_schedule_item_id: vmt.cpi_schedule_items[i]['cpi_schedule_item_id'],
                                        cpi_schedule_item_title: vmt.cpi_schedule_items[i]['cpi_schedule_item_title'],
                                    });
                                }
                                putRequest.onsuccess = function () {
                                    vmt.isCpiScheduleItemsAdded = true;
                                }
                            }
                            // Sync add
                            vmt.syncProgress = (vmt.syncProgress + bitPerCentage);
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'CpiScheduleItems';

                            console.log('CPI Schedule Items failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.doorReportsSyncStarted = false;
                        }


                    });
                }).catch(error => {
                    console.log('Axios failed?');
                    console.log(error);
                    this.syncErrorDetails = error;
                    this.isSyncComplete = true;
                    this.syncError = true;
                    this.doorReportsSyncStarted = false;

                    this.initApiError = error;
                    this.initApiErrorStage = 'axios';
                });
            },
            syncExtinguisherReports(inBg) {
                if (navigator.onLine && !this.extinguisherReportsSyncStarted) {

                    this.extinguisherReportsSyncStarted = true;
                    this.isErSyncComplete = false;
                    this.isErSyncing = inBg !== true;
                    this.isErSyncingInBg = inBg === true;
                    this.syncErsProgress = 0;
                    this.syncError = false;
                    this.syncErrorDetails = '';

                    this.isWorkspaceDetailsLoaded = false;
                    this.isWorkspaceDetailsAdded = false;
                    this.isExtinguisherOptionsLoaded = false;
                    this.isExtinguisherCapacitiesAdded = false;
                    this.isExtinguisherFinishesAdded = false;
                    this.isExtinguisherPositionsAdded = false;
                    this.isExtinguisherTypesAdded = false;
                    this.isOfflineExtinguisherReportsPosted = false;
                    this.isOfflineExtinguishersPosted = false;
                    this.isExtinguisherReportsLoaded = false;
                    this.isExtinguishersLoaded = false;
                    this.isExtinguisherReportsAdded = false;
                    this.isExtinguishersAdded = false;

                    this.showExtinguisherReportsSyncErrors = false;
                    this.submittedExtinguisherReportsConflictForm = false;
                    this.extinguisherReportsConflicts = [];
                    this.extinguisherReportsErrors = [];
                    this.extinguisherReportsToArchive = [];
                    this.extinguishersToArchive = [];

                    var vmts = this;
                    this.getDb(function onConnected(db) {
                        vmts.initDb = true;

                        var uploadTransaction = db.transaction([
                            'extinguisher_reports',
                            'extinguisher_report_items',
                        ]);

                        var localextinguisherReportsStore = uploadTransaction.objectStore('extinguisher_reports');
                        var localextinguisherReportItemsStore = uploadTransaction.objectStore('extinguisher_report_items');

                        var vm = vmts;
                        vm.getUserToken();

                        uploadTransaction.oncomplete = function (event) {
                            if (vm.offlineExtinguishers.length === 0) {
                                vm.isExtinguishersZeroLength = true;
                            }

                            if (vm.offlineExtinguisherReports.length === 0) {
                                vm.isExtinguisherReportsZeroLength = true;
                                vm.performActualExtinguisherReportsSync();
                            } else {
                                var reportsVersions = [];
                                vm.offlineExtinguisherReports.forEach(extinguisherReport => {
                                    var reportVersion = null;
                                    if(extinguisherReport.hasOwnProperty('report_version')) {
                                        reportVersion = extinguisherReport.report_version;
                                    }
                                    reportsVersions.push({
                                        'site_extinguisher_report_id': extinguisherReport.site_extinguisher_report_id,
                                        'report_version': reportVersion
                                    });
                                });

                                axios.post(vm.cmsUrl + 'api/v1/extinguisher-reports/check-versions.json', reportsVersions, {headers: {'Authorization': 'Bearer ' + vm.userToken}})
                                .then(response => {
                                    console.log('Received response from check-versions');
                                    //Go through records and check if there are conflicts, if so then display options, otherwise continue
                                    if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                                        response.data.data.forEach((report, index) => {
                                            var localReportVersion = reportsVersions[index]['report_version'];
                                            var remoteReportVersion = report['report_version'];

                                            vm.offlineExtinguisherReports[index].update_flag = 'OVERWRITE';

                                            if(remoteReportVersion != null && localReportVersion != remoteReportVersion) {
                                                vm.offlineExtinguisherReports[index].remote_report_version = remoteReportVersion;
                                                vm.extinguisherReportsConflicts.push(index);
                                            }
                                        });

                                        console.log('Number of conflicts during sync: ' + vm.extinguisherReportsConflicts.length)

                                        if(vm.extinguisherReportsConflicts.length == 0) {
                                            vm.performActualExtinguisherReportsSync();
                                        }
                                    } else {
                                        console.log('Server returned invalid response while verifying versions of reports');
                                        throw 'Server returned invalid response while verifying versions of reports';
                                    }
                                })
                                .catch(e => {
                                    console.log('Catched error: ' + e);
                                    vm.syncErrorDetails = e;
                                    vm.isErSyncComplete = true;
                                    vm.extinguisherReportsSyncStarted = false;
                                    vm.syncError = true;
                                });
                            }
                        };

                        uploadTransaction.onerror = function (error) {
                            vm.initApiError = error;
                            vm.initApiErrorStage = 'uploadTransaction';
                            console.log(error);
                        };

                        vm.offlineExtinguisherReports = [];
                        try {
                            if (localextinguisherReportsStore) {
                                localextinguisherReportsStore.openCursor().onsuccess = function (event) {
                                    var cursor = event.target.result;

                                    if (cursor) {
                                        if (vm.offlineExtinguisherReports) {
                                            vm.offlineExtinguisherReports.push(cursor.value)
                                        }
                                        cursor.continue();
                                    }
                                };
                            }

                        } catch (e) {
                            vm.initApiError = e;
                            vm.initApiErrorStage = 'offlineExtinguisherReports';
                            console.log(e);
                        }

                        vm.offlineExtinguishers = [];
                        try {
                            if (localextinguisherReportItemsStore) {
                                localextinguisherReportItemsStore.openCursor().onsuccess = function (event) {
                                    var cursor = event.target.result;

                                    if (cursor) {
                                        if (vm.offlineExtinguishers) {
                                            vm.offlineExtinguishers.push(cursor.value)
                                        }
                                        cursor.continue();
                                    }
                                };
                            }

                        } catch (e) {
                            vm.initApiError = e;
                            vm.initApiErrorStage = 'offlineExtinguishers';
                            console.log(e);
                            console.log(e);
                        }
                    });

                }
            },
            performActualExtinguisherReportsSync() {
                console.log('Entered performActualExtinguisherReportsSync()');
                var bitPerCentage = 7.69; 

                axios.post(this.cmsUrl + 'api/v1/extinguisher-reports/add-reports.json?ver=' + this.appNumericVersion, this.offlineExtinguisherReports, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                .then(response => {
                    console.log('Received response to add-reports');

                    return new Promise(async (resolve, reject) => { 
                        console.log('Entered promise after receiving response from add-reports')
                        if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                            console.log(response.data.data);
                            var vm = this;
                            response.data.data.forEach((report, index) => {
                                console.log('Report @ index ' + index + ' is complete? ' + vm.offlineExtinguisherReports[index]['is_complete']);
                                var archiveReport = vm.offlineExtinguisherReports[index]['is_complete'] || vm.offlineExtinguisherReports[index]['update_flag'] == 'REJECT';

                                if(report['status']) {
                                    vm.offlineExtinguisherReports[index].report_version = report['report_version'];
                                } else if(report['reason'] == 'complete' || report['reason'] == 'deleted') {
                                    //We move reports marked on the server as complete or deleted to archive, so they're not sent to the server again
                                    archiveReport = true;
                                    vm.invalidateExtinguisherReport(vm.offlineExtinguisherReports[index].site_extinguisher_report_id);
                                } else if(report['reason'] == 'validation' || report['reason'] == 'failed_to_duplicate_report') {
                                    var failMsg = 'Report #' + vm.offlineExtinguisherReports[index].site_extinguisher_report_id + ((vm.offlineExtinguisherReports[index].job_number != null && vm.offlineExtinguisherReports[index].job_number.length > 0) ? (' (' + vm.offlineExtinguisherReports[index].job_number + ')') : '') + ' failed to sync because of validation error (serverside). Please contact Support Team';
                                    vm.extinguisherReportsErrors.push(failMsg);
                                    archiveReport = false;
                                }

                                if(archiveReport) {
                                    vm.extinguisherReportsToArchive.push(index);
                                }
                            });

                            await this.getDbNew().then(db => {
                                console.log('Retrieved DB object and can start updating extinguisher reports');

                                var transaction = db.transaction([
                                    'extinguisher_reports',
                                    'extinguisher_reports_archived'
                                ], 'readwrite');

                                var extinguisherReportsStore = transaction.objectStore('extinguisher_reports');
                                var archivedExtinguisherReportsStore = transaction.objectStore('extinguisher_reports_archived');

                                transaction.oncomplete = function (event) {
                                    console.log('Completed updating versions / moving extinguisher reports to archive');
                                    if(!response.data.success) { //It's set to false only on validation error for at least one report
                                        vm.showExtinguisherReportsSyncErrors = true;
                                        reject('Failed to sync extinguisher reports');
                                    } else {
                                        resolve();
                                    }
                                };

                                transaction.onerror = function (error) {
                                    reject(error);
                                };

                                console.log(vm.extinguisherReportsToArchive);
                                vm.offlineExtinguisherReports.forEach((extinguisherReport, index) => {
                                    console.log('Processing extinguisher report @ index #' + index);
                                    if(vm.extinguisherReportsToArchive.includes(index)) {
                                        var archiveExtinguisherReportRequest = archivedExtinguisherReportsStore.put(extinguisherReport);
                                        console.log('Setting up callback to remove old extinguisher report');
                                        archiveExtinguisherReportRequest.onsuccess = function() {
                                            var reportIdToDelete = extinguisherReport['site_extinguisher_report_id'];
                                            if(extinguisherReport['update_flag'] == 'SAVE_AS_NEW') {
                                                reportIdToDelete = extinguisherReport['old_site_extinguisher_report_id'];
                                            }
                                            console.log('Executing callback to remove old extinguisher report #'+ reportIdToDelete);
                                            extinguisherReportsStore.delete(reportIdToDelete);
                                        };
                                    } else {
                                        var saveExtinguisherReportRequest = extinguisherReportsStore.put(extinguisherReport);
                                        if(extinguisherReport['update_flag'] == 'SAVE_AS_NEW') {
                                            console.log('Setting up callback to remove old extinguisher report');
                                            saveExtinguisherReportRequest.onsuccess = function() {
                                                console.log('Executing callback to remove old extinguisher report #'+ extinguisherReport['old_site_extinguisher_report_id']);
                                                extinguisherReportsStore.delete(extinguisherReport['old_site_extinguisher_report_id']);
                                            };
                                        }
                                    }
                                });
                            }).catch(e => {
                                reject(e);
                            });  
                            
                            console.log('Continue to execute sync process after updating on-device extinguisher reports');
                        } else {
                            resolve();
                        }
                    }).then(() => {
                        this.extinguisherReportsConflicts = [];
                        console.log('About to save extinguishers to database');

                        this.isOfflineExtinguisherReportsPosted = true;
                        // Sync add
                        this.syncErsProgress += bitPerCentage;
                        return axios.post(this.cmsUrl + 'api/v1/extinguisher-reports/add-report-items.json?ver=' + this.appNumericVersion, this.offlineExtinguishers, {headers: {'Authorization': 'Bearer ' + this.userToken}});
                    }).then(response => {
                        console.log('Received response to add-report-items');

                        return new Promise(async (resolve, reject) => { 
                            console.log('Entered promise after receiving response from add-report-items endpoint')
                            if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                                console.log(response.data.data);
                                var vm = this;
                                vm.extinguisherReportsErrors = [];
                                response.data.data.forEach((extinguisher, index) => {
                                    console.log('Extinguisher @ index ' + index + ' is complete? ' + extinguisher['is_complete']);
                                    var archiveReport = extinguisher['is_complete'] || vm.offlineExtinguishers[index]['update_flag'] == 'REJECT';

                                    if(!extinguisher['status'] && extinguisher['reason'] == 'validation') {
                                        var failMsg = 'Extinguisher #' + vm.offlineExtinguishers[index].site_extinguisher_report_item_id + ((vm.offlineExtinguishers[index].extinguisher_identifier != null && vm.offlineExtinguishers[index].extinguisher_identifier.length > 0) ? (' (ID: ' + vm.offlineExtinguishers[index].extinguisher_identifier + ')') : '') + ' failed to sync because of validation error (serverside). Please contact Support Team';
                                        vm.extinguisherReportsErrors.push(failMsg);
                                        archiveReport = false;
                                    }

                                    if(archiveReport) {
                                        vm.extinguishersToArchive.push(index);
                                    }
                                });

                                await this.getDbNew().then(db => {
                                    console.log('Retrieved DB object and can start updating extinguishers');

                                    var transaction = db.transaction([
                                        'extinguisher_report_items',
                                        'extinguisher_report_items_archived'
                                    ], 'readwrite');

                                    var extinguisherReportItemsStore = transaction.objectStore('extinguisher_report_items');
                                    var archivedExtinguisherReportItemsStore = transaction.objectStore('extinguisher_report_items_archived');

                                    transaction.oncomplete = function (event) {
                                        console.log('Completed updating / moving extinguishers to archive');
                                        if(!response.data.success) { //It's set to false only on validation error for at least one extinguisher
                                            vm.showExtinguisherReportsSyncErrors = true;
                                            reject('Failed to sync extinguishers');
                                        } else {
                                            resolve();
                                        }
                                    };

                                    transaction.onerror = function (error) {
                                        reject(error);
                                    };

                                    console.log(vm.extinguishersToArchive);
                                    vm.offlineExtinguishers.forEach((extinguisher, index) => {
                                        var updateFlag = extinguisher['update_flag'];
                                        extinguisher['update_flag'] = null;
                                        console.log('Processing extinguisher @ index #' + index);
                                        if(vm.extinguishersToArchive.includes(index)) {
                                            var archiveExtinguisherRequest = archivedExtinguisherReportItemsStore.put(extinguisher);
                                            console.log('Setting up callback to remove old extinguisher');
                                            archiveExtinguisherRequest.onsuccess = function() {
                                                var reportIdToDelete = extinguisher['site_extinguisher_report_item_id'];
                                                if(updateFlag == 'SAVE_AS_NEW') {
                                                    reportIdToDelete = extinguisher['old_site_extinguisher_report_item_id'];
                                                }
                                                console.log('Executing callback to remove old extinguisher #'+ reportIdToDelete);
                                                extinguisherReportItemsStore.delete(reportIdToDelete);
                                            };
                                        } else {
                                            var saveExtinguisherRequest = extinguisherReportItemsStore.put(extinguisher);
                                            if(updateFlag == 'SAVE_AS_NEW') {
                                                console.log('Setting up callback to remove old extinguisher');
                                                saveExtinguisherRequest.onsuccess = function() {
                                                    console.log('Executing callback to remove old extinguisher #'+ extinguisher['old_site_extinguisher_report_item_id']);
                                                    extinguisherReportItemsStore.delete(extinguisher['old_site_extinguisher_report_item_id']);
                                                };
                                            }
                                        }
                                    });
                                }).catch(e => {
                                    reject(e);
                                });  
                                
                                console.log('Continue to execute sync process after updating on-device extinguishers');
                            } else {
                                resolve();
                            }
                        }).then(() => {
                            console.log('About to get workspace details from database');

                            this.isOfflineExtinguishersPosted = true;
                            // Sync add
                            this.syncErsProgress += bitPerCentage;
                            return axios.get(this.cmsUrl + 'api/v1/workspace/details.json');
                        });    
                    });
                }).then(response => {
                    // Sync add
                    this.syncErsProgress += bitPerCentage;
                    this.workspace = response.data.workspace;
                    this.isWorkspaceDetailsLoaded = true;
                    return axios.get(this.cmsUrl + 'api/v1/workspace/extinguishers-options.json', {headers: {'Authorization': 'Bearer ' + this.userToken}});
                }).then(response => {
                    // Sync add
                    this.syncErsProgress += bitPerCentage;
                    this.isExtinguisherOptionsLoaded = true;
                    this.extinguisher_options = response.data;
                    return axios.post(this.cmsUrl + 'api/v1/extinguisher-reports/incomplete.json', {}, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                })
                .then(response => {
                    // Sync add
                    this.syncErsProgress += bitPerCentage;
                    this.isExtinguisherReportsLoaded = true;
                    this.extinguisher_reports = response.data.reports;
                    return axios.post(this.cmsUrl + 'api/v1/extinguisher-reports/incomplete-extinguishers.json', {}, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                })
                .then(response => {
                    // Sync add
                    this.syncErsProgress += bitPerCentage;
                    this.isExtinguishersLoaded = true;
                    this.extinguishers = response.data.extinguishers;

                    var vmts = this;
                    this.getDb(function onConnectedSaveAllTheThings(db) {

                        var transaction = db.transaction([
                            'workspace_details',
                            'extinguisher_capacities',
                            'extinguisher_finishes',
                            'extinguisher_positions',
                            'extinguisher_types',
                            'extinguisher_reports',
                            'extinguisher_report_items'
                        ], 'readwrite');

                        var workspaceDetailsStore = transaction.objectStore('workspace_details');
                        var extinguisherCapacitiesStore = transaction.objectStore('extinguisher_capacities');
                        var extinguisherFinishesStore = transaction.objectStore('extinguisher_finishes');
                        var extinguisherPositionsStore = transaction.objectStore('extinguisher_positions');
                        var extinguisherTypesStore = transaction.objectStore('extinguisher_types');
                        var extinguisherReportsStore = transaction.objectStore('extinguisher_reports');
                        var extinguisherReportItemsStore = transaction.objectStore('extinguisher_report_items');

                        var vmt = vmts;
                        transaction.oncomplete = function (event) {
                            vmt.isErSyncComplete = true;
                            vmt.extinguisherReportsSyncStarted = false;
                            vmt.syncsOpen = false;
                            vmt.initApi = true;
                            vmt.hasDoneFullSync = true;
                            vmt.$session.set('has_done_full_sync', true);
                            vmt.$session.set('extinguisher_reports_last_sync', new Date());
                            window.setTimeout(vmt.reload, 5000);
                        };

                        transaction.onerror = function (error) {
                            console.log('Transaction failed');
                            console.log(error);
                            vmt.syncErrorDetails = error;
                            vmt.isErSyncComplete = true;
                            vmt.extinguisherReportsSyncStarted = false;
                            vmt.syncError = true;
                        };

                        try {
                            var putWDRequest = workspaceDetailsStore.put({
                                workspace_id: vmt.workspace.workspace_id,
                                primary_colour: vmt.workspace.primary_colour,
                                primary_color_hover: vmt.workspace.primary_colour_hover,
                                secondary_colour: vmt.workspace.secondary_colour,
                                secondary_colour_hover: vmt.workspace.secondary_colour_hover,
                                workspace_name: vmt.workspace.workspace_name,
                                workspace_logo: vmt.workspace.workspace_logo,
                                workspace_favicon: vmt.workspace.workspace_favicon,
                                last_updated: new Date(),
                                risk_audit_last_updated: vmt.workspace.risk_audit_last_updated,
                                has_access_to_fire_door_audit: vmt.workspace.has_access_to_fire_door_audit,
                                has_access_to_risk_audit: vmt.workspace.has_access_to_risk_audit,
                                has_access_to_extinguisher_report: vmt.workspace.has_access_to_extinguisher_report,
                                has_access_to_fire_stopping_report: vmt.workspace.has_access_to_fire_stopping_report,
                                has_access_to_bae_system_report: vmt.workspace.has_access_to_bae_system_report,
                                has_access_to_door_installation_report: vmt.workspace.has_access_to_door_installation_report,
                                has_access_to_door_maintenance_report: vmt.workspace.has_access_to_door_maintenance_report
                            });
                            putWDRequest.onsuccess = function () {
                                vmt.isWorkspaceDetailsAdded = true;
                                // Sync add
                                vmt.syncErsProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApi = false;
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPWorkspaceDetails';

                            console.log('Workspace deets failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.extinguisherReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.extinguisher_options.hasOwnProperty('extinguisher_capacities') && vmt.extinguisher_options['extinguisher_capacities'].length > 0) {
                                for (var i in vmt.extinguisher_options['extinguisher_capacities']) {
                                    var putECRequest = extinguisherCapacitiesStore.put({
                                        extinguisher_capacity_id: vmt.extinguisher_options['extinguisher_capacities'][i]['extinguisher_capacity_id'],
                                        extinguisher_capacity_name: vmt.extinguisher_options['extinguisher_capacities'][i]['extinguisher_capacity_name'],
                                    });
                                }
                                putECRequest.onsuccess = function () {
                                    vmt.isExtinguisherCapacitiesAdded = true;
                                    vmt.syncErsProgress += bitPerCentage;
                                }
                            } else {
                                vmt.isExtinguisherCapacitiesAdded = true;
                                vmt.syncErsProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPExtinguisherCapacities';

                            console.log('Extinguisher capacities failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.extinguisherReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.extinguisher_options.hasOwnProperty('extinguisher_finishes') && vmt.extinguisher_options['extinguisher_finishes'].length > 0) {
                                for (var i in vmt.extinguisher_options['extinguisher_finishes']) {
                                    var putEFRequest = extinguisherFinishesStore.put({
                                        extinguisher_finish_id: vmt.extinguisher_options['extinguisher_finishes'][i]['extinguisher_finish_id'],
                                        extinguisher_finish_name: vmt.extinguisher_options['extinguisher_finishes'][i]['extinguisher_finish_name'],
                                    });
                                }
                                putEFRequest.onsuccess = function () {
                                    vmt.isExtinguisherFinishesAdded = true;
                                    vmt.syncErsProgress += bitPerCentage;
                                }
                            } else {
                                vmt.isExtinguisherFinishesAdded = true;
                                vmt.syncErsProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPExtinguisherFinishes';

                            console.log('Extinguisher finishes failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.extinguisherReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.extinguisher_options.hasOwnProperty('extinguisher_positions') && vmt.extinguisher_options['extinguisher_positions'].length > 0) {
                                for (var i in vmt.extinguisher_options['extinguisher_positions']) {
                                    var putEPRequest = extinguisherPositionsStore.put({
                                        extinguisher_position_id: vmt.extinguisher_options['extinguisher_positions'][i]['extinguisher_position_id'],
                                        extinguisher_position_name: vmt.extinguisher_options['extinguisher_positions'][i]['extinguisher_position_name'],
                                    });
                                }
                                putEPRequest.onsuccess = function () {
                                    vmt.isExtinguisherPositionsAdded = true;
                                    vmt.syncErsProgress += bitPerCentage;
                                }
                            } else {
                                vmt.isExtinguisherPositionsAdded = true;
                                vmt.syncErsProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPExtinguisherPositions';

                            console.log('Extinguisher positions failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.extinguisherReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.extinguisher_options.hasOwnProperty('extinguisher_types') && vmt.extinguisher_options['extinguisher_types'].length > 0) {
                                for (var i in vmt.extinguisher_options['extinguisher_types']) {
                                    var putETRequest = extinguisherTypesStore.put({
                                        extinguisher_type_id: vmt.extinguisher_options['extinguisher_types'][i]['extinguisher_type_id'],
                                        extinguisher_type_name: vmt.extinguisher_options['extinguisher_types'][i]['extinguisher_type_name'],
                                    });
                                }
                                putETRequest.onsuccess = function () {
                                    vmt.isExtinguisherTypesAdded = true;
                                    vmt.syncErsProgress += bitPerCentage;
                                }
                            } else {
                                vmt.isExtinguisherTypesAdded = true;
                                vmt.syncErsProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPExtinguisherTypes';

                            console.log('Extinguisher types failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.extinguisherReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.extinguisher_reports.length === 0) {
                                vmt.isExtinguisherReportsZeroLength = true;
                                vmt.syncErsProgress += bitPerCentage;
                            } else {
                                for (var i in vmt.extinguisher_reports) {
                                    var putExtinguisherReportRequest = extinguisherReportsStore.put({
                                        extinguisher_report_id: vmt.extinguisher_reports[i]['extinguisher_report_id'],
                                        site_extinguisher_report_id: parseInt(vmt.extinguisher_reports[i]['site_extinguisher_report_id']),
                                        job_number: vmt.extinguisher_reports[i]['job_number'],
                                        date_of_inspection: vmt.extinguisher_reports[i]['date_of_inspection'],
                                        prepared_for: vmt.extinguisher_reports[i]['prepared_for'],
                                        site_address: vmt.extinguisher_reports[i]['site_address'],
                                        prepared_by: vmt.extinguisher_reports[i]['prepared_by'],
                                        tamper_tag_colour: vmt.extinguisher_reports[i]['tamper_tag_colour'] !== undefined ? vmt.extinguisher_reports[i]['tamper_tag_colour'] : null,
                                        bs5306_3_compliant: vmt.extinguisher_reports[i]['bs5306_3_compliant'] !== undefined ? vmt.extinguisher_reports[i]['bs5306_3_compliant'] : null,
                                        overall_notes: vmt.extinguisher_reports[i]['overall_notes'],
                                        cover_image: vmt.extinguisher_reports[i]['cover_image'],
                                        engineer_signature_image: vmt.extinguisher_reports[i]['engineer_signature_image'],
                                        client_signature_image: vmt.extinguisher_reports[i]['client_signature_image'],
                                        pdf_link: vmt.extinguisher_reports[i]['extinguisher_report_pdfs'] !== undefined && vmt.extinguisher_reports[i]['extinguisher_report_pdfs'][0] !== undefined && vmt.extinguisher_reports[i]['extinguisher_report_pdfs'][0]['file_name'] !== undefined ? vmt.extinguisher_reports[i]['extinguisher_report_pdfs'][0]['file_name'] : null,
                                        user_id: vmt.extinguisher_reports[i]['user_id'],
                                        report_version: vmt.extinguisher_reports[i]['report_version'],
                                        offline_cover_image: null,
                                        offline_engineer_signature_image: null,
                                        offline_client_signature_image: null,
                                        client_signed_by: vmt.extinguisher_reports[i]['client_signed_by'],
                                        client_signed_date: vmt.extinguisher_reports[i]['client_signed_date'],
                                    });
                                }
                                putExtinguisherReportRequest.onsuccess = function () {
                                    vmt.isExtinguisherReportsAdded = true;
                                    vmt.syncErsProgress += bitPerCentage;
                                }
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPExtinguisherReportsImport';

                            console.log('Extinguisher reports failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.extinguisherReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.extinguishers.length === 0) {
                                vmt.isExtinguishersZeroLength = true;
                                vmt.syncErsProgress += bitPerCentage;
                            } else {
                                for (var i in vmt.extinguishers) {
                                    var putExtinguishersRequest = extinguisherReportItemsStore.put({
                                        extinguisher_report_item_id: vmt.extinguishers[i]['extinguisher_report_item_id'],
                                        site_extinguisher_report_item_id: parseInt(vmt.extinguishers[i]['site_extinguisher_report_item_id']),
                                        site_extinguisher_report_id: parseInt(vmt.extinguishers[i]['site_extinguisher_report_id']),
                                        extinguisher_report_id: vmt.extinguishers[i]['extinguisher_report_id'],
                                        extinguisher_identifier: vmt.extinguishers[i]['extinguisher_identifier'],
                                        extinguisher_location: vmt.extinguishers[i]['extinguisher_location'],
                                        extinguisher_type: vmt.extinguishers[i]['extinguisher_type'],
                                        extinguisher_capacity: vmt.extinguishers[i]['extinguisher_capacity'],
                                        extinguisher_finish: vmt.extinguishers[i]['extinguisher_finish'],
                                        extinguisher_position: vmt.extinguishers[i]['extinguisher_position'],
                                        weight_checked: vmt.extinguishers[i]['weight_checked'] !== undefined ? vmt.extinguishers[i]['weight_checked'] : null,
                                        tamper_tag_replaced: vmt.extinguishers[i]['tamper_tag_replaced'] !== undefined ? vmt.extinguishers[i]['tamper_tag_replaced'] : null,
                                        extinguisher_extended_service_date: vmt.extinguishers[i]['extinguisher_extended_service_date'],
                                        is_signage_present: vmt.extinguishers[i]['is_signage_present'],
                                        extinguisher_condition: vmt.extinguishers[i]['extinguisher_condition'],
                                        extinguisher_image: vmt.extinguishers[i]['extinguisher_image'],
                                        additional_comments: vmt.extinguishers[i]['additional_comments'],
                                        user_id: vmt.extinguishers[i]['user_id'],
                                        extinguisher_offline_image: null,
                                    });
                                }
                                putExtinguishersRequest.onsuccess = function () {
                                    vmt.isExtinguishersAdded = true;
                                    vmt.syncErsProgress += bitPerCentage;
                                }
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'ExtinguishersImport';

                            console.log('Extinguishers failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.extinguisherReportsSyncStarted = false;
                        }


                    });
                }).catch(error => {
                    console.log('Axios failed?');
                    console.log(error);
                    this.syncErrorDetails = error;
                    this.isErSyncComplete = true;
                    this.syncError = true;
                    this.extinguisherReportsSyncStarted = false;

                    this.initApiError = error;
                    this.initApiErrorStage = 'axios';
                });
            },
            syncFireStoppingReports(inBg) {
                if (navigator.onLine && !this.fireStoppingReportsSyncStarted) {

                    this.fireStoppingReportsSyncStarted = true;
                    this.isFsrSyncComplete = false;
                    this.isFsrSyncing = inBg !== true;
                    this.isFsrSyncingInBg = inBg === true;
                    this.syncFsrProgress = 0;
                    this.syncError = false;
                    this.syncErrorDetails = '';

                    this.isWorkspaceDetailsLoaded = false;
                    this.isWorkspaceDetailsAdded = false;
                    this.isFireStoppingReportOptionsLoaded = false;
                    this.isFsrFaultsAdded = false;
                    this.isFsrMaterialsAdded = false;
                    this.isFsrProductsAdded = false;
                    this.isFsrFireRatingsAdded = false;
                    this.isFsrSubstratesAdded = false;
                    this.isFsrConstructionTypesAdded = false;
                    this.isFsrThermalInsulationsAdded = false;
                    this.isOfflineFireStoppingReportsPosted = false;
                    this.isOfflineFireStoppingReportSitePlansPosted = false;
                    this.isOfflineFireStoppingReportItemsPosted = false;
                    this.isFireStoppingReportsLoaded = false;
                    this.isFireStoppingReportSitePlansLoaded = false;
                    this.isFireStoppingReportItemsLoaded = false;
                    this.isFireStoppingReportsAdded = false;
                    this.isFireStoppingReportSitePlansAdded = false;
                    this.isFireStoppingReportItemsAdded = false;

                    this.showFireStoppingReportsSyncErrors = false;
                    this.submittedFireStoppingReportsConflictForm = false;
                    this.fireStoppingReportsConflicts = [];
                    this.fireStoppingReportsErrors = [];
                    this.fireStoppingReportsToArchive = [];
                    this.fireStoppingReportSitePlansToArchive = [];
                    this.fireStoppingReportItemsToArchive = [];

                    var vmts = this;
                    this.getDb(function onConnected(db) {
                        vmts.initDb = true;

                        var uploadTransaction = db.transaction([
                            'fire_stopping_reports',
                            'fire_stopping_report_site_plans',
                            'fire_stopping_report_items',
                        ]);

                        var localFireStoppingReportsStore = uploadTransaction.objectStore('fire_stopping_reports');
                        var localFireStoppingReportSitePlansStore = uploadTransaction.objectStore('fire_stopping_report_site_plans');
                        var localFireStoppingReportItemsStore = uploadTransaction.objectStore('fire_stopping_report_items');

                        var vm = vmts;
                        vm.getUserToken();

                        uploadTransaction.oncomplete = function (event) {
                            if (vm.offlineFireStoppingReportSitePlans.length === 0) {
                                vm.isFireStoppingReportSitePlansZeroLength = true;
                            }

                            if (vm.offlineFireStoppingReportItems.length === 0) {
                                vm.isFireStoppingReportItemsZeroLength = true;
                            }

                            if (vm.offlineFireStoppingReports.length === 0) {
                                vm.isFireStoppingReportsZeroLength = true;
                                vm.performActualFireStoppingReportsSync();
                            } else {
                                var reportsVersions = [];
                                vm.offlineFireStoppingReports.forEach(report => {
                                    var reportVersion = null;
                                    if(report.hasOwnProperty('report_version')) {
                                        reportVersion = report.report_version;
                                    }
                                    reportsVersions.push({
                                        'site_fire_stopping_report_id': report.site_fire_stopping_report_id,
                                        'report_version': reportVersion
                                    });
                                });

                                axios.post(vm.cmsUrl + 'api/v1/fire-stopping-reports/check-versions.json', reportsVersions, {headers: {'Authorization': 'Bearer ' + vm.userToken}})
                                .then(response => {
                                    console.log('Received response from check-versions');
                                    //Go through records and check if there are conflicts, if so then display options, otherwise continue
                                    if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                                        response.data.data.forEach((report, index) => {
                                            var localReportVersion = reportsVersions[index]['report_version'];
                                            var remoteReportVersion = report['report_version'];

                                            vm.offlineFireStoppingReports[index].update_flag = 'OVERWRITE';

                                            if(remoteReportVersion != null && localReportVersion != remoteReportVersion) {
                                                vm.offlineFireStoppingReports[index].remote_report_version = remoteReportVersion;
                                                vm.fireStoppingReportsConflicts.push(index);
                                            }
                                        });

                                        console.log('Number of conflicts during sync: ' + vm.fireStoppingReportsConflicts.length)

                                        if(vm.fireStoppingReportsConflicts.length == 0) {
                                            vm.performActualFireStoppingReportsSync();
                                        }
                                    } else {
                                        console.log('Server returned invalid response while verifying versions of reports');
                                        throw 'Server returned invalid response while verifying versions of reports';
                                    }
                                })
                                .catch(e => {
                                    console.log('Catched error: ' + e);
                                    vm.syncErrorDetails = e;
                                    vm.isFsrSyncComplete = true;
                                    vm.fireStoppingReportsSyncStarted = false;
                                    vm.syncError = true;
                                });
                            }
                        };

                        uploadTransaction.onerror = function (error) {
                            vm.initApiError = error;
                            vm.initApiErrorStage = 'uploadTransaction';
                            console.log(error);
                        };

                        vm.offlineFireStoppingReports = [];
                        try {
                            if (localFireStoppingReportsStore) {
                                localFireStoppingReportsStore.openCursor().onsuccess = function (event) {
                                    var cursor = event.target.result;

                                    if (cursor) {
                                        if (vm.offlineFireStoppingReports) {
                                            vm.offlineFireStoppingReports.push(cursor.value)
                                        }
                                        cursor.continue();
                                    }
                                };
                            }

                        } catch (e) {
                            vm.initApiError = e;
                            vm.initApiErrorStage = 'offlineFireStoppingReports';
                            console.log(e);
                        }

                        vm.offlineFireStoppingReportSitePlans = [];
                        try {
                            if (localFireStoppingReportSitePlansStore) {
                                localFireStoppingReportSitePlansStore.openCursor().onsuccess = function (event) {
                                    var cursor = event.target.result;

                                    if (cursor) {
                                        if (vm.offlineFireStoppingReportSitePlans) {
                                            vm.offlineFireStoppingReportSitePlans.push(cursor.value)
                                        }
                                        cursor.continue();
                                    }
                                };
                            }

                        } catch (e) {
                            vm.initApiError = e;
                            vm.initApiErrorStage = 'offlineFireStoppingReportSitePlans';
                            console.log(e);
                        }

                        vm.offlineFireStoppingReportItems = [];
                        try {
                            if (localFireStoppingReportItemsStore) {
                                localFireStoppingReportItemsStore.openCursor().onsuccess = function (event) {
                                    var cursor = event.target.result;

                                    if (cursor) {
                                        if (vm.offlineFireStoppingReportItems) {
                                            vm.offlineFireStoppingReportItems.push(cursor.value)
                                        }
                                        cursor.continue();
                                    }
                                };
                            }

                        } catch (e) {
                            vm.initApiError = e;
                            vm.initApiErrorStage = 'offlineFireStoppingReportItems';
                            console.log(e);
                            console.log(e);
                        }
                    });
                }
            },
            performActualFireStoppingReportsSync() {
                console.log('Entered performActualFireStoppingReportsSync()');
                var bitPerCentage = 5.264; 

                axios.post(this.cmsUrl + 'api/v1/fire-stopping-reports/add-reports.json?ver=' + this.appNumericVersion, this.offlineFireStoppingReports, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                .then(response => {
                    console.log('Received response to add-reports');

                    return new Promise(async (resolve, reject) => { 
                        console.log('Entered promise after receiving response from add-reports')
                        if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                            console.log(response.data.data);
                            var vm = this;
                            response.data.data.forEach((report, index) => {
                                console.log('Report @ index ' + index + ' is complete? ' + vm.offlineFireStoppingReports[index]['is_complete']);
                                var archiveReport = vm.offlineFireStoppingReports[index]['is_complete'] || vm.offlineFireStoppingReports[index]['update_flag'] == 'REJECT';

                                if(report['status']) {
                                    vm.offlineFireStoppingReports[index].report_version = report['report_version'];
                                } else if(report['reason'] == 'complete' || report['reason'] == 'deleted') {
                                    //We move reports marked on the server as complete or deleted to archive, so they're not sent to the server again
                                    archiveReport = true;
                                    vm.invalidateFireStoppingReport(vm.offlineFireStoppingReports[index].site_fire_stopping_report_id);
                                } else if(report['reason'] == 'validation' || report['reason'] == 'failed_to_duplicate_report') {
                                    var failMsg = 'Report #' + vm.offlineFireStoppingReports[index].site_fire_stopping_report_id + ((vm.offlineFireStoppingReports[index].job_number != null && vm.offlineFireStoppingReports[index].job_number.length > 0) ? (' (' + vm.offlineFireStoppingReports[index].job_number + ')') : '') + ' failed to sync because of validation error (serverside). Please contact Support Team';
                                    vm.fireStoppingReportsErrors.push(failMsg);
                                    archiveReport = false;
                                }

                                if(archiveReport) {
                                    vm.fireStoppingReportsToArchive.push(index);
                                }
                            });

                            await this.getDbNew().then(db => {
                                console.log('Retrieved DB object and can start updating fire stopping reports');

                                var transaction = db.transaction([
                                    'fire_stopping_reports',
                                    'fire_stopping_reports_archived'
                                ], 'readwrite');

                                var fireStoppingReportsStore = transaction.objectStore('fire_stopping_reports');
                                var archivedFireStoppingReportsStore = transaction.objectStore('fire_stopping_reports_archived');

                                transaction.oncomplete = function (event) {
                                    console.log('Completed updating versions / moving fire stopping reports to archive');
                                    if(!response.data.success) {
                                        vm.showFireStoppingReportsSyncErrors = true;
                                        reject('Failed to sync fire stopping reports');
                                    } else {
                                        resolve();
                                    }
                                };

                                transaction.onerror = function (error) {
                                    reject(error);
                                };

                                console.log(vm.fireStoppingReportsToArchive);
                                vm.offlineFireStoppingReports.forEach((report, index) => {
                                    console.log('Processing report @ index #' + index);
                                    if(vm.fireStoppingReportsToArchive.includes(index)) {
                                        var archiveReportRequest = archivedFireStoppingReportsStore.put(report);
                                        console.log('Setting up callback to remove old report');
                                        archiveReportRequest.onsuccess = function() {
                                            var reportIdToDelete = report['site_fire_stopping_report_id'];
                                            if(report['update_flag'] == 'SAVE_AS_NEW') {
                                                reportIdToDelete = report['old_site_fire_stopping_report_id'];
                                            }
                                            console.log('Executing callback to remove old report #'+ reportIdToDelete);
                                            fireStoppingReportsStore.delete(reportIdToDelete);
                                        };
                                    } else {
                                        var saveReportRequest = fireStoppingReportsStore.put(report);
                                        if(report['update_flag'] == 'SAVE_AS_NEW') {
                                            console.log('Setting up callback to remove old report');
                                            saveReportRequest.onsuccess = function() {
                                                console.log('Executing callback to remove old report #'+ report['old_site_fire_stopping_report_id']);
                                                fireStoppingReportsStore.delete(report['old_site_fire_stopping_report_id']);
                                            };
                                        }
                                    }
                                });
                            }).catch(e => {
                                reject(e);
                            });  
                            
                            console.log('Continue to execute sync process after updating on-device fire stopping reports');
                        } else {
                            resolve();
                        }
                    }).then(() => {
                        this.fireStoppingReportsConflicts = [];
                        console.log('About to save report site plans to database');

                        this.isOfflineFireStoppingReportsPosted = true;
                        // Sync add
                        this.syncFsrProgress += bitPerCentage;
                        return axios.post(this.cmsUrl + 'api/v1/fire-stopping-reports/add-site-plans.json?ver=' + this.appNumericVersion, this.offlineFireStoppingReportSitePlans, {headers: {'Authorization': 'Bearer ' + this.userToken}});
                    }).then(response => {
                        console.log('Received response to add-site-plans');

                        return new Promise(async (resolve, reject) => { 
                            console.log('Entered promise after receiving response from add-site-plans endpoint')
                            if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                                console.log(response.data.data);
                                var vm = this;
                                vm.fireStoppingReportsErrors = [];
                                response.data.data.forEach((item, index) => {
                                    console.log('Item @ index ' + index + ' is complete? ' + item['is_complete']);
                                    var archiveItem = item['is_complete'] || vm.offlineFireStoppingReportSitePlans[index]['update_flag'] == 'REJECT';

                                    if(!item['status'] && item['reason'] == 'validation') {
                                        var failMsg = 'Item #' + vm.offlineFireStoppingReportSitePlans[index].site_fire_stopping_report_site_plan_id + ' failed to sync because of validation error (serverside). Please contact Support Team';
                                        vm.fireStoppingReportsErrors.push(failMsg);
                                        archiveItem = false;
                                    }

                                    if(archiveItem) {
                                        vm.fireStoppingReportSitePlansToArchive.push(index);
                                    }
                                });

                                await this.getDbNew().then(db => {
                                    console.log('Retrieved DB object and can start updating site plans');

                                    var transaction = db.transaction([
                                        'fire_stopping_report_site_plans',
                                        'fire_stopping_report_site_plans_archived'
                                    ], 'readwrite');

                                    var fireStoppingReportSitePlansStore = transaction.objectStore('fire_stopping_report_site_plans');
                                    var archivedFireStoppingReportSitePlansStoreStore = transaction.objectStore('fire_stopping_report_site_plans_archived');

                                    transaction.oncomplete = function (event) {
                                        console.log('Completed updating / moving site plans to archive');
                                        if(!response.data.success) { //It's set to false only on validation error for at least one site plan
                                            vm.showFireStoppingReportsSyncErrors = true;
                                            reject('Failed to sync site plans');
                                        } else {
                                            resolve();
                                        }
                                    };

                                    transaction.onerror = function (error) {
                                        reject(error);
                                    };

                                    console.log(vm.fireStoppingReportSitePlansToArchive);
                                    vm.offlineFireStoppingReportSitePlans.forEach((item, index) => {
                                        var updateFlag = item['update_flag'];
                                        item['update_flag'] = null;
                                        console.log('Processing item @ index #' + index);
                                        if(vm.fireStoppingReportSitePlansToArchive.includes(index)) {
                                            var archiveItemRequest = archivedFireStoppingReportSitePlansStoreStore.put(item);
                                            console.log('Setting up callback to remove old site plan');
                                            archiveItemRequest.onsuccess = function() {
                                                var reportIdToDelete = item['site_fire_stopping_report_site_plan_id'];
                                                if(updateFlag == 'SAVE_AS_NEW') {
                                                    reportIdToDelete = item['old_site_fire_stopping_report_site_plan_id'];
                                                }
                                                console.log('Executing callback to remove old site plan #'+ reportIdToDelete);
                                                fireStoppingReportSitePlansStore.delete(reportIdToDelete);
                                            };
                                        } else {
                                            var saveItemRequest = fireStoppingReportSitePlansStore.put(item);
                                            if(updateFlag == 'SAVE_AS_NEW') {
                                                console.log('Setting up callback to remove old site plan');
                                                saveItemRequest.onsuccess = function() {
                                                    console.log('Executing callback to remove old site plan #'+ item['old_site_fire_stopping_report_site_plan_id']);
                                                    fireStoppingReportSitePlansStore.delete(item['old_site_fire_stopping_report_site_plan_id']);
                                                };
                                            }
                                        }
                                    });
                                }).catch(e => {
                                    reject(e);
                                });  
                                
                                console.log('Continue to execute sync process after updating on-device site plans');
                            } else {
                                resolve();
                            }
                        });   
                    }).then(() => {
                        console.log('About to save report items to database');

                        this.isOfflineFireStoppingReportSitePlansPosted = true;
                        // Sync add
                        this.syncFsrProgress += bitPerCentage;
                        return axios.post(this.cmsUrl + 'api/v1/fire-stopping-reports/add-report-items.json?ver=' + this.appNumericVersion, this.offlineFireStoppingReportItems, {headers: {'Authorization': 'Bearer ' + this.userToken}});
                    }).then(response => {
                        console.log('Received response to add-report-items');

                        return new Promise(async (resolve, reject) => { 
                            console.log('Entered promise after receiving response from add-report-items endpoint')
                            if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                                console.log(response.data.data);
                                var vm = this;
                                vm.fireStoppingReportsErrors = [];
                                response.data.data.forEach((item, index) => {
                                    console.log('Item @ index ' + index + ' is complete? ' + item['is_complete']);
                                    var archiveItem = item['is_complete'] || vm.offlineFireStoppingReportItems[index]['update_flag'] == 'REJECT';

                                    if(!item['status'] && item['reason'] == 'validation') {
                                        var failMsg = 'Item #' + vm.offlineFireStoppingReportItems[index].site_fire_stopping_report_item_id + ((vm.offlineFireStoppingReportItems[index].pin_number != null && vm.offlineFireStoppingReportItems[index].pin_number.length > 0) ? (' (Ref: ' + vm.offlineFireStoppingReportItems[index].pin_number + ')') : '') + ' failed to sync because of validation error (serverside). Please contact Support Team';
                                        vm.fireStoppingReportsErrors.push(failMsg);
                                        archiveItem = false;
                                    }

                                    if(archiveItem) {
                                        vm.fireStoppingReportItemsToArchive.push(index);
                                    }
                                });

                                await this.getDbNew().then(db => {
                                    console.log('Retrieved DB object and can start updating report items');

                                    var transaction = db.transaction([
                                        'fire_stopping_report_items',
                                        'fire_stopping_report_items_archived'
                                    ], 'readwrite');

                                    var fireStoppingReportItemsStore = transaction.objectStore('fire_stopping_report_items');
                                    var archivedFireStoppingReportItemsStore = transaction.objectStore('fire_stopping_report_items_archived');

                                    transaction.oncomplete = function (event) {
                                        console.log('Completed updating / moving items to archive');
                                        if(!response.data.success) { //It's set to false only on validation error for at least one item
                                            vm.showFireStoppingReportsSyncErrors = true;
                                            reject('Failed to sync items');
                                        } else {
                                            resolve();
                                        }
                                    };

                                    transaction.onerror = function (error) {
                                        reject(error);
                                    };

                                    console.log(vm.fireStoppingReportItemsToArchive);
                                    vm.offlineFireStoppingReportItems.forEach((item, index) => {
                                        var updateFlag = item['update_flag'];
                                        item['update_flag'] = null;
                                        console.log('Processing item @ index #' + index);
                                        if(vm.fireStoppingReportItemsToArchive.includes(index)) {
                                            var archiveItemRequest = archivedFireStoppingReportItemsStore.put(item);
                                            console.log('Setting up callback to remove old item');
                                            archiveItemRequest.onsuccess = function() {
                                                var reportIdToDelete = item['site_fire_stopping_report_item_id'];
                                                if(updateFlag == 'SAVE_AS_NEW') {
                                                    reportIdToDelete = item['old_site_fire_stopping_report_item_id'];
                                                }
                                                console.log('Executing callback to remove old item #'+ reportIdToDelete);
                                                fireStoppingReportItemsStore.delete(reportIdToDelete);
                                            };
                                        } else {
                                            var saveItemRequest = fireStoppingReportItemsStore.put(item);
                                            if(updateFlag == 'SAVE_AS_NEW') {
                                                console.log('Setting up callback to remove old item');
                                                saveItemRequest.onsuccess = function() {
                                                    console.log('Executing callback to remove old item #'+ item['old_site_fire_stopping_report_item_id']);
                                                    fireStoppingReportItemsStore.delete(item['old_site_fire_stopping_report_item_id']);
                                                };
                                            }
                                        }
                                    });
                                }).catch(e => {
                                    reject(e);
                                });  
                                
                                console.log('Continue to execute sync process after updating on-device items');
                            } else {
                                resolve();
                            }
                        }).then(() => {
                            console.log('About to get workspace details from database');

                            this.isOfflineFireStoppingReportItemsPosted = true;
                            // Sync add
                            this.syncFsrProgress += bitPerCentage;
                            return axios.get(this.cmsUrl + 'api/v1/workspace/details.json');
                        });    
                    }); 
                }).then(response => {
                    // Sync add
                    this.syncFsrProgress += bitPerCentage;
                    this.workspace = response.data.workspace;
                    this.isWorkspaceDetailsLoaded = true;
                    return axios.get(this.cmsUrl + 'api/v1/workspace/fire-stopping-report-options.json', {headers: {'Authorization': 'Bearer ' + this.userToken}});
                }).then(response => {
                    // Sync add
                    this.syncFsrProgress += bitPerCentage;
                    this.isFireStoppingReportOptionsLoaded = true;
                    this.fire_stopping_report_options = response.data;
                    return axios.post(this.cmsUrl + 'api/v1/fire-stopping-reports/incomplete.json', {}, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                })
                .then(response => {
                    // Sync add
                    this.syncFsrProgress += bitPerCentage;
                    this.isFireStoppingReportsLoaded = true;
                    this.fire_stopping_reports = response.data.reports;
                    return axios.post(this.cmsUrl + 'api/v1/fire-stopping-reports/incomplete-site-plans.json', {}, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                })
                .then(response => {
                    // Sync add
                    this.syncFsrProgress += bitPerCentage;
                    this.isFireStoppingReportSitePlansLoaded = true;
                    this.fire_stopping_report_site_plans = response.data.site_plans;
                    return axios.post(this.cmsUrl + 'api/v1/fire-stopping-reports/incomplete-items.json', {}, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                })
                .then(response => {
                    // Sync add
                    this.syncFsrProgress += bitPerCentage;
                    this.isFireStoppingReportItemsLoaded = true;
                    this.fire_stopping_report_items = response.data.items;

                    var vmts = this;
                    this.getDb(function onConnectedSaveAllTheThings(db) {

                        var transaction = db.transaction([
                            'workspace_details',
                            'fsr_faults',
                            'fsr_materials',
                            'fsr_products',
                            'fsr_required_fire_ratings',
                            'fsr_substrate_types',
                            'fsr_construction_types',
                            'fsr_thermal_insulations',
                            'fire_stopping_reports',
                            'fire_stopping_report_site_plans',
                            'fire_stopping_report_items'
                        ], 'readwrite');

                        var workspaceDetailsStore = transaction.objectStore('workspace_details');
                        var fsrFaultsStore = transaction.objectStore('fsr_faults');
                        var fsrMaterialsStore = transaction.objectStore('fsr_materials');
                        var fsrProductsStore = transaction.objectStore('fsr_products');
                        var requiredRatingsStore = transaction.objectStore('fsr_required_fire_ratings');
                        var fsrSubstrateTypesStore = transaction.objectStore('fsr_substrate_types');
                        var fsrConstructionTypesStore = transaction.objectStore('fsr_construction_types');
                        var fsrThermalInsulationsStore = transaction.objectStore('fsr_thermal_insulations');
                        var fireStoppingReportsStore = transaction.objectStore('fire_stopping_reports');
                        var fireStoppingReportSitePlansStore = transaction.objectStore('fire_stopping_report_site_plans');
                        var fireStoppingReportItemsStore = transaction.objectStore('fire_stopping_report_items');

                        var vmt = vmts;
                        transaction.oncomplete = function (event) {
                            vmt.isFsrSyncComplete = true;
                            vmt.fireStoppingReportsSyncStarted = false;
                            vmt.syncsOpen = false;
                            vmt.initApi = true;
                            vmt.hasDoneFullSync = true;
                            vmt.$session.set('has_done_full_sync', true);
                            vmt.$session.set('fire_stopping_reports_last_sync', new Date());
                            window.setTimeout(vmt.reload, 5000);
                        };

                        transaction.onerror = function (error) {
                            console.log('Transaction failed');
                            console.log(error);
                            vmt.syncErrorDetails = error;
                            vmt.isFsrSyncComplete = true;
                            vmt.fireStoppingReportsSyncStarted = false;
                            vmt.syncError = true;
                        };

                        try {
                            var putWDRequest = workspaceDetailsStore.put({
                                workspace_id: vmt.workspace.workspace_id,
                                primary_colour: vmt.workspace.primary_colour,
                                primary_color_hover: vmt.workspace.primary_colour_hover,
                                secondary_colour: vmt.workspace.secondary_colour,
                                secondary_colour_hover: vmt.workspace.secondary_colour_hover,
                                workspace_name: vmt.workspace.workspace_name,
                                workspace_logo: vmt.workspace.workspace_logo,
                                workspace_favicon: vmt.workspace.workspace_favicon,
                                last_updated: new Date(),
                                risk_audit_last_updated: vmt.workspace.risk_audit_last_updated,
                                has_access_to_fire_door_audit: vmt.workspace.has_access_to_fire_door_audit,
                                has_access_to_risk_audit: vmt.workspace.has_access_to_risk_audit,
                                has_access_to_extinguisher_report: vmt.workspace.has_access_to_extinguisher_report,
                                has_access_to_fire_stopping_report: vmt.workspace.has_access_to_fire_stopping_report,
                                has_access_to_bae_system_report: vmt.workspace.has_access_to_bae_system_report,
                                has_access_to_door_installation_report: vmt.workspace.has_access_to_door_installation_report,
                                has_access_to_door_maintenance_report: vmt.workspace.has_access_to_door_maintenance_report
                            });
                            putWDRequest.onsuccess = function () {
                                vmt.isWorkspaceDetailsAdded = true;
                                // Sync add
                                vmt.syncFsrProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApi = false;
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPWorkspaceDetails';

                            console.log('Workspace deets failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fireStoppingReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.fire_stopping_report_options.hasOwnProperty('fsr_faults') && vmt.fire_stopping_report_options['fsr_faults'].length > 0) {
                                for (var i in vmt.fire_stopping_report_options['fsr_faults']) {
                                    var putFCRequest = fsrFaultsStore.put({
                                        fsr_fault_id: vmt.fire_stopping_report_options['fsr_faults'][i]['fsr_fault_id'],
                                        fault_description: vmt.fire_stopping_report_options['fsr_faults'][i]['fault_description'],
                                        fault_code: vmt.fire_stopping_report_options['fsr_faults'][i]['fault_code']
                                    });
                                }
                                putFCRequest.onsuccess = function () {
                                    vmt.isFsrFaultsAdded = true;
                                    vmt.syncFsrProgress += bitPerCentage;
                                }
                            } else {
                                vmt.isFsrFaultsAdded = true;
                                vmt.syncFsrProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPFsrFaultCodes';

                            console.log('FSR Fault codes failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fireStoppingReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.fire_stopping_report_options.hasOwnProperty('fsr_materials') && vmt.fire_stopping_report_options['fsr_materials'].length > 0) {
                                for (var i in vmt.fire_stopping_report_options['fsr_materials']) {
                                    var putMRequest = fsrMaterialsStore.put({
                                        fsr_material_id: vmt.fire_stopping_report_options['fsr_materials'][i]['fsr_material_id'],
                                        material_name: vmt.fire_stopping_report_options['fsr_materials'][i]['material_name'],
                                    });
                                }
                                putMRequest.onsuccess = function () {
                                    vmt.isFsrMaterialsAdded = true;
                                    vmt.syncFsrProgress += bitPerCentage;
                                }
                            } else {
                                vmt.isFsrMaterialsAdded = true;
                                vmt.syncFsrProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPFsrMaterials';

                            console.log('FSR Materials failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fireStoppingReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.fire_stopping_report_options.hasOwnProperty('fsr_products') && vmt.fire_stopping_report_options['fsr_products'].length > 0) {
                                for (var i in vmt.fire_stopping_report_options['fsr_products']) {
                                    var putMRequest = fsrProductsStore.put({
                                        fsr_product_id: vmt.fire_stopping_report_options['fsr_products'][i]['fsr_product_id'],
                                        product_name: vmt.fire_stopping_report_options['fsr_products'][i]['product_name'],
                                    });
                                }
                                putMRequest.onsuccess = function () {
                                    vmt.isFsrProductsAdded = true;
                                    vmt.syncFsrProgress += bitPerCentage;
                                }
                            } else {
                                vmt.isFsrProductsAdded = true;
                                vmt.syncFsrProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPFsrProducts';

                            console.log('FSR Products failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fireStoppingReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.fire_stopping_report_options.hasOwnProperty('fire_ratings') && vmt.fire_stopping_report_options['fire_ratings'].length > 0) {
                                for (var i in vmt.fire_stopping_report_options['fire_ratings']) {
                                    var putFRRequest = requiredRatingsStore.put({
                                        fsr_required_fire_rating_id: vmt.fire_stopping_report_options['fire_ratings'][i]['fsr_required_fire_rating_id'],
                                        fsr_required_fire_rating_name: vmt.fire_stopping_report_options['fire_ratings'][i]['fsr_required_fire_rating_name'],
                                    });
                                }
                                putFRRequest.onsuccess = function () {
                                    vmt.isFsrFireRatingsAdded = true;
                                    vmt.syncFsrProgress += bitPerCentage;
                                }
                            } else {
                                vmt.isFsrFireRatingsAdded = true;
                                vmt.syncFsrProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPFireRatings';

                            console.log('Fire Ratings failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fireStoppingReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.fire_stopping_report_options.hasOwnProperty('substrate_types') && vmt.fire_stopping_report_options['substrate_types'].length > 0) {
                                for (var i in vmt.fire_stopping_report_options['substrate_types']) {
                                    var putSTRequest = fsrSubstrateTypesStore.put({
                                        fsr_substrate_type_id: vmt.fire_stopping_report_options['substrate_types'][i]['fsr_substrate_type_id'],
                                        fsr_substrate_type_name: vmt.fire_stopping_report_options['substrate_types'][i]['fsr_substrate_type_name'],
                                    });
                                }
                                putSTRequest.onsuccess = function () {
                                    vmt.isFsrSubstratesAdded = true;
                                    vmt.syncFsrProgress += bitPerCentage;
                                }
                            } else {
                                vmt.isFsrSubstratesAdded = true;
                                vmt.syncFsrProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPFsrSubstrates';

                            console.log('FSR Substrates failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fireStoppingReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.fire_stopping_report_options.hasOwnProperty('construction_types') && vmt.fire_stopping_report_options['construction_types'].length > 0) {
                                for (var i in vmt.fire_stopping_report_options['construction_types']) {
                                    var putCTRequest = fsrConstructionTypesStore.put({
                                        fsr_construction_type_id: vmt.fire_stopping_report_options['construction_types'][i]['fsr_construction_type_id'],
                                        fsr_construction_type_name: vmt.fire_stopping_report_options['construction_types'][i]['fsr_construction_type_name'],
                                    });
                                }
                                putCTRequest.onsuccess = function () {
                                    vmt.isFsrConstructionTypesAdded = true;
                                    vmt.syncFsrProgress += bitPerCentage;
                                }
                            } else {
                                vmt.isFsrConstructionTypesAdded = true;
                                vmt.syncFsrProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPFsrConstructionTypes';

                            console.log('FSR Construction Types failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fireStoppingReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.fire_stopping_report_options.hasOwnProperty('thermal_insulations') && vmt.fire_stopping_report_options['thermal_insulations'].length > 0) {
                                for (var i in vmt.fire_stopping_report_options['thermal_insulations']) {
                                    var putTIRequest = fsrThermalInsulationsStore.put({
                                        fsr_thermal_insulation_id: vmt.fire_stopping_report_options['thermal_insulations'][i]['fsr_thermal_insulation_id'],
                                        fsr_thermal_insulation_name: vmt.fire_stopping_report_options['thermal_insulations'][i]['fsr_thermal_insulation_name'],
                                    });
                                }
                                putTIRequest.onsuccess = function () {
                                    vmt.isFsrThermalInsulationsAdded = true;
                                    vmt.syncFsrProgress += bitPerCentage;
                                }
                            } else {
                                vmt.isFsrThermalInsulationsAdded = true;
                                vmt.syncFsrProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPFsrThermalInsulations';

                            console.log('FSR Thermal Insulations failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fireStoppingReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.fire_stopping_reports.length === 0) {
                                vmt.isFireStoppingReportsZeroLength = true;
                                vmt.syncFsrProgress += bitPerCentage;
                            } else {
                                for (var i in vmt.fire_stopping_reports) {
                                    var putFireStoppingReportRequest = fireStoppingReportsStore.put({
                                        fire_stopping_report_id: vmt.fire_stopping_reports[i]['fire_stopping_report_id'],
                                        site_fire_stopping_report_id: parseInt(vmt.fire_stopping_reports[i]['site_fire_stopping_report_id']),
                                        sequential_reference_number: vmt.fire_stopping_reports[i]['sequential_reference_number'],
                                        job_number: vmt.fire_stopping_reports[i]['job_number'],
                                        date_of_inspection: vmt.fire_stopping_reports[i]['date_of_inspection'],
                                        prepared_for: vmt.fire_stopping_reports[i]['prepared_for'],
                                        site_address: vmt.fire_stopping_reports[i]['site_address'],
                                        sign_off_signature_image: vmt.fire_stopping_reports[i]['sign_off_signature_image'],
                                        pdf_link: vmt.fire_stopping_reports[i]['fire_stopping_report_pdfs'] !== undefined && vmt.fire_stopping_reports[i]['fire_stopping_report_pdfs'][0] !== undefined && vmt.fire_stopping_reports[i]['fire_stopping_report_pdfs'][0]['file_name'] !== undefined ? vmt.fire_stopping_reports[i]['fire_stopping_report_pdfs'][0]['file_name'] : null,
                                        report_version: vmt.fire_stopping_reports[i]['report_version'],
                                        offline_sign_off_signature_image: null
                                    });
                                }
                                putFireStoppingReportRequest.onsuccess = function () {
                                    vmt.isFireStoppingReportsAdded = true;
                                    vmt.syncFsrProgress += bitPerCentage;
                                }
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPFireStoppingReportsImport';

                            console.log('Fire Stopping Reports failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fireStoppingReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.fire_stopping_report_site_plans.length === 0) {
                                vmt.isFireStoppingReportSitePlansZeroLength = true;
                                vmt.syncFsrProgress += bitPerCentage;
                            } else {
                                for (var i in vmt.fire_stopping_report_site_plans) {
                                    var putFireStoppingReportSitePlansRequest = fireStoppingReportSitePlansStore.put({
                                        fire_stopping_report_site_plan_id: vmt.fire_stopping_report_site_plans[i]['fire_stopping_report_site_plan_id'],
                                        site_fire_stopping_report_site_plan_id: parseInt(vmt.fire_stopping_report_site_plans[i]['site_fire_stopping_report_site_plan_id']),
                                        site_fire_stopping_report_id: parseInt(vmt.fire_stopping_report_site_plans[i]['site_fire_stopping_report_id']),
                                        fire_stopping_report_id: vmt.fire_stopping_report_site_plans[i]['fire_stopping_report_id'],
                                        site_plan_title: vmt.fire_stopping_report_site_plans[i]['site_plan_title'],
                                        site_plan_image: vmt.fire_stopping_report_site_plans[i]['site_plan_image'],
                                        offline_site_plan_image: null
                                    });
                                }
                                putFireStoppingReportSitePlansRequest.onsuccess = function () {
                                    vmt.isFireStoppingReportSitePlansAdded = true;
                                    vmt.syncFsrProgress += bitPerCentage;
                                }
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPFireStoppingReportSitePlansImport';

                            console.log('FSR Site Plans failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fireStoppingReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.fire_stopping_report_items.length === 0) {
                                vmt.isFireStoppingReportItemsZeroLength = true;
                                vmt.syncFsrProgress += bitPerCentage;
                            } else {
                                for (var i in vmt.fire_stopping_report_items) {
                                    var putFireStoppingReportItemsRequest = fireStoppingReportItemsStore.put({
                                        fire_stopping_report_item_id: vmt.fire_stopping_report_items[i]['fire_stopping_report_item_id'],
                                        site_fire_stopping_report_item_id: parseInt(vmt.fire_stopping_report_items[i]['site_fire_stopping_report_item_id']),
                                        site_fire_stopping_report_id: parseInt(vmt.fire_stopping_report_items[i]['site_fire_stopping_report_id']),
                                        fire_stopping_report_id: vmt.fire_stopping_report_items[i]['fire_stopping_report_id'],
                                        site_fire_stopping_report_site_plan_id: parseInt(vmt.fire_stopping_report_items[i]['site_fire_stopping_report_site_plan_id']),
                                        fire_stopping_report_site_plan_id: vmt.fire_stopping_report_items[i]['fire_stopping_report_site_plan_id'],
                                        site_plan_image_position_x: vmt.fire_stopping_report_items[i]['site_plan_image_position_x'],
                                        site_plan_image_position_y: vmt.fire_stopping_report_items[i]['site_plan_image_position_y'],
                                        site_plan_image_zoom_level: vmt.fire_stopping_report_items[i]['site_plan_image_zoom_level'] !== undefined ? vmt.fire_stopping_report_items[i]['site_plan_image_zoom_level'] : 1,
                                        pin_number: vmt.fire_stopping_report_items[i]['pin_number'],
                                        issue_reference: vmt.fire_stopping_report_items[i]['issue_reference'],
                                        issue_location: vmt.fire_stopping_report_items[i]['issue_location'],
                                        operative_name: vmt.fire_stopping_report_items[i]['operative_name'] !== undefined ? vmt.fire_stopping_report_items[i]['operative_name'] : null,
                                        issue_status: vmt.fire_stopping_report_items[i]['issue_status'],
                                        required_fire_rating: vmt.fire_stopping_report_items[i]['required_fire_rating'],
                                        substrate: vmt.fire_stopping_report_items[i]['substrate'],
                                        construction_type: vmt.fire_stopping_report_items[i]['construction_type'],
                                        pipes_selected: vmt.fire_stopping_report_items[i]['pipes_selected'],
                                        pipes_material: vmt.fire_stopping_report_items[i]['pipes_material'],
                                        pipes_size: vmt.fire_stopping_report_items[i]['pipes_size'],
                                        pipes_thermal_insulation: vmt.fire_stopping_report_items[i]['pipes_thermal_insulation'],
                                        pipes_distance_to_first_support: vmt.fire_stopping_report_items[i]['pipes_distance_to_first_support'],
                                        pipes_proximity_to_each_other: vmt.fire_stopping_report_items[i]['pipes_proximity_to_each_other'],
                                        cables_selected: vmt.fire_stopping_report_items[i]['cables_selected'],
                                        cables_size: vmt.fire_stopping_report_items[i]['cables_size'],
                                        cables_bundles: vmt.fire_stopping_report_items[i]['cables_bundles'],
                                        cables_trays_type: vmt.fire_stopping_report_items[i]['cables_trays_type'],
                                        cables_trays_size: vmt.fire_stopping_report_items[i]['cables_trays_size'],
                                        cables_support_conditions: vmt.fire_stopping_report_items[i]['cables_support_conditions'],
                                        cables_distance_to_first_support: vmt.fire_stopping_report_items[i]['cables_distance_to_first_support'],
                                        cables_proximity_to_each_other: vmt.fire_stopping_report_items[i]['cables_proximity_to_each_other'] !== undefined ? vmt.fire_stopping_report_items[i]['cables_proximity_to_each_other'] : null,
                                        ducts_selected: vmt.fire_stopping_report_items[i]['ducts_selected'],
                                        ducts_size: vmt.fire_stopping_report_items[i]['ducts_size'],
                                        ducts_manufacturer: vmt.fire_stopping_report_items[i]['ducts_manufacturer'],
                                        ducts_seal_details: vmt.fire_stopping_report_items[i]['ducts_seal_details'],
                                        ducts_support_conditions: vmt.fire_stopping_report_items[i]['ducts_support_conditions'],
                                        ducts_distance_to_first_support: vmt.fire_stopping_report_items[i]['ducts_distance_to_first_support'],
                                        ducts_proximity_to_each_other: vmt.fire_stopping_report_items[i]['ducts_proximity_to_each_other'] !== undefined ? vmt.fire_stopping_report_items[i]['ducts_proximity_to_each_other'] : null,
                                        opening_size: vmt.fire_stopping_report_items[i]['opening_size'],
                                        opening_depth: vmt.fire_stopping_report_items[i]['opening_depth'] !== undefined ? vmt.fire_stopping_report_items[i]['opening_depth'] : null,
                                        opening_preparation: vmt.fire_stopping_report_items[i]['opening_preparation'],
                                        opening_preparation_details: vmt.fire_stopping_report_items[i]['opening_preparation_details'],
                                        opening_preparation_adequate: vmt.fire_stopping_report_items[i]['opening_preparation_adequate'],
                                        opening_proximity_to_other_elements: vmt.fire_stopping_report_items[i]['opening_proximity_to_other_elements'],
                                        opening_space_adequate: vmt.fire_stopping_report_items[i]['opening_space_adequate'],
                                        work_required: vmt.fire_stopping_report_items[i]['work_required'],
                                        installation_date: vmt.fire_stopping_report_items[i]['installation_date'],
                                        installed_by: vmt.fire_stopping_report_items[i]['installed_by'],
                                        engineer_signature_image: vmt.fire_stopping_report_items[i]['engineer_signature_image'],
                                        audit_date: vmt.fire_stopping_report_items[i]['audit_date'] !== undefined ? vmt.fire_stopping_report_items[i]['audit_date'] : null,
                                        audit_comments: vmt.fire_stopping_report_items[i]['audit_comments'] !== undefined ? vmt.fire_stopping_report_items[i]['audit_comments'] : null,
                                        audited_by: vmt.fire_stopping_report_items[i]['audited_by'] !== undefined ? vmt.fire_stopping_report_items[i]['audited_by'] : null,
                                        sign_off_signature_image: vmt.fire_stopping_report_items[i]['sign_off_signature_image'] !== undefined ? vmt.fire_stopping_report_items[i]['sign_off_signature_image'] : null,
                                        fsr_materials: vmt.fire_stopping_report_items[i]['fsr_materials'],
                                        fsr_products: vmt.fire_stopping_report_items[i]['fsr_products'] !== undefined ? vmt.fire_stopping_report_items[i]['fsr_products'] : [],
                                        fire_stopping_report_item_faults: vmt.fire_stopping_report_items[i]['fire_stopping_report_item_faults'],
                                        fire_stopping_report_item_images: vmt.fire_stopping_report_items[i]['fire_stopping_report_item_images'],
                                        offline_images: [],
                                        offline_engineer_signature_image: null,
                                        offline_sign_off_signature_image: null
                                    });
                                }
                                putFireStoppingReportItemsRequest.onsuccess = function () {
                                    vmt.isFireStoppingReportItemsAdded = true;
                                    vmt.syncFsrProgress += bitPerCentage;
                                }
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPFSRItemsImport';

                            console.log('FSR Items failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fireStoppingReportsSyncStarted = false;
                        }


                    });
                }).catch(error => {
                    console.log('Axios failed?');
                    console.log(error);
                    this.syncErrorDetails = error;
                    this.isFsrSyncComplete = true;
                    this.syncError = true;
                    this.fireStoppingReportsSyncStarted = false;

                    this.initApiError = error;
                    this.initApiErrorStage = 'axios';
                });
            },
            syncBaeSystemsReports(inBg) {
                if (navigator.onLine && !this.baeSystemsReportsSyncStarted) {

                    this.baeSystemsReportsSyncStarted = true;
                    this.isBsrSyncComplete = false;
                    this.isBsrSyncing = inBg !== true;
                    this.isBsrSyncingInBg = inBg === true;
                    this.syncBsrProgress = 0;
                    this.syncError = false;
                    this.syncErrorDetails = '';

                    this.isWorkspaceDetailsLoaded = false;
                    this.isWorkspaceDetailsAdded = false;
                    this.isOfflineBaeSystemsReportsPosted = false;
                    this.isBaeSystemsReportsLoaded = false;
                    this.isBaeSystemsReportsAdded = false;
                    this.isBaeSystemsReportsZeroLength = false;

                    this.showBaeSystemsReportsSyncErrors = false;
                    this.submittedBaeSystemsReportsConflictForm = false;
                    this.baeSystemsReportsConflicts = [];
                    this.baeSystemsReportsErrors = [];
                    this.baeSystemsReportsToArchive = [];

                    var vmts = this;
                    this.getDb(function onConnected(db) {
                        vmts.initDb = true;

                        var uploadTransaction = db.transaction([
                            'bae_systems_reports'
                        ]);

                        var localBaeSystemsReportsStore = uploadTransaction.objectStore('bae_systems_reports');
                        var vm = vmts;
                        vm.getUserToken();

                        uploadTransaction.oncomplete = function (event) {

                            if (vm.offlineBaeSystemsReports.length === 0) {
                                vm.isBaeSystemsReportsZeroLength = true;
                                vm.performActualBaeSystemsReportsSync();
                            } else {
                                var reportsVersions = [];
                                vm.offlineBaeSystemsReports.forEach(report => {
                                    var reportVersion = null;
                                    if(report.hasOwnProperty('report_version')) {
                                        reportVersion = report.report_version;
                                    }
                                    reportsVersions.push({
                                        'site_bae_systems_report_id': report.site_bae_systems_report_id,
                                        'report_version': reportVersion
                                    });
                                });

                                axios.post(vm.cmsUrl + 'api/v1/bae-systems-reports/check-versions.json', reportsVersions, {headers: {'Authorization': 'Bearer ' + vm.userToken}})
                                .then(response => {
                                    console.log('Received response from check-versions');
                                    //Go through records and check if there are conflicts, if so then display options, otherwise continue
                                    if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                                        response.data.data.forEach((report, index) => {
                                            var localReportVersion = reportsVersions[index]['report_version'];
                                            var remoteReportVersion = report['report_version'];

                                            vm.offlineBaeSystemsReports[index].update_flag = 'OVERWRITE';

                                            if(remoteReportVersion != null && localReportVersion != remoteReportVersion) {
                                                vm.offlineBaeSystemsReports[index].remote_report_version = remoteReportVersion;
                                                vm.baeSystemsReportsConflicts.push(index);
                                            }
                                        });

                                        console.log('Number of conflicts during sync: ' + vm.baeSystemsReportsConflicts.length)

                                        if(vm.baeSystemsReportsConflicts.length == 0) {
                                            vm.performActualBaeSystemsReportsSync();
                                        }
                                    } else {
                                        console.log('Server returned invalid response while verifying versions of reports');
                                        throw 'Server returned invalid response while verifying versions of reports';
                                    }
                                })
                                .catch(e => {
                                    console.log('Catched error: ' + e);
                                    vm.syncErrorDetails = e;
                                    vm.isFsrSyncComplete = true;
                                    vm.fireStoppingReportsSyncStarted = false;
                                    vm.syncError = true;
                                });
                            }
                        };

                        uploadTransaction.onerror = function (error) {
                            vm.initApiError = error;
                            vm.initApiErrorStage = 'uploadTransaction';
                            console.log(error);
                        };

                        vm.offlineBaeSystemsReports = [];
                        try {
                            if (localBaeSystemsReportsStore) {
                                localBaeSystemsReportsStore.openCursor().onsuccess = function (event) {
                                    var cursor = event.target.result;

                                    if (cursor) {
                                        if (vm.offlineBaeSystemsReports) {
                                            vm.offlineBaeSystemsReports.push(cursor.value)
                                        }
                                        cursor.continue();
                                    }
                                };
                            }

                        } catch (e) {
                            vm.initApiError = e;
                            vm.initApiErrorStage = 'offlineBaeSystemsReports';
                            console.log(e);
                        }
                    });
                }
            },
            performActualBaeSystemsReportsSync() {
                console.log('Entered performActualBaeSystemsReportsSync()');
                var bitPerCentage = 25; 

                axios.post(this.cmsUrl + 'api/v1/bae-systems-reports/add-reports.json?ver=' + this.appNumericVersion, this.offlineBaeSystemsReports, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                .then(response => {
                    console.log('Received response to add-reports');

                    return new Promise(async (resolve, reject) => { 
                        console.log('Entered promise after receiving response from add-reports')
                        if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                            console.log(response.data.data);
                            var vm = this;
                            response.data.data.forEach((report, index) => {
                                console.log('Report @ index ' + index + ' is complete? ' + vm.offlineBaeSystemsReports[index]['is_complete']);
                                var archiveReport = vm.offlineBaeSystemsReports[index]['is_complete'] || vm.offlineBaeSystemsReports[index]['update_flag'] == 'REJECT';

                                if(report['status']) {
                                    vm.offlineBaeSystemsReports[index].report_version = report['report_version'];
                                } else if(report['reason'] == 'complete' || report['reason'] == 'deleted') {
                                    //We move reports marked on the server as complete or deleted to archive, so they're not sent to the server again
                                    archiveReport = true;
                                } else if(report['reason'] == 'validation' || report['reason'] == 'failed_to_duplicate_report') {
                                    var failMsg = 'Report #' + vm.offlineBaeSystemsReports[index].site_bae_systems_report_id + ((vm.offlineBaeSystemsReports[index].door_identifier != null && vm.offlineBaeSystemsReports[index].door_identifier.length > 0) ? (' (' + vm.offlineBaeSystemsReports[index].door_identifier + ')') : '') + ' failed to sync because of validation error (serverside). Please contact Support Team';
                                    vm.baeSystemsReportsErrors.push(failMsg);
                                    archiveReport = false;
                                }

                                if(archiveReport) {
                                    vm.baeSystemsReportsToArchive.push(index);
                                }
                            });

                            await this.getDbNew().then(db => {
                                console.log('Retrieved DB object and can start updating BAE Systems reports');

                                var transaction = db.transaction([
                                    'bae_systems_reports',
                                    'bae_systems_reports_archived'
                                ], 'readwrite');

                                var baeSystemsReportsStore = transaction.objectStore('bae_systems_reports');
                                var archivedBaeSystemsReportsStore = transaction.objectStore('bae_systems_reports_archived');

                                transaction.oncomplete = function (event) {
                                    console.log('Completed updating versions / moving BAE Systems reports to archive');
                                    if(!response.data.success) {
                                        vm.showBaeSystemsReportsSyncErrors = true;
                                        reject('Failed to sync BAE Systems reports');
                                    } else {
                                        resolve();
                                    }
                                };

                                transaction.onerror = function (error) {
                                    reject(error);
                                };

                                console.log(vm.baeSystemsReportsToArchive);
                                vm.offlineBaeSystemsReports.forEach((report, index) => {
                                    console.log('Processing report @ index #' + index);
                                    if(vm.baeSystemsReportsToArchive.includes(index)) {
                                        var archiveReportRequest = archivedBaeSystemsReportsStore.put(report);
                                        console.log('Setting up callback to remove old report');
                                        archiveReportRequest.onsuccess = function() {
                                            var reportIdToDelete = report['site_bae_systems_report_id'];
                                            if(report['update_flag'] == 'SAVE_AS_NEW') {
                                                reportIdToDelete = report['old_site_bae_systems_report_id'];
                                            }
                                            console.log('Executing callback to remove old report #'+ reportIdToDelete);
                                            baeSystemsReportsStore.delete(reportIdToDelete);
                                        };
                                    } else {
                                        var saveReportRequest = baeSystemsReportsStore.put(report);
                                        if(report['update_flag'] == 'SAVE_AS_NEW') {
                                            console.log('Setting up callback to remove old report');
                                            saveReportRequest.onsuccess = function() {
                                                console.log('Executing callback to remove old report #'+ report['old_site_bae_systems_report_id']);
                                                baeSystemsReportsStore.delete(report['old_site_bae_systems_report_id']);
                                            };
                                        }
                                    }
                                });
                            }).catch(e => {
                                reject(e);
                            });  
                            
                            console.log('Continue to execute sync process after updating on-device BAE Systems reports');
                        } else {
                            resolve();
                        }
                    });
                }).then(() => {
                    this.baeSystemsReportsConflicts = [];
                    this.isOfflineBaeSystemsReportsPosted = true;
                    this.syncBsrProgress += bitPerCentage;

                    return axios.get(this.cmsUrl + 'api/v1/workspace/details.json');
                }).then(response => {
                    this.workspace = response.data.workspace;
                    this.isWorkspaceDetailsLoaded = true;
                    this.syncBsrProgress += bitPerCentage;

                    return axios.post(this.cmsUrl + 'api/v1/bae-systems-reports/incomplete.json', {}, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                }).then(response => {
                    // Sync add
                    this.syncBsrProgress += bitPerCentage;
                    this.isBaeSystemsReportsLoaded = true;
                    this.bae_systems_reports = response.data.reports;

                    var vmts = this;
                    this.getDb(function onConnectedSaveAllTheThings(db) {

                        var transaction = db.transaction([
                            'workspace_details',
                            'bae_systems_reports'
                        ], 'readwrite');

                        var workspaceDetailsStore = transaction.objectStore('workspace_details');
                        var baeSystemsReportsStore = transaction.objectStore('bae_systems_reports');

                        var vmt = vmts;
                        transaction.oncomplete = function (event) {
                            vmt.isBsrSyncComplete = true;
                            vmt.baeSystemsReportsSyncStarted = false;
                            vmt.syncsOpen = false;
                            vmt.initApi = true;
                            vmt.hasDoneFullSync = true;
                            vmt.$session.set('has_done_full_sync', true);
                            vmt.$session.set('bae_systems_reports_last_sync', new Date());
                            window.setTimeout(vmt.reload, 5000);
                        };

                        transaction.onerror = function (error) {
                            console.log('Transaction failed');
                            console.log(error);
                            vmt.syncErrorDetails = error;
                            vmt.isBsrSyncComplete = true;
                            vmt.baeSystemsReportsSyncStarted = false;
                            vmt.syncError = true;
                        };

                        try {
                            var putWDRequest = workspaceDetailsStore.put({
                                workspace_id: vmt.workspace.workspace_id,
                                primary_colour: vmt.workspace.primary_colour,
                                primary_color_hover: vmt.workspace.primary_colour_hover,
                                secondary_colour: vmt.workspace.secondary_colour,
                                secondary_colour_hover: vmt.workspace.secondary_colour_hover,
                                workspace_name: vmt.workspace.workspace_name,
                                workspace_logo: vmt.workspace.workspace_logo,
                                workspace_favicon: vmt.workspace.workspace_favicon,
                                last_updated: new Date(),
                                risk_audit_last_updated: vmt.workspace.risk_audit_last_updated,
                                has_access_to_fire_door_audit: vmt.workspace.has_access_to_fire_door_audit,
                                has_access_to_risk_audit: vmt.workspace.has_access_to_risk_audit,
                                has_access_to_extinguisher_report: vmt.workspace.has_access_to_extinguisher_report,
                                has_access_to_fire_stopping_report: vmt.workspace.has_access_to_fire_stopping_report,
                                has_access_to_bae_system_report: vmt.workspace.has_access_to_bae_system_report,
                                has_access_to_door_installation_report: vmt.workspace.has_access_to_door_installation_report,
                                has_access_to_door_maintenance_report: vmt.workspace.has_access_to_door_maintenance_report
                            });
                            putWDRequest.onsuccess = function () {
                                vmt.isWorkspaceDetailsAdded = true;
                                vmt.syncBsrProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApi = false;
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPWorkspaceDetails';

                            console.log('Workspace deets failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.baeSystemsReportsSyncStarted = false;
                        }

                        try {
                            if (vmt.bae_systems_reports.length === 0) {
                                vmt.isBaeSystemsReportsZeroLength = true;
                                vmt.syncBsrProgress += bitPerCentage;
                            } else {
                                for (var i in vmt.bae_systems_reports) {
                                    var putReportRequest = baeSystemsReportsStore.put({
                                        bae_systems_report_id: vmt.bae_systems_reports[i]['bae_systems_report_id'],
                                        site_bae_systems_report_id: parseInt(vmt.bae_systems_reports[i]['site_bae_systems_report_id']),
                                        door_identifier: vmt.bae_systems_reports[i]['door_identifier'],
                                        door_location: vmt.bae_systems_reports[i]['door_location'],
                                        door_zone_floor: vmt.bae_systems_reports[i]['door_zone_floor'],
                                        door_rating: vmt.bae_systems_reports[i]['door_rating'],
                                        door_material: vmt.bae_systems_reports[i]['door_material'] !== undefined ? vmt.bae_systems_reports[i]['door_material'] : null,
                                        door_manufacturer: vmt.bae_systems_reports[i]['door_manufacturer'] !== undefined ? vmt.bae_systems_reports[i]['door_manufacturer'] : null,
                                        inspection_date: vmt.bae_systems_reports[i]['inspection_date'] !== undefined ? vmt.bae_systems_reports[i]['inspection_date'] : null,
                                        inspector_name: vmt.bae_systems_reports[i]['inspector_name'] !== undefined ? vmt.bae_systems_reports[i]['inspector_name'] : null,
                                        company: vmt.bae_systems_reports[i]['company'] !== undefined ? vmt.bae_systems_reports[i]['company'] : null,
                                        comments: vmt.bae_systems_reports[i]['comments'],
                                        leaf_qn_1: vmt.bae_systems_reports[i]['leaf_qn_1'],
                                        leaf_qn_2: vmt.bae_systems_reports[i]['leaf_qn_2'],
                                        leaf_qn_3: vmt.bae_systems_reports[i]['leaf_qn_3'],
                                        frame_qn_1: vmt.bae_systems_reports[i]['frame_qn_1'],
                                        frame_qn_2: vmt.bae_systems_reports[i]['frame_qn_2'],
                                        frame_qn_3: vmt.bae_systems_reports[i]['frame_qn_3'],
                                        frame_qn_4: vmt.bae_systems_reports[i]['frame_qn_4'],
                                        frame_qn_5: vmt.bae_systems_reports[i]['frame_qn_5'] !== undefined ? vmt.bae_systems_reports[i]['frame_qn_5'] : null,
                                        seals_qn_1: vmt.bae_systems_reports[i]['seals_qn_1'],
                                        seals_qn_2: vmt.bae_systems_reports[i]['seals_qn_2'],
                                        seals_qn_3: vmt.bae_systems_reports[i]['seals_qn_3'],
                                        seals_qn_4: vmt.bae_systems_reports[i]['seals_qn_4'],
                                        seals_qn_5: vmt.bae_systems_reports[i]['seals_qn_5'],
                                        hinges_qn_1: vmt.bae_systems_reports[i]['hinges_qn_1'],
                                        hinges_qn_2: vmt.bae_systems_reports[i]['hinges_qn_2'],
                                        hinges_qn_3: vmt.bae_systems_reports[i]['hinges_qn_3'],
                                        hinges_qn_4: vmt.bae_systems_reports[i]['hinges_qn_4'],
                                        hinges_qn_5: vmt.bae_systems_reports[i]['hinges_qn_5'],
                                        closers_qn_1: vmt.bae_systems_reports[i]['closers_qn_1'],
                                        closers_qn_2: vmt.bae_systems_reports[i]['closers_qn_2'],
                                        closers_qn_3: vmt.bae_systems_reports[i]['closers_qn_3'],
                                        closers_qn_4: vmt.bae_systems_reports[i]['closers_qn_4'],
                                        closers_qn_5: vmt.bae_systems_reports[i]['closers_qn_5'],
                                        hold_open_qn_1: vmt.bae_systems_reports[i]['hold_open_qn_1'],
                                        hold_open_qn_2: vmt.bae_systems_reports[i]['hold_open_qn_2'],
                                        hold_open_qn_3: vmt.bae_systems_reports[i]['hold_open_qn_3'],
                                        lock_latch_qn_1: vmt.bae_systems_reports[i]['lock_latch_qn_1'],
                                        lock_latch_qn_2: vmt.bae_systems_reports[i]['lock_latch_qn_2'],
                                        glass_glazing_qn_1: vmt.bae_systems_reports[i]['glass_glazing_qn_1'],
                                        glass_glazing_qn_2: vmt.bae_systems_reports[i]['glass_glazing_qn_2'],
                                        glass_glazing_qn_3: vmt.bae_systems_reports[i]['glass_glazing_qn_3'],
                                        glass_glazing_qn_4: vmt.bae_systems_reports[i]['glass_glazing_qn_4'],
                                        glass_glazing_qn_5: vmt.bae_systems_reports[i]['glass_glazing_qn_5'],
                                        threshold_gap_qn_1: vmt.bae_systems_reports[i]['threshold_gap_qn_1'],
                                        threshold_gap_qn_2: vmt.bae_systems_reports[i]['threshold_gap_qn_2'],
                                        threshold_gap_qn_3: vmt.bae_systems_reports[i]['threshold_gap_qn_3'],
                                        main_door_bool: vmt.bae_systems_reports[i]['main_door_bool'] !== undefined ? vmt.bae_systems_reports[i]['main_door_bool'] : false,
                                        main_door_closed_bool: vmt.bae_systems_reports[i]['main_door_closed_bool'] !== undefined ? vmt.bae_systems_reports[i]['main_door_closed_bool'] : false,
                                        main_door_locked_bool: vmt.bae_systems_reports[i]['main_door_locked_bool'] !== undefined ? vmt.bae_systems_reports[i]['main_door_locked_bool'] : false,
                                        main_door_auto_bool: vmt.bae_systems_reports[i]['main_door_auto_bool'] !== undefined ? vmt.bae_systems_reports[i]['main_door_auto_bool'] : false,
                                        main_door_f_escape_bool: vmt.bae_systems_reports[i]['main_door_f_escape_bool'] !== undefined ? vmt.bae_systems_reports[i]['main_door_f_escape_bool'] : false,
                                        main_door_tag_bool: vmt.bae_systems_reports[i]['main_door_tag_bool'] !== undefined ? vmt.bae_systems_reports[i]['main_door_tag_bool'] : false,
                                        second_door_bool: vmt.bae_systems_reports[i]['second_door_bool'] !== undefined ? vmt.bae_systems_reports[i]['second_door_bool'] : false,
                                        second_door_closed_bool: vmt.bae_systems_reports[i]['second_door_closed_bool'] !== undefined ? vmt.bae_systems_reports[i]['second_door_closed_bool'] : false,
                                        second_door_locked_bool: vmt.bae_systems_reports[i]['second_door_locked_bool'] !== undefined ? vmt.bae_systems_reports[i]['second_door_locked_bool'] : false,
                                        second_door_auto_bool: vmt.bae_systems_reports[i]['second_door_auto_bool'] !== undefined ? vmt.bae_systems_reports[i]['second_door_auto_bool'] : false,
                                        second_door_f_escape_bool: vmt.bae_systems_reports[i]['second_door_f_escape_bool'] !== undefined ? vmt.bae_systems_reports[i]['second_door_f_escape_bool'] : false,
                                        second_door_tag_bool: vmt.bae_systems_reports[i]['second_door_tag_bool'] !== undefined ? vmt.bae_systems_reports[i]['second_door_tag_bool'] : false,
                                        all_fdoors_signage_legible: vmt.bae_systems_reports[i]['all_fdoors_signage_legible'] !== undefined ? vmt.bae_systems_reports[i]['all_fdoors_signage_legible'] : null,
                                        fdoor_signage_correct: vmt.bae_systems_reports[i]['fdoor_signage_correct'] !== undefined ? vmt.bae_systems_reports[i]['fdoor_signage_correct'] : null,
                                        signage_comments: vmt.bae_systems_reports[i]['signage_comments'] !== undefined ? vmt.bae_systems_reports[i]['signage_comments'] : null,
                                        bae_systems_report_actions: vmt.bae_systems_reports[i]['bae_systems_report_actions'],
                                        bae_systems_report_images: vmt.bae_systems_reports[i]['bae_systems_report_images'],
                                        pdf_link: vmt.bae_systems_reports[i]['bae_systems_report_pdfs'] !== undefined && vmt.bae_systems_reports[i]['bae_systems_report_pdfs'][0] !== undefined && vmt.bae_systems_reports[i]['bae_systems_report_pdfs'][0]['file_name'] !== undefined ? vmt.bae_systems_reports[i]['bae_systems_report_pdfs'][0]['file_name'] : null,
                                        report_version: vmt.bae_systems_reports[i]['report_version'],
                                        offline_images: []
                                    });
                                }
                                putReportRequest.onsuccess = function () {
                                    vmt.isBaeSystemsReportsAdded = true;
                                    vmt.syncBsrProgress += bitPerCentage;
                                }
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPBaeSystemsReportsImport';

                            console.log('BAE Systems Reports failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.baeSystemsReportsSyncStarted = false;
                        }
                    });
                }).catch(error => {
                    console.log('Axios failed?');
                    console.log(error);
                    this.syncErrorDetails = error;
                    this.isBsrSyncComplete = true;
                    this.syncError = true;
                    this.baeSystemsReportsSyncStarted = false;

                    this.initApiError = error;
                    this.initApiErrorStage = 'axios';
                });
            },
            syncFdiReports(inBg) {
                if (navigator.onLine && !this.fdirSyncStarted) {

                    this.syncErrorDetails = null;
                    this.syncError = false;
                    this.fdirSyncStarted = true;
                    this.isFdirSyncComplete = false;
                    this.isFdirSyncing = inBg !== true;
                    this.isFdirSyncingInBg = inBg === true;
                    this.syncFdirProgress = 0;

                    this.isWorkspaceDetailsLoaded = false;
                    this.isWorkspaceDetailsAdded = false;
                    this.isAdditionalDoorFieldsOptionsLoaded = false;
                    this.isDeclaredResistanceLevelsAdded = false;
                    this.isFdiReportsLoaded = false;
                    this.isFdiReportsAdded = false;
                    this.isFdirItemsLoaded = false;
                    this.isFdirItemsAdded = false;
                    this.isOfflineFdiReportsPosted = false;
                    this.isOfflineFdirItemsPosted = false;

                    this.isOfflineFdirItemsZeroLength = false;
                    this.isOfflineFdiReportsZeroLength = false;
                    this.showFdirSyncErrors = false;
                    this.submittedFdirConflictForm = false;
                    this.fdirConflicts = [];
                    this.fdirSyncErrors = [];
                    this.fdiReportsToArchive = [];
                    this.fdirItemsToArchive = [];

                    var vm = this;
                    this.getDb(function onConnected(db) {
                        vm.initDb = true;

                        var uploadTransaction = db.transaction([
                            'door_installation_reports',
                            'door_installation_report_items',
                        ]);

                        var localFdirStore = uploadTransaction.objectStore('door_installation_reports');
                        var localFdirItemsStore = uploadTransaction.objectStore('door_installation_report_items');

                        vm.getUserToken();

                        uploadTransaction.oncomplete = function (event) {
                            if (vm.offlineFdirItems.length === 0) {
                                vm.isOfflineFdirItemsZeroLength = true;
                            }

                            if (vm.offlineFdiReports.length === 0) {
                                vm.isOfflineFdiReportsZeroLength = true;
                                vm.performActualFdiReportsSync();
                            } else {
                                var reportsVersions = [];
                                vm.offlineFdiReports.forEach(report => {
                                    var reportVersion = null;
                                    if(report.hasOwnProperty('report_version')) {
                                        reportVersion = report.report_version;
                                    }
                                    reportsVersions.push({
                                        'site_door_installation_report_id': report.site_door_installation_report_id,
                                        'report_version': reportVersion
                                    });
                                });

                                axios.post(vm.cmsUrl + 'api/v1/door-installation-reports/check-versions.json', reportsVersions, {headers: {'Authorization': 'Bearer ' + vm.userToken}})
                                .then(response => {
                                    if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                                        response.data.data.forEach((report, index) => {
                                            var localReportVersion = reportsVersions[index]['report_version'];
                                            var remoteReportVersion = report['report_version'];

                                            vm.offlineFdiReports[index].update_flag = 'OVERWRITE';

                                            if(remoteReportVersion != null && localReportVersion != remoteReportVersion) {
                                                vm.offlineFdiReports[index].remote_report_version = remoteReportVersion;
                                                vm.fdirConflicts.push(index);
                                            }
                                        });

                                        console.log('Number of FDI Reports to sync: ' + vm.fdirConflicts.length)

                                        if(vm.fdirConflicts.length == 0) {
                                            vm.performActualFdiReportsSync();
                                        }
                                    } else {
                                        console.log('Server returned invalid response while verifying versions of reports');
                                        throw 'Server returned invalid response while verifying versions of reports';
                                    }
                                })
                                .catch(e => {
                                    console.log('Catched error: ' + e);
                                    vm.syncErrorDetails = e;
                                    vm.isFdirSyncComplete = true;
                                    vm.fdirSyncStarted = false;
                                    vm.syncError = true;
                                });
                            }
                        };

                        uploadTransaction.onerror = function (error) {
                            vm.initApiError = error;
                            vm.initApiErrorStage = 'uploadTransaction';
                            console.log(error);
                        };

                        vm.offlineFdiReports = [];
                        try {
                            if (localFdirStore) {
                                localFdirStore.openCursor().onsuccess = function (event) {
                                    var cursor = event.target.result;

                                    if (cursor) {
                                        if (vm.offlineFdiReports) {
                                            vm.offlineFdiReports.push(cursor.value)
                                        }
                                        cursor.continue();
                                    }
                                };
                            }

                        } catch (e) {
                            vm.initApiError = e;
                            vm.initApiErrorStage = 'offlineFdiReports';
                            console.log(e);
                        }

                        vm.offlineFdirItems = [];
                        try {
                            if (localFdirItemsStore) {
                                localFdirItemsStore.openCursor().onsuccess = function (event) {
                                    var cursor = event.target.result;

                                    if (cursor) {
                                        if (vm.offlineFdirItems) {
                                            vm.offlineFdirItems.push(cursor.value)
                                        }
                                        cursor.continue();
                                    }
                                };
                            }

                        } catch (e) {
                            vm.initApiError = e;
                            vm.initApiErrorStage = 'offlineFdirItems';
                            console.log(e);
                            console.log(e);
                        }
                    });

                }
            },
            performActualFdiReportsSync() {
                console.log('Entered performActualFdiReportsSync()');
                var bitPerCentage = 20; 

                axios.post(this.cmsUrl + 'api/v1/door-installation-reports/add-reports.json?ver=' + this.appNumericVersion, this.offlineFdiReports, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                .then(response => {
                    return new Promise(async (resolve, reject) => { 
                        if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                            var vm = this;
                            response.data.data.forEach((report, index) => {
                                var archiveReport = vm.offlineFdiReports[index]['is_complete'] || vm.offlineFdiReports[index]['update_flag'] == 'REJECT';

                                if(report['status']) {
                                    vm.offlineFdiReports[index].report_version = report['report_version'];
                                } else if(report['reason'] == 'complete' || report['reason'] == 'deleted') {
                                    //We move reports marked on the server as complete or deleted to archive, so they're not sent to the server again
                                    archiveReport = true;
                                    vm.invalidateFdirItems(vm.offlineFdiReports[index].site_door_installation_report_id);
                                } else if(report['reason'] == 'validation' || report['reason'] == 'failed_to_duplicate_report') {
                                    var failMsg = 'Report #' + vm.offlineFdiReports[index].site_door_installation_report_id + ((vm.offlineFdiReports[index].job_number != null && vm.offlineFdiReports[index].job_number.length > 0) ? (' (' + vm.offlineFdiReports[index].job_number + ')') : '') + ' failed to sync because of validation error (serverside). Please contact Support Team';
                                    vm.fdirSyncErrors.push(failMsg);
                                    archiveReport = false;
                                }

                                if(archiveReport) {
                                    vm.fdiReportsToArchive.push(index);
                                }
                            });

                            await this.getDbNew().then(db => {
                                var transaction = db.transaction([
                                    'door_installation_reports',
                                    'door_installation_reports_archived'
                                ], 'readwrite');

                                var fdiReportsStore = transaction.objectStore('door_installation_reports');
                                var archivedFdiReportsStore= transaction.objectStore('door_installation_reports_archived');

                                transaction.oncomplete = function (event) {
                                    console.log('Completed updating versions / moving door reports to archive');
                                    if(!response.data.success) { 
                                        vm.showFdirSyncErrors = true;
                                        reject('Failed to sync door reports');
                                    } else {
                                        resolve();
                                    }
                                };

                                transaction.onerror = function (error) {
                                    reject(error);
                                };

                                vm.offlineFdiReports.forEach((report, index) => {
                                    if(vm.fdiReportsToArchive.includes(index)) {
                                        var archiveFdiReportRequest = archivedFdiReportsStore.put(report);
                                        archiveFdiReportRequest.onsuccess = function() {
                                            var reportIdToDelete = report['site_door_installation_report_id'];
                                            if(report['update_flag'] == 'SAVE_AS_NEW') {
                                                reportIdToDelete = report['old_site_door_installation_report_id'];
                                            }
                                            fdiReportsStore.delete(reportIdToDelete);
                                        };
                                    } else {
                                        var saveFdiReportRequest = fdiReportsStore.put(report);
                                        if(report['update_flag'] == 'SAVE_AS_NEW') {
                                            saveFdiReportRequest.onsuccess = function() {
                                                fdiReportsStore.delete(report['old_site_door_installation_report_id']);
                                            };
                                        }
                                    }
                                });
                            }).catch(e => {
                                reject(e);
                            });  
                            
                        } else {
                            resolve();
                        }
                    }).then(() => {
                        this.fdirConflicts = [];

                        this.isOfflineFdiReportsPosted = true;
                        // Sync add
                        this.syncFdirProgress = (this.syncFdirProgress + bitPerCentage);
                        return axios.post(this.cmsUrl + 'api/v1/door-installation-reports/add-report-items.json?ver=' + this.appNumericVersion, this.offlineFdirItems, {headers: {'Authorization': 'Bearer ' + this.userToken}});
                    }).then(response => {

                        return new Promise(async (resolve, reject) => { 
                            if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                                var vm = this;
                                vm.fdirSyncErrors = [];
                                response.data.data.forEach((door, index) => {
                                    var archiveReport = door['is_complete'] || vm.offlineFdirItems[index]['update_flag'] == 'REJECT';

                                    if(!door['status'] && door['reason'] == 'validation') {
                                        var failMsg = 'Door #' + vm.offlineFdirItems[index].site_door_installation_report_item_id + ((vm.offlineFdirItems[index].door_identifier != null && vm.offlineFdirItems[index].door_identifier.length > 0) ? (' (ID: ' + vm.offlineFdirItems[index].door_identifier + ')') : '') + ' failed to sync because of validation error (serverside). Please contact Support Team';
                                        vm.fdirSyncErrors.push(failMsg);
                                        archiveReport = false;
                                    }

                                    if(archiveReport) {
                                        vm.fdirItemsToArchive.push(index);
                                    }
                                });

                                await this.getDbNew().then(db => {

                                    var transaction = db.transaction([
                                        'door_installation_report_items',
                                        'door_installation_report_items_archived'
                                    ], 'readwrite');

                                    var fdirItemsStore = transaction.objectStore('door_installation_report_items');
                                    var archivedFdirItemsStore = transaction.objectStore('door_installation_report_items_archived');

                                    transaction.oncomplete = function (event) {
                                        if(!response.data.success) {
                                            vm.showFdirSyncErrors = true;
                                            reject('Failed to sync doors');
                                        } else {
                                            resolve();
                                        }
                                    };

                                    transaction.onerror = function (error) {
                                        reject(error);
                                    };

                                    vm.offlineFdirItems.forEach((door, index) => {
                                        var updateFlag = door['update_flag'];
                                        door['update_flag'] = null;
                                        if(vm.fdirItemsToArchive.includes(index)) {
                                            var archiveDoorRequest = archivedFdirItemsStore.put(door);
                                            archiveDoorRequest.onsuccess = function() {
                                                var reportIdToDelete = door['site_door_installation_report_item_id'];
                                                if(updateFlag == 'SAVE_AS_NEW') {
                                                    reportIdToDelete = door['old_site_door_installation_report_item_id'];
                                                }
                                                fdirItemsStore.delete(reportIdToDelete);
                                            };
                                        } else {
                                            var saveDoorRequest = fdirItemsStore.put(door);
                                            if(updateFlag == 'SAVE_AS_NEW') {
                                                saveDoorRequest.onsuccess = function() {
                                                    fdirItemsStore.delete(door['old_site_door_installation_report_item_id']);
                                                };
                                            }
                                        }
                                    });
                                }).catch(e => {
                                    reject(e);
                                });  
                                
                            } else {
                                resolve();
                            }
                        }).then(() => {
                            console.log('About to get workspace details from database');

                            this.isOfflineFdirItemsPosted = true;
                            // Sync add
                            this.syncFdirProgress = (this.syncFdirProgress + bitPerCentage);
                            return axios.get(this.cmsUrl + 'api/v1/workspace/details.json');
                        });    
                    });
                }).then(response => {
                    // Sync add
                    this.syncFdirProgress = (this.syncFdirProgress + bitPerCentage);
                    this.workspace = response.data.workspace;
                    this.isWorkspaceDetailsLoaded = true;
                    
                    return axios.get(this.cmsUrl + 'api/v1/workspace/additional-door-fields-options.json', {headers: {'Authorization': 'Bearer ' + this.userToken}});
                })
                .then(response => {
                    this.syncFdirProgress = (this.syncFdirProgress + bitPerCentage);
                    this.declared_resistance_levels = response.data.declared_resistance_levels;
                    this.isAdditionalDoorFieldsOptionsLoaded = true; 

                    return axios.post(this.cmsUrl + 'api/v1/door-installation-reports/incomplete.json', {}, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                })
                .then(response => {
                    // Sync add
                    this.syncFdirProgress = (this.syncFdirProgress + bitPerCentage);
                    this.isFdiReportsLoaded = true;
                    this.door_installation_reports = response.data.reports;
                    return axios.post(this.cmsUrl + 'api/v1/door-installation-reports/incomplete-items.json', {}, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                })
                .then(response => {
                    // Sync add
                    this.syncFdirProgress = (this.syncFdirProgress + bitPerCentage);
                    this.isFdirItemsLoaded = true;
                    this.door_installation_report_items = response.data.items;

                    var vmts = this;
                    this.getDb(function onConnectedSaveAllTheThings(db) {

                        var transaction = db.transaction([
                            'workspace_details',
                            'door_installation_reports',
                            'door_installation_report_items',
                            'declared_resistance_levels'
                        ], 'readwrite');

                        var workspaceDetailsStore = transaction.objectStore('workspace_details');
                        var fdiReportsStore = transaction.objectStore('door_installation_reports');
                        var fdirItemsStore = transaction.objectStore('door_installation_report_items');
                        var declaredResistanceLevelsStore = transaction.objectStore('declared_resistance_levels');

                        var vmt = vmts;
                        transaction.oncomplete = function (event) {
                            vmt.isFdirSyncComplete = true;
                            vmt.fdirSyncStarted = false;
                            vmt.syncsOpen = false;
                            vmt.initApi = true;
                            vmt.$session.set('has_done_full_sync', true);
                            vmt.$session.set('fdir_last_sync', new Date());
                            vmt.hasDoneFullSync = true;
                            window.setTimeout(vmt.reload, 5000);
                        };

                        transaction.onerror = function (error) {
                            console.log('Transaction failed');
                            console.log(error);
                            vmt.syncErrorDetails = error;
                            vmt.isFdirSyncComplete = true;
                            vmt.fdirSyncStarted = false;
                            vmt.syncError = true;
                        };

                        try {
                            var putWDRequest = workspaceDetailsStore.put({
                                workspace_id: vmt.workspace.workspace_id,
                                primary_colour: vmt.workspace.primary_colour,
                                primary_color_hover: vmt.workspace.primary_colour_hover,
                                secondary_colour: vmt.workspace.secondary_colour,
                                secondary_colour_hover: vmt.workspace.secondary_colour_hover,
                                workspace_name: vmt.workspace.workspace_name,
                                workspace_logo: vmt.workspace.workspace_logo,
                                workspace_favicon: vmt.workspace.workspace_favicon,
                                last_updated: new Date(),
                                risk_audit_last_updated: vmt.workspace.risk_audit_last_updated,
                                has_access_to_fire_door_audit: vmt.workspace.has_access_to_fire_door_audit,
                                has_access_to_risk_audit: vmt.workspace.has_access_to_risk_audit,
                                has_access_to_extinguisher_report: vmt.workspace.has_access_to_extinguisher_report,
                                has_access_to_fire_stopping_report: vmt.workspace.has_access_to_fire_stopping_report,
                                has_access_to_bae_system_report: vmt.workspace.has_access_to_bae_system_report,
                                has_access_to_door_installation_report: vmt.workspace.has_access_to_door_installation_report,
                                has_access_to_door_maintenance_report: vmt.workspace.has_access_to_door_maintenance_report
                            });
                            putWDRequest.onsuccess = function () {
                                vmt.isWorkspaceDetailsAdded = true;
                                // Sync add
                                vmt.syncFdirProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApi = false;
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPWorkspaceDetails';

                            console.log('Workspace deets failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fdirSyncStarted = false;
                        }

                        try {
                            if (vmt.door_installation_reports.length === 0) {
                                vmt.isFdiReportsZeroLength = true;
                                vmt.syncFdirProgress += bitPerCentage;
                            } else {
                                for (var i in vmt.door_installation_reports) {
                                    var putFdiReportRequest = fdiReportsStore.put({
                                        door_installation_report_id: parseInt(vmt.door_installation_reports[i]['door_installation_report_id']),
                                        site_door_installation_report_id: parseInt(vmt.door_installation_reports[i]['site_door_installation_report_id']),
                                        sequential_reference_number: vmt.door_installation_reports[i]['sequential_reference_number'],
                                        job_number: vmt.door_installation_reports[i]['job_number'],
                                        date_of_issue: vmt.door_installation_reports[i]['date_of_issue'],
                                        prepared_for: vmt.door_installation_reports[i]['prepared_for'],
                                        site_address: vmt.door_installation_reports[i]['site_address'],
                                        use_bm_trada_template: vmt.door_installation_reports[i]['use_bm_trada_template'],
                                        pdf_link: vmt.door_installation_reports[i]['pdf_link'],
                                        report_version: vmt.door_installation_reports[i]['report_version']
                                    });
                                }
                                putFdiReportRequest.onsuccess = function () {
                                    vmt.isFdiReportsAdded = true;
                                    vmt.syncFdirProgress += bitPerCentage;
                                }
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPFdiReportsImport';

                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fdirSyncStarted = false;
                        }

                        try {
                            if (vmt.door_installation_report_items === null || vmt.door_installation_report_items === undefined || vmt.door_installation_report_items.length === 0) {
                                vmt.isFdirItemsZeroLength = true;
                                vmt.syncFdirProgress += bitPerCentage;
                            } else {
                                for (var i in vmt.door_installation_report_items) {
                                    var putFdirItemRequest = fdirItemsStore.put({
                                        door_installation_report_item_id: parseInt(vmt.door_installation_report_items[i]['door_installation_report_item_id']),
                                        site_door_installation_report_item_id: parseInt(vmt.door_installation_report_items[i]['site_door_installation_report_item_id']),
                                        door_installation_report_id: parseInt(vmt.door_installation_report_items[i]['door_installation_report_id']),
                                        site_door_installation_report_id: parseInt(vmt.door_installation_report_items[i]['site_door_installation_report_id']),
                                        door_identifier: vmt.door_installation_report_items[i]['door_identifier'],
                                        door_location: vmt.door_installation_report_items[i]['door_location'],
                                        intended_fire_resistance_period: vmt.door_installation_report_items[i]['intended_fire_resistance_period'],
                                        installation_date: vmt.door_installation_report_items[i]['installation_date'],
                                        installed_by: vmt.door_installation_report_items[i]['installed_by'],
                                        is_silver_core_plug_fitted: vmt.door_installation_report_items[i]['is_silver_core_plug_fitted'],
                                        is_installer_plug_label_fitted: vmt.door_installation_report_items[i]['is_installer_plug_label_fitted'],
                                        installation_guidance_used: vmt.door_installation_report_items[i]['installation_guidance_used'],
                                        comments: vmt.door_installation_report_items[i]['comments'],
                                        user_id: vmt.door_installation_report_items[i]['user_id'],
                                        door_installation_report_item_images: vmt.door_installation_report_items[i]['door_installation_report_item_images'],
                                        offline_images: []
                                    });
                                }
                                putFdirItemRequest.onsuccess = function () {
                                    vmt.isFdirItemsAdded = true;
                                    vmt.syncFdirProgress += bitPerCentage;
                                }
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'FdirItemsImport';

                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fdirSyncStarted = false;
                        }

                        try {
                            if (vmt.declared_resistance_levels !== undefined && vmt.declared_resistance_levels.length > 0) {
                                for (var i in vmt.declared_resistance_levels) {
                                    var putRequest = declaredResistanceLevelsStore.put({
                                        declared_resistance_level_id: vmt.declared_resistance_levels[i]['declared_resistance_level_id'],
                                        declared_resistance_level_title: vmt.declared_resistance_levels[i]['declared_resistance_level_title'],
                                    });
                                }
                                putRequest.onsuccess = function () {
                                    vmt.isDeclaredResistanceLevelsAdded = true;
                                }
                            }
                            // Sync add
                            vmt.syncFdirProgress += bitPerCentage;
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'DeclaredResistanceLevels';

                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fdirSyncStarted = false;
                        }

                    });
                }).catch(error => {
                    console.log('Axios failed?');
                    console.log(error);
                    this.syncErrorDetails = error;
                    this.isFdirSyncComplete = true;
                    this.syncError = true;
                    this.fdirSyncStarted = false;

                    this.initApiError = error;
                    this.initApiErrorStage = 'axios';
                });
            },
            continueFdiReportsSyncProcess(event) {
                event.preventDefault();
                if(this.submittedFdirConflictForm) {
                    return;
                }

                this.submittedFdirConflictForm = true;
                
                this.offlineFdiReports.forEach((report, index, array) => {
                    if(report.update_flag == 'SAVE_AS_NEW') {
                        array[index].old_site_door_installation_report_id = report.site_door_installation_report_id;
                        array[index].site_door_installation_report_id = Math.floor(new Date().getTime() / 1000)  + index;
                        array[index].job_number += ' #' + array[index].site_door_installation_report_id;
                    }

                    this.offlineFdirItems.forEach((door, doorIndex, doorsArray) => {
                        if((report.update_flag == 'SAVE_AS_NEW' && array[index].old_site_door_installation_report_id == door.site_door_installation_report_id) ||
                        (report.update_flag != 'SAVE_AS_NEW' && report.site_door_installation_report_id == door.site_door_installation_report_id)) {
                            doorsArray[doorIndex].update_flag = report.update_flag;
                            if(report.update_flag == 'SAVE_AS_NEW') {
                                doorsArray[doorIndex].site_door_installation_report_id = array[index].site_door_installation_report_id;
                                doorsArray[doorIndex].old_site_door_installation_report_item_id = door.site_door_installation_report_item_id;
                                doorsArray[doorIndex].site_door_installation_report_item_id = Math.floor(new Date().getTime() / 1000) + index + doorIndex;     
                            }
                        }
                    });
                });

                this.performActualFdiReportsSync();
            },
            hideFdiReportsSyncErrors() {
                this.showFdirSyncErrors = false;
            },
            invalidateFdirItems(site_door_installation_report_id) {
                this.offlineFdirItems.forEach((door, doorIndex, doorsArray) => {
                    if(door.site_door_installation_report_id == site_door_installation_report_id) {
                        doorsArray[doorIndex].report_ignored = true;
                    }
                });
            },
            syncFdmReports(inBg) {
                if (navigator.onLine && !this.fdmrSyncStarted) {

                    this.syncErrorDetails = null;
                    this.syncError = false;
                    this.fdmrSyncStarted = true;
                    this.isFdmrSyncComplete = false;
                    this.isFdmrSyncing = inBg !== true;
                    this.isFdmrSyncingInBg = inBg === true;
                    this.syncFdmrProgress = 0;

                    this.isWorkspaceDetailsLoaded = false;
                    this.isWorkspaceDetailsAdded = false;
                    this.isAdditionalDoorFieldsOptionsLoaded = false;
                    this.isDeclaredResistanceLevelsAdded = false;
                    this.isFdmReportsLoaded = false;
                    this.isFdmReportsAdded = false;
                    this.isFdmrItemsLoaded = false;
                    this.isFdmrItemsAdded = false;
                    this.isOfflineFdmReportsPosted = false;
                    this.isOfflineFdmrItemsPosted = false;

                    this.isOfflineFdmrItemsZeroLength = false;
                    this.isOfflineFdmReportsZeroLength = false;
                    this.showFdmrSyncErrors = false;
                    this.submittedFdmrConflictForm = false;
                    this.fdmrConflicts = [];
                    this.fdmrSyncErrors = [];
                    this.fdmReportsToArchive = [];
                    this.fdmrItemsToArchive = [];

                    var vm = this;
                    this.getDb(function onConnected(db) {
                        vm.initDb = true;

                        var uploadTransaction = db.transaction([
                            'door_maintenance_reports',
                            'door_maintenance_report_items',
                        ]);

                        var localFdmrStore = uploadTransaction.objectStore('door_maintenance_reports');
                        var localFdmrItemsStore = uploadTransaction.objectStore('door_maintenance_report_items');

                        vm.getUserToken();

                        uploadTransaction.oncomplete = function (event) {
                            if (vm.offlineFdmrItems.length === 0) {
                                vm.isOfflineFdmrItemsZeroLength = true;
                            }

                            if (vm.offlineFdmReports.length === 0) {
                                vm.isOfflineFdmReportsZeroLength = true;
                                vm.performActualFdmReportsSync();
                            } else {
                                var reportsVersions = [];
                                vm.offlineFdmReports.forEach(report => {
                                    var reportVersion = null;
                                    if(report.hasOwnProperty('report_version')) {
                                        reportVersion = report.report_version;
                                    }
                                    reportsVersions.push({
                                        'site_door_maintenance_report_id': report.site_door_maintenance_report_id,
                                        'report_version': reportVersion
                                    });
                                });

                                axios.post(vm.cmsUrl + 'api/v1/door-maintenance-reports/check-versions.json', reportsVersions, {headers: {'Authorization': 'Bearer ' + vm.userToken}})
                                .then(response => {
                                    if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                                        response.data.data.forEach((report, index) => {
                                            var localReportVersion = reportsVersions[index]['report_version'];
                                            var remoteReportVersion = report['report_version'];

                                            vm.offlineFdmReports[index].update_flag = 'OVERWRITE';

                                            if(remoteReportVersion != null && localReportVersion != remoteReportVersion) {
                                                vm.offlineFdmReports[index].remote_report_version = remoteReportVersion;
                                                vm.fdmrConflicts.push(index);
                                            }
                                        });

                                        console.log('Number of FDM Reports to sync: ' + vm.fdmrConflicts.length)

                                        if(vm.fdmrConflicts.length == 0) {
                                            vm.performActualFdmReportsSync();
                                        }
                                    } else {
                                        console.log('Server returned invalid response while verifying versions of reports');
                                        throw 'Server returned invalid response while verifying versions of reports';
                                    }
                                })
                                .catch(e => {
                                    console.log('Catched error: ' + e);
                                    vm.syncErrorDetails = e;
                                    vm.isFdmrSyncComplete = true;
                                    vm.fdmrSyncStarted = false;
                                    vm.syncError = true;
                                });
                            }
                        };

                        uploadTransaction.onerror = function (error) {
                            vm.initApiError = error;
                            vm.initApiErrorStage = 'uploadTransaction';
                            console.log(error);
                        };

                        vm.offlineFdmReports = [];
                        try {
                            if (localFdmrStore) {
                                localFdmrStore.openCursor().onsuccess = function (event) {
                                    var cursor = event.target.result;

                                    if (cursor) {
                                        if (vm.offlineFdmReports) {
                                            vm.offlineFdmReports.push(cursor.value)
                                        }
                                        cursor.continue();
                                    }
                                };
                            }

                        } catch (e) {
                            vm.initApiError = e;
                            vm.initApiErrorStage = 'offlineFdmReports';
                            console.log(e);
                        }

                        vm.offlineFdmrItems = [];
                        try {
                            if (localFdmrItemsStore) {
                                localFdmrItemsStore.openCursor().onsuccess = function (event) {
                                    var cursor = event.target.result;

                                    if (cursor) {
                                        if (vm.offlineFdmrItems) {
                                            vm.offlineFdmrItems.push(cursor.value)
                                        }
                                        cursor.continue();
                                    }
                                };
                            }

                        } catch (e) {
                            vm.initApiError = e;
                            vm.initApiErrorStage = 'offlineFdmrItems';
                            console.log(e);
                            console.log(e);
                        }
                    });

                }
            },
            performActualFdmReportsSync() {
                console.log('Entered performActualFdmReportsSync()');
                var bitPerCentage = 20; 

                axios.post(this.cmsUrl + 'api/v1/door-maintenance-reports/add-reports.json?ver=' + this.appNumericVersion, this.offlineFdmReports, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                .then(response => {
                    return new Promise(async (resolve, reject) => { 
                        if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                            var vm = this;
                            response.data.data.forEach((report, index) => {
                                var archiveReport = vm.offlineFdmReports[index]['is_complete'] || vm.offlineFdmReports[index]['update_flag'] == 'REJECT';

                                if(report['status']) {
                                    vm.offlineFdmReports[index].report_version = report['report_version'];
                                } else if(report['reason'] == 'complete' || report['reason'] == 'deleted') {
                                    //We move reports marked on the server as complete or deleted to archive, so they're not sent to the server again
                                    archiveReport = true;
                                    vm.invalidateFdmrItems(vm.offlineFdmReports[index].site_door_maintenance_report_id);
                                } else if(report['reason'] == 'validation' || report['reason'] == 'failed_to_duplicate_report') {
                                    var failMsg = 'Report #' + vm.offlineFdmReports[index].site_door_maintenance_report_id + ((vm.offlineFdmReports[index].job_number != null && vm.offlineFdmReports[index].job_number.length > 0) ? (' (' + vm.offlineFdmReports[index].job_number + ')') : '') + ' failed to sync because of validation error (serverside). Please contact Support Team';
                                    vm.fdmrSyncErrors.push(failMsg);
                                    archiveReport = false;
                                }

                                if(archiveReport) {
                                    vm.fdmReportsToArchive.push(index);
                                }
                            });

                            await this.getDbNew().then(db => {
                                var transaction = db.transaction([
                                    'door_maintenance_reports',
                                    'door_maintenance_reports_archived'
                                ], 'readwrite');

                                var fdmReportsStore = transaction.objectStore('door_maintenance_reports');
                                var archivedFdmReportsStore= transaction.objectStore('door_maintenance_reports_archived');

                                transaction.oncomplete = function (event) {
                                    console.log('Completed updating versions / moving door reports to archive');
                                    if(!response.data.success) { 
                                        vm.showFdmrSyncErrors = true;
                                        reject('Failed to sync door reports');
                                    } else {
                                        resolve();
                                    }
                                };

                                transaction.onerror = function (error) {
                                    reject(error);
                                };

                                vm.offlineFdmReports.forEach((report, index) => {
                                    if(vm.fdmReportsToArchive.includes(index)) {
                                        var archiveFdmReportRequest = archivedFdmReportsStore.put(report);
                                        archiveFdmReportRequest.onsuccess = function() {
                                            var reportIdToDelete = report['site_door_maintenance_report_id'];
                                            if(report['update_flag'] == 'SAVE_AS_NEW') {
                                                reportIdToDelete = report['old_site_door_maintenance_report_id'];
                                            }
                                            fdmReportsStore.delete(reportIdToDelete);
                                        };
                                    } else {
                                        var saveFdmReportRequest = fdmReportsStore.put(report);
                                        if(report['update_flag'] == 'SAVE_AS_NEW') {
                                            saveFdmReportRequest.onsuccess = function() {
                                                fdmReportsStore.delete(report['old_site_door_maintenance_report_id']);
                                            };
                                        }
                                    }
                                });
                            }).catch(e => {
                                reject(e);
                            });  
                            
                        } else {
                            resolve();
                        }
                    }).then(() => {
                        this.fdmrConflicts = [];

                        this.isOfflineFdmReportsPosted = true;
                        // Sync add
                        this.syncFdmrProgress = (this.syncFdmrProgress + bitPerCentage);
                        return axios.post(this.cmsUrl + 'api/v1/door-maintenance-reports/add-report-items.json?ver=' + this.appNumericVersion, this.offlineFdmrItems, {headers: {'Authorization': 'Bearer ' + this.userToken}});
                    }).then(response => {

                        return new Promise(async (resolve, reject) => { 
                            if(response.data.hasOwnProperty('data') && response.data.data.length > 0) {
                                var vm = this;
                                vm.fdmrSyncErrors = [];
                                response.data.data.forEach((door, index) => {
                                    var archiveReport = door['is_complete'] || vm.offlineFdmrItems[index]['update_flag'] == 'REJECT';

                                    if(!door['status'] && door['reason'] == 'validation') {
                                        var failMsg = 'Door #' + vm.offlineFdmrItems[index].site_door_maintenance_report_item_id + ((vm.offlineFdmrItems[index].door_identifier != null && vm.offlineFdmrItems[index].door_identifier.length > 0) ? (' (ID: ' + vm.offlineFdmrItems[index].door_identifier + ')') : '') + ' failed to sync because of validation error (serverside). Please contact Support Team';
                                        vm.fdmrSyncErrors.push(failMsg);
                                        archiveReport = false;
                                    }

                                    if(archiveReport) {
                                        vm.fdmrItemsToArchive.push(index);
                                    }
                                });

                                await this.getDbNew().then(db => {

                                    var transaction = db.transaction([
                                        'door_maintenance_report_items',
                                        'door_maintenance_report_items_archived'
                                    ], 'readwrite');

                                    var fdmrItemsStore = transaction.objectStore('door_maintenance_report_items');
                                    var archivedFdmrItemsStore = transaction.objectStore('door_maintenance_report_items_archived');

                                    transaction.oncomplete = function (event) {
                                        if(!response.data.success) {
                                            vm.showFdmrSyncErrors = true;
                                            reject('Failed to sync doors');
                                        } else {
                                            resolve();
                                        }
                                    };

                                    transaction.onerror = function (error) {
                                        reject(error);
                                    };

                                    vm.offlineFdmrItems.forEach((door, index) => {
                                        var updateFlag = door['update_flag'];
                                        door['update_flag'] = null;
                                        if(vm.fdmrItemsToArchive.includes(index)) {
                                            var archiveDoorRequest = archivedFdmrItemsStore.put(door);
                                            archiveDoorRequest.onsuccess = function() {
                                                var reportIdToDelete = door['site_door_maintenance_report_item_id'];
                                                if(updateFlag == 'SAVE_AS_NEW') {
                                                    reportIdToDelete = door['old_site_door_maintenance_report_item_id'];
                                                }
                                                fdmrItemsStore.delete(reportIdToDelete);
                                            };
                                        } else {
                                            var saveDoorRequest = fdmrItemsStore.put(door);
                                            if(updateFlag == 'SAVE_AS_NEW') {
                                                saveDoorRequest.onsuccess = function() {
                                                    fdmrItemsStore.delete(door['old_site_door_maintenance_report_item_id']);
                                                };
                                            }
                                        }
                                    });
                                }).catch(e => {
                                    reject(e);
                                });  
                                
                            } else {
                                resolve();
                            }
                        }).then(() => {
                            console.log('About to get workspace details from database');

                            this.isOfflineFdmrItemsPosted = true;
                            // Sync add
                            this.syncFdmrProgress = (this.syncFdmrProgress + bitPerCentage);
                            return axios.get(this.cmsUrl + 'api/v1/workspace/details.json');
                        });    
                    });
                }).then(response => {
                    // Sync add
                    this.syncFdmrProgress = (this.syncFdmrProgress + bitPerCentage);
                    this.workspace = response.data.workspace;
                    this.isWorkspaceDetailsLoaded = true;
                    
                    return axios.get(this.cmsUrl + 'api/v1/workspace/additional-door-fields-options.json', {headers: {'Authorization': 'Bearer ' + this.userToken}});
                })
                .then(response => {
                    this.syncFdmrProgress = (this.syncFdmrProgress + bitPerCentage);
                    this.declared_resistance_levels = response.data.declared_resistance_levels;
                    this.isAdditionalDoorFieldsOptionsLoaded = true; 

                    return axios.post(this.cmsUrl + 'api/v1/door-maintenance-reports/incomplete.json', {}, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                })
                .then(response => {
                    // Sync add
                    this.syncFdmrProgress = (this.syncFdmrProgress + bitPerCentage);
                    this.isFdmReportsLoaded = true;
                    this.door_maintenance_reports = response.data.reports;
                    return axios.post(this.cmsUrl + 'api/v1/door-maintenance-reports/incomplete-items.json', {}, {headers: {'Authorization': 'Bearer ' + this.userToken}})
                })
                .then(response => {
                    // Sync add
                    this.syncFdmrProgress = (this.syncFdmrProgress + bitPerCentage);
                    this.isFdmrItemsLoaded = true;
                    this.door_maintenance_report_items = response.data.items;

                    var vmts = this;
                    this.getDb(function onConnectedSaveAllTheThings(db) {

                        var transaction = db.transaction([
                            'workspace_details',
                            'door_maintenance_reports',
                            'door_maintenance_report_items',
                            'declared_resistance_levels'
                        ], 'readwrite');

                        var workspaceDetailsStore = transaction.objectStore('workspace_details');
                        var fdmReportsStore = transaction.objectStore('door_maintenance_reports');
                        var fdmrItemsStore = transaction.objectStore('door_maintenance_report_items');
                        var declaredResistanceLevelsStore = transaction.objectStore('declared_resistance_levels');

                        var vmt = vmts;
                        transaction.oncomplete = function (event) {
                            vmt.isFdmrSyncComplete = true;
                            vmt.fdmrSyncStarted = false;
                            vmt.syncsOpen = false;
                            vmt.initApi = true;
                            vmt.$session.set('has_done_full_sync', true);
                            vmt.$session.set('fdmr_last_sync', new Date());
                            vmt.hasDoneFullSync = true;
                            window.setTimeout(vmt.reload, 5000);
                        };

                        transaction.onerror = function (error) {
                            console.log('Transaction failed');
                            console.log(error);
                            vmt.syncErrorDetails = error;
                            vmt.isFdmrSyncComplete = true;
                            vmt.fdmrSyncStarted = false;
                            vmt.syncError = true;
                        };

                        try {
                            var putWDRequest = workspaceDetailsStore.put({
                                workspace_id: vmt.workspace.workspace_id,
                                primary_colour: vmt.workspace.primary_colour,
                                primary_color_hover: vmt.workspace.primary_colour_hover,
                                secondary_colour: vmt.workspace.secondary_colour,
                                secondary_colour_hover: vmt.workspace.secondary_colour_hover,
                                workspace_name: vmt.workspace.workspace_name,
                                workspace_logo: vmt.workspace.workspace_logo,
                                workspace_favicon: vmt.workspace.workspace_favicon,
                                last_updated: new Date(),
                                risk_audit_last_updated: vmt.workspace.risk_audit_last_updated,
                                has_access_to_fire_door_audit: vmt.workspace.has_access_to_fire_door_audit,
                                has_access_to_risk_audit: vmt.workspace.has_access_to_risk_audit,
                                has_access_to_extinguisher_report: vmt.workspace.has_access_to_extinguisher_report,
                                has_access_to_fire_stopping_report: vmt.workspace.has_access_to_fire_stopping_report,
                                has_access_to_bae_system_report: vmt.workspace.has_access_to_bae_system_report,
                                has_access_to_door_installation_report: vmt.workspace.has_access_to_door_installation_report,
                                has_access_to_door_maintenance_report: vmt.workspace.has_access_to_door_maintenance_report
                            });
                            putWDRequest.onsuccess = function () {
                                vmt.isWorkspaceDetailsAdded = true;
                                // Sync add
                                vmt.syncFdmrProgress += bitPerCentage;
                            }
                        } catch (e) {
                            vmt.initApi = false;
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPWorkspaceDetails';

                            console.log('Workspace deets failed');
                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fdmrSyncStarted = false;
                        }

                        try {
                            if (vmt.door_maintenance_reports.length === 0) {
                                vmt.isFdmReportsZeroLength = true;
                                vmt.syncFdmrProgress += bitPerCentage;
                            } else {
                                for (var i in vmt.door_maintenance_reports) {
                                    var putFdmReportRequest = fdmReportsStore.put({
                                        door_maintenance_report_id: parseInt(vmt.door_maintenance_reports[i]['door_maintenance_report_id']),
                                        site_door_maintenance_report_id: parseInt(vmt.door_maintenance_reports[i]['site_door_maintenance_report_id']),
                                        sequential_reference_number: vmt.door_maintenance_reports[i]['sequential_reference_number'],
                                        job_number: vmt.door_maintenance_reports[i]['job_number'],
                                        date_of_issue: vmt.door_maintenance_reports[i]['date_of_issue'],
                                        prepared_for: vmt.door_maintenance_reports[i]['prepared_for'],
                                        site_address: vmt.door_maintenance_reports[i]['site_address'],
                                        use_bm_trada_template: vmt.door_maintenance_reports[i]['use_bm_trada_template'],
                                        pdf_link: vmt.door_maintenance_reports[i]['pdf_link'],
                                        report_version: vmt.door_maintenance_reports[i]['report_version']
                                    });
                                }
                                putFdmReportRequest.onsuccess = function () {
                                    vmt.isFdmReportsAdded = true;
                                    vmt.syncFdmrProgress += bitPerCentage;
                                }
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'IMPFdmReportsImport';

                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fdmrSyncStarted = false;
                        }

                        try {
                            if (vmt.door_maintenance_report_items === null || vmt.door_maintenance_report_items === undefined || vmt.door_maintenance_report_items.length === 0) {
                                vmt.isFdmrItemsZeroLength = true;
                                vmt.syncFdmrProgress += bitPerCentage;
                            } else {
                                for (var i in vmt.door_maintenance_report_items) {
                                    var putFdmrItemRequest = fdmrItemsStore.put({
                                        door_maintenance_report_item_id: parseInt(vmt.door_maintenance_report_items[i]['door_maintenance_report_item_id']),
                                        site_door_maintenance_report_item_id: parseInt(vmt.door_maintenance_report_items[i]['site_door_maintenance_report_item_id']),
                                        door_maintenance_report_id: parseInt(vmt.door_maintenance_report_items[i]['door_maintenance_report_id']),
                                        site_door_maintenance_report_id: parseInt(vmt.door_maintenance_report_items[i]['site_door_maintenance_report_id']),
                                        door_identifier: vmt.door_maintenance_report_items[i]['door_identifier'],
                                        door_location: vmt.door_maintenance_report_items[i]['door_location'],
                                        declared_fire_resistance_period: vmt.door_maintenance_report_items[i]['declared_fire_resistance_period'],
                                        maintenance_date: vmt.door_maintenance_report_items[i]['maintenance_date'],
                                        next_maintenance_due_date: vmt.door_maintenance_report_items[i]['next_maintenance_due_date'],
                                        maintained_by: vmt.door_maintenance_report_items[i]['maintained_by'],
                                        arts_carried_out: vmt.door_maintenance_report_items[i]['arts_carried_out'],
                                        maintenance_label_fitted: vmt.door_maintenance_report_items[i]['maintenance_label_fitted'],
                                        comments: vmt.door_maintenance_report_items[i]['comments'],
                                        door_maintenance_report_item_images: vmt.door_maintenance_report_items[i]['door_maintenance_report_item_images'],
                                        offline_images: []
                                    });
                                }
                                putFdmrItemRequest.onsuccess = function () {
                                    vmt.isFdmrItemsAdded = true;
                                    vmt.syncFdmrProgress += bitPerCentage;
                                }
                            }
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'FdmrItemsImport';

                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fdmrSyncStarted = false;
                        }

                        try {
                            if (vmt.declared_resistance_levels !== undefined && vmt.declared_resistance_levels.length > 0) {
                                for (var i in vmt.declared_resistance_levels) {
                                    var putRequest = declaredResistanceLevelsStore.put({
                                        declared_resistance_level_id: vmt.declared_resistance_levels[i]['declared_resistance_level_id'],
                                        declared_resistance_level_title: vmt.declared_resistance_levels[i]['declared_resistance_level_title'],
                                    });
                                }
                                putRequest.onsuccess = function () {
                                    vmt.isDeclaredResistanceLevelsAdded = true;
                                }
                            }
                            // Sync add
                            vmt.syncFdmrProgress += bitPerCentage;
                        } catch (e) {
                            vmt.initApiError = e;
                            vmt.initApiErrorStage = 'DeclaredResistanceLevels';

                            console.log(e);
                            vmt.syncErrorDetails = e;
                            vmt.syncError = true;
                            vmt.fdmrSyncStarted = false;
                        }

                    });
                }).catch(error => {
                    console.log('Axios failed?');
                    console.log(error);
                    this.syncErrorDetails = error;
                    this.isFdmrSyncComplete = true;
                    this.syncError = true;
                    this.fdmrSyncStarted = false;

                    this.initApiError = error;
                    this.initApiErrorStage = 'axios';
                });
            },
            continueFdmReportsSyncProcess(event) {
                event.preventDefault();
                if(this.submittedFdmrConflictForm) {
                    return;
                }

                this.submittedFdmrConflictForm = true;
                
                this.offlineFdmReports.forEach((report, index, array) => {
                    if(report.update_flag == 'SAVE_AS_NEW') {
                        array[index].old_site_door_maintenance_report_id = report.site_door_maintenance_report_id;
                        array[index].site_door_maintenance_report_id = Math.floor(new Date().getTime() / 1000)  + index;
                        array[index].job_number += ' #' + array[index].site_door_maintenance_report_id;
                    }

                    this.offlineFdmrItems.forEach((door, doorIndex, doorsArray) => {
                        if((report.update_flag == 'SAVE_AS_NEW' && array[index].old_site_door_maintenance_report_id == door.site_door_maintenance_report_id) ||
                        (report.update_flag != 'SAVE_AS_NEW' && report.site_door_maintenance_report_id == door.site_door_maintenance_report_id)) {
                            doorsArray[doorIndex].update_flag = report.update_flag;
                            if(report.update_flag == 'SAVE_AS_NEW') {
                                doorsArray[doorIndex].site_door_maintenance_report_id = array[index].site_door_maintenance_report_id;
                                doorsArray[doorIndex].old_site_door_maintenance_report_item_id = door.site_door_maintenance_report_item_id;
                                doorsArray[doorIndex].site_door_maintenance_report_item_id = Math.floor(new Date().getTime() / 1000) + index + doorIndex;    
                            }
                        }
                    });
                });

                this.performActualFdmReportsSync();
            },
            hideFdmReportsSyncErrors() {
                this.showFdmrSyncErrors = false;
            },
            invalidateFdmrItems(site_door_maintenance_report_id) {
                this.offlineFdmrItems.forEach((door, doorIndex, doorsArray) => {
                    if(door.site_door_maintenance_report_id == site_door_maintenance_report_id) {
                        doorsArray[doorIndex].report_ignored = true;
                    }
                });
            },
            syncWithServer(inBg) {
                this.syncDoorApps(inBg)
            },
            reload() {
                this.isSyncing = false;
                this.isRasSyncing = false;
                this.isErSyncing = false;
                this.isFsrSyncing = false;
                this.isBsrSyncing = false;
                this.isFdirSyncing = false;
            },
            reloadPage() {
                window.location.reload()
            },
            getWorkspaceDetails() {
                var vmt = this;
                this.getDb(function onConnected(db) {
                    try {
                        var objectStore = db.transaction('workspace_details').objectStore('workspace_details');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vmt.workspace) {
                                        vmt.workspace = {
                                            workspace_details_id: cursor.key,
                                            primary_colour: cursor.value.primary_colour,
                                            primary_color_hover: cursor.value.primary_color_hover,
                                            secondary_color: cursor.value.secondary_color,
                                            secondary_color_hover: cursor.value.secondary_color_hover,
                                            workspace_name: cursor.value.workspace_name,
                                            workspace_logo: cursor.value.workspace_logo,
                                            workspace_favicon: cursor.value.workspace_favicon,
                                            has_access_to_fire_door_audit: cursor.value.has_access_to_fire_door_audit,
                                            has_access_to_risk_audit: cursor.value.has_access_to_risk_audit,
                                            has_access_to_extinguisher_report: cursor.value.has_access_to_extinguisher_report,
                                            has_access_to_fire_stopping_report: cursor.value.has_access_to_fire_stopping_report,
                                            has_access_to_bae_system_report: cursor.value.has_access_to_bae_system_report,
                                            has_access_to_door_installation_report: cursor.value.has_access_to_door_installation_report,
                                            has_access_to_door_maintenance_report: cursor.value.has_access_to_door_maintenance_report
                                        };
                                    }
                                    cursor.continue();
                                }
                                
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
        }
    }
</script>
